(function (root, factory) {
  if (typeof define === 'function' && define.amd)
    define(['exports', './kotlin-kotlin-stdlib.js', './korge-root-korlibs-concurrent.js'], factory);
  else if (typeof exports === 'object')
    factory(module.exports, require('./kotlin-kotlin-stdlib.js'), require('./korge-root-korlibs-concurrent.js'));
  else {
    if (typeof this['kotlin-kotlin-stdlib'] === 'undefined') {
      throw new Error("Error loading module 'korge-root-korlibs-datastructure'. Its dependency 'kotlin-kotlin-stdlib' was not found. Please, check whether 'kotlin-kotlin-stdlib' is loaded prior to 'korge-root-korlibs-datastructure'.");
    }
    if (typeof this['korge-root-korlibs-concurrent'] === 'undefined') {
      throw new Error("Error loading module 'korge-root-korlibs-datastructure'. Its dependency 'korge-root-korlibs-concurrent' was not found. Please, check whether 'korge-root-korlibs-concurrent' is loaded prior to 'korge-root-korlibs-datastructure'.");
    }
    root['korge-root-korlibs-datastructure'] = factory(typeof this['korge-root-korlibs-datastructure'] === 'undefined' ? {} : this['korge-root-korlibs-datastructure'], this['kotlin-kotlin-stdlib'], this['korge-root-korlibs-concurrent']);
  }
}(this, function (_, kotlin_kotlin, kotlin_com_soywiz_korge_korlibs_concurrent) {
  'use strict';
  //region block: imports
  var imul = Math.imul;
  var log2 = Math.log2;
  var protoOf = kotlin_kotlin.$_$.uc;
  var objectMeta = kotlin_kotlin.$_$.tc;
  var setMetadataFor = kotlin_kotlin.$_$.vc;
  var Unit_instance = kotlin_kotlin.$_$.a5;
  var THROW_CCE = kotlin_kotlin.$_$.qg;
  var contentEquals = kotlin_kotlin.$_$.h6;
  var contentHashCode = kotlin_kotlin.$_$.i6;
  var intArrayIterator = kotlin_kotlin.$_$.vb;
  var classMeta = kotlin_kotlin.$_$.jb;
  var VOID = kotlin_kotlin.$_$.f;
  var contentEquals_0 = kotlin_kotlin.$_$.f6;
  var contentHashCode_0 = kotlin_kotlin.$_$.l6;
  var floatArrayIterator = kotlin_kotlin.$_$.ob;
  var toString = kotlin_kotlin.$_$.zc;
  var IllegalStateException_init_$Create$ = kotlin_kotlin.$_$.t1;
  var reverse = kotlin_kotlin.$_$.x8;
  var objectCreate = kotlin_kotlin.$_$.sc;
  var copyOf = kotlin_kotlin.$_$.u6;
  var isDoubleArray = kotlin_kotlin.$_$.dc;
  var IndexOutOfBoundsException_init_$Create$ = kotlin_kotlin.$_$.v1;
  var take = kotlin_kotlin.$_$.h9;
  var equals = kotlin_kotlin.$_$.lb;
  var List = kotlin_kotlin.$_$.k5;
  var isInterface = kotlin_kotlin.$_$.gc;
  var StringBuilder_init_$Create$ = kotlin_kotlin.$_$.g1;
  var _Char___init__impl__6a9atx = kotlin_kotlin.$_$.r2;
  var Collection = kotlin_kotlin.$_$.e5;
  var isIntArray = kotlin_kotlin.$_$.fc;
  var copyOf_0 = kotlin_kotlin.$_$.x6;
  var take_0 = kotlin_kotlin.$_$.g9;
  var copyOf_1 = kotlin_kotlin.$_$.v6;
  var isFloatArray = kotlin_kotlin.$_$.ec;
  var take_1 = kotlin_kotlin.$_$.f9;
  var compareTo = kotlin_kotlin.$_$.kb;
  var LinkedHashMap_init_$Create$ = kotlin_kotlin.$_$.x;
  var MutableMap = kotlin_kotlin.$_$.p5;
  var hashCode = kotlin_kotlin.$_$.ub;
  var fillArrayVal = kotlin_kotlin.$_$.nb;
  var isArray = kotlin_kotlin.$_$.xb;
  var toSet = kotlin_kotlin.$_$.w9;
  var toList = kotlin_kotlin.$_$.o9;
  var collectionSizeOrDefault = kotlin_kotlin.$_$.b6;
  var ArrayList_init_$Create$ = kotlin_kotlin.$_$.n;
  var to = kotlin_kotlin.$_$.yh;
  var Map_0 = kotlin_kotlin.$_$.m5;
  var StringBuilder_init_$Create$_0 = kotlin_kotlin.$_$.h1;
  var MutableIterable = kotlin_kotlin.$_$.n5;
  var addAll = kotlin_kotlin.$_$.t5;
  var MutableList = kotlin_kotlin.$_$.o5;
  var interfaceMeta = kotlin_kotlin.$_$.wb;
  var AbstractMutableSet = kotlin_kotlin.$_$.c5;
  var LinkedHashSet_init_$Create$ = kotlin_kotlin.$_$.z;
  var IndexOutOfBoundsException_init_$Create$_0 = kotlin_kotlin.$_$.w1;
  var toMutableSet = kotlin_kotlin.$_$.v9;
  var until = kotlin_kotlin.$_$.pd;
  var NoSuchElementException_init_$Create$ = kotlin_kotlin.$_$.x1;
  var joinToString = kotlin_kotlin.$_$.w7;
  var Iterable = kotlin_kotlin.$_$.h5;
  var copyOf_2 = kotlin_kotlin.$_$.w6;
  var IllegalStateException_init_$Create$_0 = kotlin_kotlin.$_$.s1;
  var numberToInt = kotlin_kotlin.$_$.qc;
  var ensureNotNull = kotlin_kotlin.$_$.ih;
  var NonRecursiveLock = kotlin_com_soywiz_korge_korlibs_concurrent.$_$.b;
  var Comparator = kotlin_kotlin.$_$.dg;
  var reversed = kotlin_kotlin.$_$.da;
  var NotImplementedError = kotlin_kotlin.$_$.mg;
  var contentEquals_1 = kotlin_kotlin.$_$.e6;
  var contentHashCode_1 = kotlin_kotlin.$_$.j6;
  var throwUninitializedPropertyAccessException = kotlin_kotlin.$_$.vh;
  var IntCompanionObject_instance = kotlin_kotlin.$_$.l4;
  var firstOrNull = kotlin_kotlin.$_$.i7;
  var first = kotlin_kotlin.$_$.n7;
  var getStringHashCode = kotlin_kotlin.$_$.tb;
  var removeLast = kotlin_kotlin.$_$.u8;
  var CoroutineImpl = kotlin_kotlin.$_$.wa;
  var SequenceScope = kotlin_kotlin.$_$.wd;
  var get_COROUTINE_SUSPENDED = kotlin_kotlin.$_$.fa;
  var HashMap_init_$Create$ = kotlin_kotlin.$_$.r;
  var iterator = kotlin_kotlin.$_$.xd;
  var ArrayList_init_$Create$_0 = kotlin_kotlin.$_$.o;
  var contentHashCode_2 = kotlin_kotlin.$_$.k6;
  var contentEquals_2 = kotlin_kotlin.$_$.g6;
  var arrayCopy = kotlin_kotlin.$_$.v5;
  var Char__plus_impl_qi7pgj = kotlin_kotlin.$_$.v2;
  var joinToString_0 = kotlin_kotlin.$_$.v7;
  var toRawBits = kotlin_kotlin.$_$.wh;
  var Lock = kotlin_com_soywiz_korge_korlibs_concurrent.$_$.a;
  var toMutableList = kotlin_kotlin.$_$.s9;
  var mapCapacity = kotlin_kotlin.$_$.k8;
  var coerceAtLeast = kotlin_kotlin.$_$.hd;
  var LinkedHashMap_init_$Create$_0 = kotlin_kotlin.$_$.w;
  var toMutableMap = kotlin_kotlin.$_$.u9;
  var Pair = kotlin_kotlin.$_$.ng;
  var toMap = kotlin_kotlin.$_$.r9;
  var getOrNull = kotlin_kotlin.$_$.p7;
  var step = kotlin_kotlin.$_$.nd;
  var round = kotlin_kotlin.$_$.dd;
  var numberToLong = kotlin_kotlin.$_$.rc;
  var copyToArray = kotlin_kotlin.$_$.y6;
  var AbstractMutableList = kotlin_kotlin.$_$.b5;
  var get_lastIndex = kotlin_kotlin.$_$.b8;
  var joinToString_1 = kotlin_kotlin.$_$.x7;
  var RandomAccess = kotlin_kotlin.$_$.r5;
  var toList_0 = kotlin_kotlin.$_$.p9;
  //endregion
  //region block: pre-declaration
  setMetadataFor(Companion, 'Companion', objectMeta);
  function getAt(x, y) {
    return this.b1r(index(this, x, y));
  }
  function asString() {
    var tmp = until(0, this.y1q());
    return joinToString(tmp, '\n', VOID, VOID, VOID, VOID, IArray2$asString$lambda(this));
  }
  setMetadataFor(IArray2, 'IArray2', interfaceMeta, VOID, [Iterable]);
  setMetadataFor(IntArray2, 'IntArray2', classMeta, VOID, [IArray2]);
  setMetadataFor(Companion_0, 'Companion', objectMeta);
  setMetadataFor(FloatArray2, 'FloatArray2', classMeta, VOID, [IArray2]);
  setMetadataFor(Companion_1, 'Companion', objectMeta);
  setMetadataFor(DoubleArrayList, 'DoubleArrayList', classMeta, VOID, [Collection], DoubleArrayList);
  setMetadataFor(Companion_2, 'Companion', objectMeta);
  setMetadataFor(IntArrayList, 'IntArrayList', classMeta, VOID, [Collection], IntArrayList);
  setMetadataFor(Companion_3, 'Companion', objectMeta);
  setMetadataFor(FloatArrayList, 'FloatArrayList', classMeta, VOID, [Collection], FloatArrayList);
  setMetadataFor(SortOps, 'SortOps', classMeta);
  setMetadataFor(DoubleArrayListSortOps, 'DoubleArrayListSortOps', objectMeta, SortOps);
  setMetadataFor(CaseInsensitiveStringMap, 'CaseInsensitiveStringMap', classMeta, VOID, [MutableMap], CaseInsensitiveStringMap_init_$Create$);
  setMetadataFor(TGenDeque$iterator$1, VOID, classMeta);
  setMetadataFor(TGenDeque, 'TGenDeque', classMeta, VOID, [MutableIterable, Collection], TGenDeque_init_$Create$);
  setMetadataFor(IntDeque$iterator$1, VOID, classMeta);
  setMetadataFor(IntDeque, 'IntDeque', classMeta, VOID, [MutableIterable, Collection], IntDeque_init_$Create$);
  function setAddAll(index, elements, offset, size) {
    // Inline function 'kotlin.math.min' call
    var b = this.n() - index | 0;
    var setCount = Math.min(size, b);
    this.d1v(index, elements, offset, setCount);
    this.e1v(elements, offset + setCount | 0, size - setCount | 0);
  }
  function setAddAll$default(index, elements, offset, size, $super) {
    offset = offset === VOID ? 0 : offset;
    size = size === VOID ? elements.n() - offset | 0 : size;
    var tmp;
    if ($super === VOID) {
      this.c1v(index, elements, offset, size);
      tmp = Unit_instance;
    } else {
      setAddAll(index, elements, offset, size);
      tmp = Unit_instance;
    }
    return tmp;
  }
  function setAll(index, elements, offset, size) {
    var inductionVariable = 0;
    if (inductionVariable < size)
      do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        this.o(index + n | 0, elements.f1(offset + n | 0));
      }
       while (inductionVariable < size);
  }
  function addAll_0(elements, offset, size) {
    var inductionVariable = 0;
    if (inductionVariable < size)
      do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        this.r(elements.f1(offset + n | 0));
      }
       while (inductionVariable < size);
  }
  function removeToSize(size) {
    this.b1v(size, this.n());
  }
  setMetadataFor(MutableListEx, 'MutableListEx', interfaceMeta, VOID, [MutableList]);
  setMetadataFor(FastIdentityCacheMap, 'FastIdentityCacheMap', classMeta, VOID, VOID, FastIdentityCacheMap);
  setMetadataFor(FastSmallSet, 'FastSmallSet', classMeta, AbstractMutableSet, VOID, FastSmallSet);
  setMetadataFor(GenericSubList, 'GenericSubList', classMeta, VOID, [List]);
  setMetadataFor(GenericListIterator, 'GenericListIterator', classMeta);
  setMetadataFor(Companion_4, 'Companion', objectMeta);
  setMetadataFor(Companion_5, 'Companion', objectMeta);
  setMetadataFor(Entry, 'Entry', classMeta);
  setMetadataFor(Iterator, 'Iterator', classMeta);
  setMetadataFor(_no_name_provided__qut3iv, VOID, classMeta, VOID, [Iterable]);
  setMetadataFor(_no_name_provided__qut3iv_0, VOID, classMeta, VOID, [Iterable]);
  setMetadataFor(IntMap, 'IntMap', classMeta, VOID, VOID, IntMap_init_$Create$);
  setMetadataFor(Companion_6, 'Companion', objectMeta);
  setMetadataFor(IntIntMap, 'IntIntMap', classMeta, VOID, VOID, IntIntMap_init_$Create$);
  setMetadataFor(Iterator$1, VOID, classMeta);
  setMetadataFor(Pool, 'Pool', classMeta);
  setMetadataFor(ConcurrentPool, 'ConcurrentPool', classMeta, Pool);
  setMetadataFor(Companion_7, 'Companion', objectMeta);
  setMetadataFor(ReturnablePool, 'ReturnablePool', classMeta);
  setMetadataFor(sam$kotlin_Comparator$0, 'sam$kotlin_Comparator$0', classMeta, VOID, [Comparator]);
  setMetadataFor(Companion_8, 'Companion', objectMeta);
  setMetadataFor(TGenPriorityQueue$iterator$1, VOID, classMeta);
  setMetadataFor(TGenPriorityQueue, 'TGenPriorityQueue', classMeta, VOID, [MutableIterable, Collection]);
  setMetadataFor(TGenQueue, 'TGenQueue', classMeta, VOID, [Collection], TGenQueue);
  setMetadataFor(Ref$2, VOID, classMeta);
  setMetadataFor(Ref$3, VOID, classMeta);
  setMetadataFor(ByteRingBuffer, 'ByteRingBuffer', classMeta);
  setMetadataFor(RingBuffer, 'RingBuffer', classMeta, ByteRingBuffer);
  function getLast(x, y) {
    var level = this.a21(x, y);
    if (level === 0)
      return this.m20();
    return this.z20(x, y, level - 1 | 0);
  }
  setMetadataFor(IStackedIntArray2, 'IStackedIntArray2', interfaceMeta);
  setMetadataFor(SparseChunkedStackedIntArray2, 'SparseChunkedStackedIntArray2', classMeta, VOID, [IStackedIntArray2], SparseChunkedStackedIntArray2);
  setMetadataFor(Companion_9, 'Companion', objectMeta);
  setMetadataFor(TGenStack, 'TGenStack', classMeta, VOID, [Collection]);
  setMetadataFor(Companion_10, 'Companion', objectMeta);
  setMetadataFor(StackedIntArray2, 'StackedIntArray2', classMeta, VOID, [IStackedIntArray2]);
  setMetadataFor(Closeable, 'Closeable', interfaceMeta);
  setMetadataFor(Comparators, 'Comparators', classMeta, VOID, VOID, Comparators);
  setMetadataFor(Companion_11, 'Companion', objectMeta, Comparators);
  setMetadataFor(Node, 'Node', classMeta);
  setMetadataFor(RemoveSubtreeRetObject, 'RemoveSubtreeRetObject', classMeta);
  setMetadataFor(BVH$iterator$slambda, 'BVH$iterator$slambda', classMeta, CoroutineImpl, VOID, VOID, VOID, VOID, [1]);
  setMetadataFor(BVH, 'BVH', classMeta, VOID, [Iterable]);
  setMetadataFor(BVHRect, 'BVHRect', classMeta);
  setMetadataFor(Companion_12, 'Companion', objectMeta);
  setMetadataFor(BVHIntervals, 'BVHIntervals', classMeta);
  setMetadataFor(Companion_13, 'Companion', objectMeta);
  setMetadataFor(BVHVector, 'BVHVector', classMeta);
  setMetadataFor(SyncPauseable, 'SyncPauseable', classMeta, VOID, VOID, SyncPauseable);
  setMetadataFor(Mixin, 'Mixin', classMeta, VOID, VOID, Mixin);
  setMetadataFor(Property, 'Property', classMeta);
  setMetadataFor(PropertyThis, 'PropertyThis', classMeta);
  setMetadataFor(ExtraObject, 'ExtraObject', classMeta, VOID, [MutableMap], ExtraObject);
  setMetadataFor(Math_0, 'Math', objectMeta);
  setMetadataFor(Memory, 'Memory', objectMeta);
  setMetadataFor(FastArrayList, 'FastArrayList', classMeta, AbstractMutableList, [AbstractMutableList, MutableListEx, RandomAccess], FastArrayList_init_$Create$);
  //endregion
  function Companion() {
  }
  var Companion_instance;
  function Companion_getInstance() {
    return Companion_instance;
  }
  function IntArray2(width, height, data) {
    this.t1q_1 = width;
    this.u1q_1 = height;
    this.v1q_1 = data;
    Companion_instance_4.w1q(this.t1q_1, this.u1q_1, this.v1q_1.length);
  }
  protoOf(IntArray2).x1q = function () {
    return this.t1q_1;
  };
  protoOf(IntArray2).y1q = function () {
    return this.u1q_1;
  };
  protoOf(IntArray2).z1q = function (idx, value) {
    this.v1q_1[idx] = value;
  };
  protoOf(IntArray2).a1r = function (idx, value) {
    return this.z1q(idx, (!(value == null) ? typeof value === 'number' : false) ? value : THROW_CCE());
  };
  protoOf(IntArray2).b1r = function (idx) {
    return this.v1q_1[idx];
  };
  protoOf(IntArray2).equals = function (other) {
    var tmp;
    var tmp_0;
    var tmp_1;
    if (other instanceof IntArray2) {
      tmp_1 = this.t1q_1 === other.t1q_1;
    } else {
      tmp_1 = false;
    }
    if (tmp_1) {
      tmp_0 = this.u1q_1 === other.u1q_1;
    } else {
      tmp_0 = false;
    }
    if (tmp_0) {
      tmp = contentEquals(this.v1q_1, other.v1q_1);
    } else {
      tmp = false;
    }
    return tmp;
  };
  protoOf(IntArray2).c1r = function (x, y) {
    return this.v1q_1[index(this, x, y)];
  };
  protoOf(IntArray2).d1r = function (x, y, value) {
    this.v1q_1[index(this, x, y)] = value;
  };
  protoOf(IntArray2).hashCode = function () {
    return (this.t1q_1 + this.u1q_1 | 0) + contentHashCode(this.v1q_1) | 0;
  };
  protoOf(IntArray2).u = function () {
    return intArrayIterator(this.v1q_1);
  };
  protoOf(IntArray2).toString = function () {
    return this.e1r();
  };
  function Companion_0() {
  }
  var Companion_instance_0;
  function Companion_getInstance_0() {
    return Companion_instance_0;
  }
  function FloatArray2(width, height, data) {
    this.g1r_1 = width;
    this.h1r_1 = height;
    this.i1r_1 = data;
    Companion_instance_4.w1q(this.g1r_1, this.h1r_1, this.i1r_1.length);
  }
  protoOf(FloatArray2).x1q = function () {
    return this.g1r_1;
  };
  protoOf(FloatArray2).y1q = function () {
    return this.h1r_1;
  };
  protoOf(FloatArray2).j1r = function (idx, value) {
    this.i1r_1[idx] = value;
  };
  protoOf(FloatArray2).a1r = function (idx, value) {
    return this.j1r(idx, (!(value == null) ? typeof value === 'number' : false) ? value : THROW_CCE());
  };
  protoOf(FloatArray2).b1r = function (idx) {
    return this.i1r_1[idx];
  };
  protoOf(FloatArray2).equals = function (other) {
    var tmp;
    var tmp_0;
    var tmp_1;
    if (other instanceof FloatArray2) {
      tmp_1 = this.g1r_1 === other.g1r_1;
    } else {
      tmp_1 = false;
    }
    if (tmp_1) {
      tmp_0 = this.h1r_1 === other.h1r_1;
    } else {
      tmp_0 = false;
    }
    if (tmp_0) {
      tmp = contentEquals_0(this.i1r_1, other.i1r_1);
    } else {
      tmp = false;
    }
    return tmp;
  };
  protoOf(FloatArray2).c1r = function (x, y) {
    return this.i1r_1[index(this, x, y)];
  };
  protoOf(FloatArray2).k1r = function (x, y, value) {
    this.i1r_1[index(this, x, y)] = value;
  };
  protoOf(FloatArray2).hashCode = function () {
    return (this.g1r_1 + this.h1r_1 | 0) + contentHashCode_0(this.i1r_1) | 0;
  };
  protoOf(FloatArray2).u = function () {
    return floatArrayIterator(this.i1r_1);
  };
  protoOf(FloatArray2).toString = function () {
    return this.e1r();
  };
  function swap(_this__u8e3s4, lIndex, rIndex) {
    var temp = _this__u8e3s4[lIndex];
    _this__u8e3s4[lIndex] = _this__u8e3s4[rIndex];
    _this__u8e3s4[rIndex] = temp;
  }
  function rotateRight(_this__u8e3s4, offset) {
    offset = offset === VOID ? 1 : offset;
    var tmp$ret$0;
    $l$block: {
      // Inline function 'korlibs.datastructure._rotateRight' call
      var size = _this__u8e3s4.length;
      var offset_0 = Math_instance.m1r(offset, size);
      if (offset_0 === 0) {
        tmp$ret$0 = Unit_instance;
        break $l$block;
      }
      // Inline function 'kotlin.check' call
      // Inline function 'kotlin.contracts.contract' call
      // Inline function 'kotlin.check' call
      // Inline function 'kotlin.contracts.contract' call
      if (!(1 <= offset_0 ? offset_0 < size : false)) {
        // Inline function 'kotlin.check.<anonymous>' call
        var message = 'Check failed.';
        throw IllegalStateException_init_$Create$(toString(message));
      }
      // Inline function 'korlibs.datastructure.rotateRight.<anonymous>' call
      reverse(_this__u8e3s4, 0, size);
      // Inline function 'korlibs.datastructure.rotateRight.<anonymous>' call
      reverse(_this__u8e3s4, 0, offset_0);
      // Inline function 'korlibs.datastructure.rotateRight.<anonymous>' call
      reverse(_this__u8e3s4, offset_0, size);
    }
    return tmp$ret$0;
  }
  function Companion_1() {
  }
  var Companion_instance_1;
  function Companion_getInstance_1() {
    return Companion_instance_1;
  }
  function DoubleArrayList_init_$Init$(other, $this) {
    DoubleArrayList.call($this);
    $this.p1r(other);
    return $this;
  }
  function DoubleArrayList_init_$Create$(other) {
    return DoubleArrayList_init_$Init$(other, objectCreate(protoOf(DoubleArrayList)));
  }
  function DoubleArrayList_init_$Init$_0(other, $this) {
    DoubleArrayList.call($this);
    $this.q1r(other);
    return $this;
  }
  function DoubleArrayList_init_$Create$_0(other) {
    return DoubleArrayList_init_$Init$_0(other, objectCreate(protoOf(DoubleArrayList)));
  }
  function ensure($this, count) {
    if (($this.o1r_1 + count | 0) > $this.n1r_1.length) {
      var tmp = $this;
      var tmp_0 = $this.n1r_1;
      // Inline function 'kotlin.math.max' call
      var a = $this.o1r_1 + count | 0;
      var b = imul($this.n1r_1.length, 3);
      var tmp$ret$0 = Math.max(a, b);
      var tmp_1 = copyOf(tmp_0, tmp$ret$0);
      tmp.n1r_1 = isDoubleArray(tmp_1) ? tmp_1 : THROW_CCE();
    }
  }
  function DoubleArrayList(capacity) {
    capacity = capacity === VOID ? 7 : capacity;
    var tmp = this;
    var tmp_0 = new Float64Array(capacity);
    tmp.n1r_1 = isDoubleArray(tmp_0) ? tmp_0 : THROW_CCE();
    this.o1r_1 = 0;
  }
  protoOf(DoubleArrayList).r1r = function (value) {
    ensure(this, value);
    this.o1r_1 = value;
  };
  protoOf(DoubleArrayList).n = function () {
    return this.o1r_1;
  };
  protoOf(DoubleArrayList).b3 = function () {
    this.o1r_1 = 0;
  };
  protoOf(DoubleArrayList).s1r = function (v0) {
    ensure(this, 1);
    var tmp = this.n1r_1;
    var tmp1 = this.o1r_1;
    this.o1r_1 = tmp1 + 1 | 0;
    tmp[tmp1] = v0;
  };
  protoOf(DoubleArrayList).t1r = function (v0, v1) {
    ensure(this, 2);
    var tmp = this.n1r_1;
    var tmp1 = this.o1r_1;
    this.o1r_1 = tmp1 + 1 | 0;
    tmp[tmp1] = v0;
    var tmp_0 = this.n1r_1;
    var tmp3 = this.o1r_1;
    this.o1r_1 = tmp3 + 1 | 0;
    tmp_0[tmp3] = v1;
  };
  protoOf(DoubleArrayList).u1r = function (v0, v1, v2, v3) {
    ensure(this, 4);
    var tmp = this.n1r_1;
    var tmp1 = this.o1r_1;
    this.o1r_1 = tmp1 + 1 | 0;
    tmp[tmp1] = v0;
    var tmp_0 = this.n1r_1;
    var tmp3 = this.o1r_1;
    this.o1r_1 = tmp3 + 1 | 0;
    tmp_0[tmp3] = v1;
    var tmp_1 = this.n1r_1;
    var tmp5 = this.o1r_1;
    this.o1r_1 = tmp5 + 1 | 0;
    tmp_1[tmp5] = v2;
    var tmp_2 = this.n1r_1;
    var tmp7 = this.o1r_1;
    this.o1r_1 = tmp7 + 1 | 0;
    tmp_2[tmp7] = v3;
  };
  protoOf(DoubleArrayList).v1r = function (v0, v1, v2, v3, v4, v5) {
    ensure(this, 6);
    var tmp = this.n1r_1;
    var tmp1 = this.o1r_1;
    this.o1r_1 = tmp1 + 1 | 0;
    tmp[tmp1] = v0;
    var tmp_0 = this.n1r_1;
    var tmp3 = this.o1r_1;
    this.o1r_1 = tmp3 + 1 | 0;
    tmp_0[tmp3] = v1;
    var tmp_1 = this.n1r_1;
    var tmp5 = this.o1r_1;
    this.o1r_1 = tmp5 + 1 | 0;
    tmp_1[tmp5] = v2;
    var tmp_2 = this.n1r_1;
    var tmp7 = this.o1r_1;
    this.o1r_1 = tmp7 + 1 | 0;
    tmp_2[tmp7] = v3;
    var tmp_3 = this.n1r_1;
    var tmp9 = this.o1r_1;
    this.o1r_1 = tmp9 + 1 | 0;
    tmp_3[tmp9] = v4;
    var tmp_4 = this.n1r_1;
    var tmp11 = this.o1r_1;
    this.o1r_1 = tmp11 + 1 | 0;
    tmp_4[tmp11] = v5;
  };
  protoOf(DoubleArrayList).w1r = function (value) {
    return this.s1r(value);
  };
  protoOf(DoubleArrayList).x1r = function (value) {
    return this.p1r(value);
  };
  protoOf(DoubleArrayList).y1r = function (values, offset, length) {
    ensure(this, length);
    var tmp = Memory_instance;
    tmp.z1r(isDoubleArray(values) ? values : THROW_CCE(), offset, this.n1r_1, this.n(), length);
    this.r1r(this.n() + length | 0);
  };
  protoOf(DoubleArrayList).q1r = function (values, offset, length, $super) {
    offset = offset === VOID ? 0 : offset;
    length = length === VOID ? values.length : length;
    var tmp;
    if ($super === VOID) {
      this.y1r(values, offset, length);
      tmp = Unit_instance;
    } else {
      tmp = $super.y1r.call(this, values, offset, length);
    }
    return tmp;
  };
  protoOf(DoubleArrayList).p1r = function (values) {
    return this.y1r(values.n1r_1, 0, values.n());
  };
  protoOf(DoubleArrayList).f1 = function (index) {
    return this.n1r_1[index];
  };
  protoOf(DoubleArrayList).b1r = function (index) {
    return this.n1r_1[index];
  };
  protoOf(DoubleArrayList).a1s = function (index, value) {
    if (index >= this.o1r_1) {
      ensure(this, index + 1 | 0);
      this.o1r_1 = index + 1 | 0;
    }
    this.n1r_1[index] = value;
  };
  protoOf(DoubleArrayList).u = function () {
    return this.w1(0);
  };
  protoOf(DoubleArrayList).b1s = function (element) {
    var inductionVariable = 0;
    var last = this.o1r_1;
    if (inductionVariable < last)
      do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        if (this.n1r_1[n] === element)
          return true;
      }
       while (inductionVariable < last);
    return false;
  };
  protoOf(DoubleArrayList).c1s = function (elements) {
    var tmp0_iterator = elements.u();
    while (tmp0_iterator.v()) {
      var e = tmp0_iterator.x();
      if (!this.b1s(e))
        return false;
    }
    return true;
  };
  protoOf(DoubleArrayList).a1 = function (elements) {
    return this.c1s(elements);
  };
  protoOf(DoubleArrayList).b1 = function () {
    return this.n() === 0;
  };
  protoOf(DoubleArrayList).d1s = function (indexA, indexB) {
    var l = this.b1r(indexA);
    var r = this.b1r(indexB);
    this.a1s(indexA, r);
    this.a1s(indexB, l);
  };
  protoOf(DoubleArrayList).h1 = function (index) {
    return this.e1s(index, 1);
  };
  protoOf(DoubleArrayList).e1s = function (index, count) {
    if ((index < 0 ? true : index >= this.o1r_1) ? true : (index + count | 0) > this.o1r_1)
      throw IndexOutOfBoundsException_init_$Create$();
    var out = this.n1r_1[index];
    if (count > 0) {
      if (index < (this.o1r_1 - count | 0)) {
        Memory_instance.z1r(this.n1r_1, index + count | 0, this.n1r_1, index, (this.o1r_1 - index | 0) - count | 0);
      }
      this.o1r_1 = this.o1r_1 - count | 0;
    }
    return out;
  };
  protoOf(DoubleArrayList).f1s = function () {
    return copyOf(this.n1r_1, this.o1r_1);
  };
  protoOf(DoubleArrayList).w1 = function (index) {
    return take(this.n1r_1, this.o1r_1).w1(index);
  };
  protoOf(DoubleArrayList).g1s = function () {
    return DoubleArrayList_init_$Create$(this);
  };
  protoOf(DoubleArrayList).hashCode = function () {
    return contentHashCode_3(this.n1r_1, 0, this.n());
  };
  protoOf(DoubleArrayList).equals = function (other) {
    if (other instanceof DoubleArrayList)
      return this.n() === other.n() ? contentEquals_3(this.n1r_1, other.n1r_1, 0, this.n()) : false;
    if (!(other == null) ? isInterface(other, List) : false)
      return equals(other, this);
    return false;
  };
  protoOf(DoubleArrayList).toString = function () {
    // Inline function 'kotlin.also' call
    var this_0 = StringBuilder_init_$Create$(2 + imul(5, this.n()) | 0);
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.datastructure.DoubleArrayList.toString.<anonymous>' call
    this_0.v5(_Char___init__impl__6a9atx(91));
    var inductionVariable = 0;
    var last = this.n();
    if (inductionVariable < last)
      do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        if (!(n === 0)) {
          this_0.u5(', ');
        }
        this_0.m8(this.b1r(n));
      }
       while (inductionVariable < last);
    this_0.v5(_Char___init__impl__6a9atx(93));
    return this_0.toString();
  };
  function Companion_2() {
  }
  var Companion_instance_2;
  function Companion_getInstance_2() {
    return Companion_instance_2;
  }
  function IntArrayList_init_$Init$(other, $this) {
    IntArrayList.call($this);
    $this.j1s(other);
    return $this;
  }
  function IntArrayList_init_$Create$(other) {
    return IntArrayList_init_$Init$(other, objectCreate(protoOf(IntArrayList)));
  }
  function IntArrayList_init_$Init$_0(other, $this) {
    IntArrayList.call($this);
    $this.k1s(other);
    return $this;
  }
  function IntArrayList_init_$Create$_0(other) {
    return IntArrayList_init_$Init$_0(other, objectCreate(protoOf(IntArrayList)));
  }
  function IntArrayList(capacity) {
    capacity = capacity === VOID ? 7 : capacity;
    var tmp = this;
    var tmp_0 = new Int32Array(capacity);
    tmp.h1s_1 = isIntArray(tmp_0) ? tmp_0 : THROW_CCE();
    this.i1s_1 = 0;
  }
  protoOf(IntArrayList).r1r = function (value) {
    this.l1s(value);
    this.i1s_1 = value;
  };
  protoOf(IntArrayList).n = function () {
    return this.i1s_1;
  };
  protoOf(IntArrayList).l1s = function (count) {
    if ((this.i1s_1 + count | 0) > this.h1s_1.length) {
      var tmp = this;
      var tmp_0 = this.h1s_1;
      // Inline function 'kotlin.math.max' call
      var a = this.i1s_1 + count | 0;
      var b = imul(this.h1s_1.length, 3);
      var tmp$ret$0 = Math.max(a, b);
      var tmp_1 = copyOf_0(tmp_0, tmp$ret$0);
      tmp.h1s_1 = isIntArray(tmp_1) ? tmp_1 : THROW_CCE();
    }
  };
  protoOf(IntArrayList).b3 = function () {
    this.i1s_1 = 0;
  };
  protoOf(IntArrayList).m1s = function (v0) {
    this.l1s(1);
    var tmp = this.h1s_1;
    var tmp1 = this.i1s_1;
    this.i1s_1 = tmp1 + 1 | 0;
    tmp[tmp1] = v0;
  };
  protoOf(IntArrayList).n1s = function (value) {
    return this.m1s(value);
  };
  protoOf(IntArrayList).o1s = function (value) {
    return this.j1s(value);
  };
  protoOf(IntArrayList).p1s = function (values, offset, length) {
    this.l1s(length);
    var tmp = Memory_instance;
    tmp.q1s(isIntArray(values) ? values : THROW_CCE(), offset, this.h1s_1, this.n(), length);
    this.r1r(this.n() + length | 0);
  };
  protoOf(IntArrayList).k1s = function (values, offset, length, $super) {
    offset = offset === VOID ? 0 : offset;
    length = length === VOID ? values.length : length;
    var tmp;
    if ($super === VOID) {
      this.p1s(values, offset, length);
      tmp = Unit_instance;
    } else {
      tmp = $super.p1s.call(this, values, offset, length);
    }
    return tmp;
  };
  protoOf(IntArrayList).j1s = function (values) {
    return this.p1s(values.h1s_1, 0, values.n());
  };
  protoOf(IntArrayList).f1 = function (index) {
    return this.h1s_1[index];
  };
  protoOf(IntArrayList).b1r = function (index) {
    return this.h1s_1[index];
  };
  protoOf(IntArrayList).r1s = function (index, value) {
    if (index >= this.i1s_1) {
      this.l1s(index + 1 | 0);
      this.i1s_1 = index + 1 | 0;
    }
    this.h1s_1[index] = value;
  };
  protoOf(IntArrayList).u = function () {
    return this.w1(0);
  };
  protoOf(IntArrayList).zh = function (element) {
    var inductionVariable = 0;
    var last = this.i1s_1;
    if (inductionVariable < last)
      do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        if (this.h1s_1[n] === element)
          return true;
      }
       while (inductionVariable < last);
    return false;
  };
  protoOf(IntArrayList).s1s = function (elements) {
    var tmp0_iterator = elements.u();
    while (tmp0_iterator.v()) {
      var e = tmp0_iterator.x();
      if (!this.zh(e))
        return false;
    }
    return true;
  };
  protoOf(IntArrayList).a1 = function (elements) {
    return this.s1s(elements);
  };
  protoOf(IntArrayList).b1 = function () {
    return this.n() === 0;
  };
  protoOf(IntArrayList).t1s = function () {
    return !(this.n() === 0);
  };
  protoOf(IntArrayList).u1s = function () {
    var tmp;
    if (this.b1()) {
      throw IndexOutOfBoundsException_init_$Create$();
    } else {
      tmp = this.h1s_1[0];
    }
    return tmp;
  };
  protoOf(IntArrayList).v1s = function () {
    var tmp;
    if (this.b1()) {
      throw IndexOutOfBoundsException_init_$Create$();
    } else {
      tmp = this.h1s_1[this.i1s_1 - 1 | 0];
    }
    return tmp;
  };
  protoOf(IntArrayList).w1s = function (index, value) {
    // Inline function 'kotlin.apply' call
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.datastructure.IntArrayList.insertAt.<anonymous>' call
    this.l1s(1);
    if (this.t1s()) {
      Memory_instance.q1s(this.h1s_1, index, this.h1s_1, index + 1 | 0, this.i1s_1 - index | 0);
    }
    this.h1s_1[index] = value;
    this.i1s_1 = this.i1s_1 + 1 | 0;
    return this;
  };
  protoOf(IntArrayList).d1s = function (indexA, indexB) {
    var l = this.b1r(indexA);
    var r = this.b1r(indexB);
    this.r1s(indexA, r);
    this.r1s(indexB, l);
  };
  protoOf(IntArrayList).e1s = function (index, count) {
    if ((index < 0 ? true : index >= this.i1s_1) ? true : (index + count | 0) > this.i1s_1)
      throw IndexOutOfBoundsException_init_$Create$();
    var out = this.h1s_1[index];
    if (count > 0) {
      if (index < (this.i1s_1 - count | 0)) {
        Memory_instance.q1s(this.h1s_1, index + count | 0, this.h1s_1, index, (this.i1s_1 - index | 0) - count | 0);
      }
      this.i1s_1 = this.i1s_1 - count | 0;
    }
    return out;
  };
  protoOf(IntArrayList).x1s = function () {
    return copyOf_0(this.h1s_1, this.i1s_1);
  };
  protoOf(IntArrayList).w1 = function (index) {
    return take_0(this.h1s_1, this.i1s_1).w1(index);
  };
  protoOf(IntArrayList).hashCode = function () {
    return contentHashCode_4(this.h1s_1, 0, this.n());
  };
  protoOf(IntArrayList).equals = function (other) {
    if (other instanceof IntArrayList)
      return this.n() === other.n() ? contentEquals_4(this.h1s_1, other.h1s_1, 0, this.n()) : false;
    if (!(other == null) ? isInterface(other, List) : false)
      return equals(other, this);
    return false;
  };
  protoOf(IntArrayList).toString = function () {
    // Inline function 'kotlin.also' call
    var this_0 = StringBuilder_init_$Create$(2 + imul(5, this.n()) | 0);
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.datastructure.IntArrayList.toString.<anonymous>' call
    this_0.v5(_Char___init__impl__6a9atx(91));
    var inductionVariable = 0;
    var last = this.n();
    if (inductionVariable < last)
      do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        if (!(n === 0)) {
          this_0.u5(', ');
        }
        this_0.j8(this.b1r(n));
      }
       while (inductionVariable < last);
    this_0.v5(_Char___init__impl__6a9atx(93));
    return this_0.toString();
  };
  function intArrayListOf(values) {
    return IntArrayList_init_$Create$_0(values.slice());
  }
  function toIntArrayList(_this__u8e3s4) {
    return IntArrayList_init_$Create$_0(_this__u8e3s4.slice());
  }
  function Companion_3() {
  }
  var Companion_instance_3;
  function Companion_getInstance_3() {
    return Companion_instance_3;
  }
  function FloatArrayList_init_$Init$(other, $this) {
    FloatArrayList.call($this);
    $this.a1t(other);
    return $this;
  }
  function FloatArrayList_init_$Create$(other) {
    return FloatArrayList_init_$Init$(other, objectCreate(protoOf(FloatArrayList)));
  }
  function ensure_0($this, count) {
    if (($this.z1s_1 + count | 0) > $this.y1s_1.length) {
      var tmp = $this;
      var tmp_0 = $this.y1s_1;
      // Inline function 'kotlin.math.max' call
      var a = $this.z1s_1 + count | 0;
      var b = imul($this.y1s_1.length, 3);
      var tmp$ret$0 = Math.max(a, b);
      var tmp_1 = copyOf_1(tmp_0, tmp$ret$0);
      tmp.y1s_1 = isFloatArray(tmp_1) ? tmp_1 : THROW_CCE();
    }
  }
  function FloatArrayList(capacity) {
    capacity = capacity === VOID ? 7 : capacity;
    var tmp = this;
    var tmp_0 = new Float32Array(capacity);
    tmp.y1s_1 = isFloatArray(tmp_0) ? tmp_0 : THROW_CCE();
    this.z1s_1 = 0;
  }
  protoOf(FloatArrayList).r1r = function (value) {
    ensure_0(this, value);
    this.z1s_1 = value;
  };
  protoOf(FloatArrayList).n = function () {
    return this.z1s_1;
  };
  protoOf(FloatArrayList).b3 = function () {
    this.z1s_1 = 0;
  };
  protoOf(FloatArrayList).b1t = function (v0, v1, v2, v3) {
    ensure_0(this, 4);
    var tmp = this.y1s_1;
    var tmp1 = this.z1s_1;
    this.z1s_1 = tmp1 + 1 | 0;
    tmp[tmp1] = v0;
    var tmp_0 = this.y1s_1;
    var tmp3 = this.z1s_1;
    this.z1s_1 = tmp3 + 1 | 0;
    tmp_0[tmp3] = v1;
    var tmp_1 = this.y1s_1;
    var tmp5 = this.z1s_1;
    this.z1s_1 = tmp5 + 1 | 0;
    tmp_1[tmp5] = v2;
    var tmp_2 = this.y1s_1;
    var tmp7 = this.z1s_1;
    this.z1s_1 = tmp7 + 1 | 0;
    tmp_2[tmp7] = v3;
  };
  protoOf(FloatArrayList).c1t = function (values, offset, length) {
    ensure_0(this, length);
    var tmp = Memory_instance;
    tmp.d1t(isFloatArray(values) ? values : THROW_CCE(), offset, this.y1s_1, this.n(), length);
    this.r1r(this.n() + length | 0);
  };
  protoOf(FloatArrayList).a1t = function (values, offset, length, $super) {
    offset = offset === VOID ? 0 : offset;
    length = length === VOID ? values.length : length;
    var tmp;
    if ($super === VOID) {
      this.c1t(values, offset, length);
      tmp = Unit_instance;
    } else {
      tmp = $super.c1t.call(this, values, offset, length);
    }
    return tmp;
  };
  protoOf(FloatArrayList).b1r = function (index) {
    return this.y1s_1[index];
  };
  protoOf(FloatArrayList).u = function () {
    return this.w1(0);
  };
  protoOf(FloatArrayList).e1t = function (element) {
    var inductionVariable = 0;
    var last = this.z1s_1;
    if (inductionVariable < last)
      do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        if (this.y1s_1[n] === element)
          return true;
      }
       while (inductionVariable < last);
    return false;
  };
  protoOf(FloatArrayList).f1t = function (elements) {
    var tmp0_iterator = elements.u();
    while (tmp0_iterator.v()) {
      var e = tmp0_iterator.x();
      if (!this.e1t(e))
        return false;
    }
    return true;
  };
  protoOf(FloatArrayList).a1 = function (elements) {
    return this.f1t(elements);
  };
  protoOf(FloatArrayList).b1 = function () {
    return this.n() === 0;
  };
  protoOf(FloatArrayList).g1t = function () {
    return copyOf_1(this.y1s_1, this.z1s_1);
  };
  protoOf(FloatArrayList).w1 = function (index) {
    return take_1(this.y1s_1, this.z1s_1).w1(index);
  };
  protoOf(FloatArrayList).hashCode = function () {
    return contentHashCode_5(this.y1s_1, 0, this.n());
  };
  protoOf(FloatArrayList).equals = function (other) {
    if (other instanceof FloatArrayList)
      return this.n() === other.n() ? contentEquals_5(this.y1s_1, other.y1s_1, 0, this.n()) : false;
    if (!(other == null) ? isInterface(other, List) : false)
      return equals(other, this);
    return false;
  };
  protoOf(FloatArrayList).toString = function () {
    // Inline function 'kotlin.also' call
    var this_0 = StringBuilder_init_$Create$(2 + imul(5, this.n()) | 0);
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.datastructure.FloatArrayList.toString.<anonymous>' call
    this_0.v5(_Char___init__impl__6a9atx(91));
    var inductionVariable = 0;
    var last = this.n();
    if (inductionVariable < last)
      do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        if (!(n === 0)) {
          this_0.u5(', ');
        }
        this_0.l8(this.b1r(n));
      }
       while (inductionVariable < last);
    this_0.v5(_Char___init__impl__6a9atx(93));
    return this_0.toString();
  };
  function floatArrayListOf(values) {
    return FloatArrayList_init_$Create$(values.slice());
  }
  function doubleArrayListOf(values) {
    return DoubleArrayList_init_$Create$_0(values.slice());
  }
  function sort(_this__u8e3s4, start, end, reversed) {
    start = start === VOID ? 0 : start;
    end = end === VOID ? _this__u8e3s4.n() : end;
    reversed = reversed === VOID ? false : reversed;
    return genericSort_0(_this__u8e3s4, start, end - 1 | 0, DoubleArrayListSortOps_getInstance(), reversed);
  }
  function reverse_0(_this__u8e3s4, start, end) {
    start = start === VOID ? 0 : start;
    end = end === VOID ? _this__u8e3s4.n() : end;
    return DoubleArrayListSortOps_getInstance().h1t(_this__u8e3s4, start, end - 1 | 0);
  }
  function DoubleArrayListSortOps() {
    DoubleArrayListSortOps_instance = this;
    SortOps.call(this);
  }
  protoOf(DoubleArrayListSortOps).i1t = function (subject, l, r) {
    return compareTo(subject.b1r(l), subject.b1r(r));
  };
  protoOf(DoubleArrayListSortOps).j1t = function (subject, l, r) {
    return this.i1t(subject instanceof DoubleArrayList ? subject : THROW_CCE(), l, r);
  };
  protoOf(DoubleArrayListSortOps).k1t = function (subject, indexL, indexR) {
    var l = subject.b1r(indexL);
    var r = subject.b1r(indexR);
    subject.a1s(indexR, l);
    subject.a1s(indexL, r);
  };
  protoOf(DoubleArrayListSortOps).l1t = function (subject, indexL, indexR) {
    return this.k1t(subject instanceof DoubleArrayList ? subject : THROW_CCE(), indexL, indexR);
  };
  var DoubleArrayListSortOps_instance;
  function DoubleArrayListSortOps_getInstance() {
    if (DoubleArrayListSortOps_instance == null)
      new DoubleArrayListSortOps();
    return DoubleArrayListSortOps_instance;
  }
  function CaseInsensitiveStringMap_init_$Init$($this) {
    CaseInsensitiveStringMap.call($this, LinkedHashMap_init_$Create$(), LinkedHashMap_init_$Create$(), LinkedHashMap_init_$Create$());
    return $this;
  }
  function CaseInsensitiveStringMap_init_$Create$() {
    return CaseInsensitiveStringMap_init_$Init$(objectCreate(protoOf(CaseInsensitiveStringMap)));
  }
  function CaseInsensitiveStringMap(mapOrig, lcToOrig, mapLC) {
    this.n1t_1 = mapOrig;
    this.o1t_1 = lcToOrig;
    this.p1t_1 = mapLC;
  }
  protoOf(CaseInsensitiveStringMap).k2 = function () {
    return this.n1t_1.k2();
  };
  protoOf(CaseInsensitiveStringMap).g2 = function () {
    return this.n1t_1.g2();
  };
  protoOf(CaseInsensitiveStringMap).n = function () {
    return this.n1t_1.n();
  };
  protoOf(CaseInsensitiveStringMap).h2 = function () {
    return this.n1t_1.h2();
  };
  protoOf(CaseInsensitiveStringMap).b1 = function () {
    return this.n1t_1.b1();
  };
  protoOf(CaseInsensitiveStringMap).r13 = function (key) {
    // Inline function 'kotlin.text.toLowerCase' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$1 = key.toLowerCase();
    return this.p1t_1.p2(tmp$ret$1);
  };
  protoOf(CaseInsensitiveStringMap).p2 = function (key) {
    if (!(!(key == null) ? typeof key === 'string' : false))
      return false;
    return this.r13((!(key == null) ? typeof key === 'string' : false) ? key : THROW_CCE());
  };
  protoOf(CaseInsensitiveStringMap).s13 = function (key) {
    // Inline function 'kotlin.text.toLowerCase' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$1 = key.toLowerCase();
    return this.p1t_1.s2(tmp$ret$1);
  };
  protoOf(CaseInsensitiveStringMap).s2 = function (key) {
    if (!(!(key == null) ? typeof key === 'string' : false))
      return null;
    return this.s13((!(key == null) ? typeof key === 'string' : false) ? key : THROW_CCE());
  };
  protoOf(CaseInsensitiveStringMap).q1t = function (key, value) {
    this.r1t(key);
    // Inline function 'kotlin.collections.set' call
    this.n1t_1.i2(key, value);
    // Inline function 'kotlin.collections.set' call
    var this_0 = this.o1t_1;
    // Inline function 'kotlin.text.toLowerCase' call
    // Inline function 'kotlin.js.asDynamic' call
    var key_0 = key.toLowerCase();
    this_0.i2(key_0, key);
    // Inline function 'kotlin.text.toLowerCase' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$3 = key.toLowerCase();
    return this.p1t_1.i2(tmp$ret$3, value);
  };
  protoOf(CaseInsensitiveStringMap).i2 = function (key, value) {
    var tmp = (!(key == null) ? typeof key === 'string' : false) ? key : THROW_CCE();
    return this.q1t(tmp, (value == null ? true : !(value == null)) ? value : THROW_CCE());
  };
  protoOf(CaseInsensitiveStringMap).s1t = function (from) {
    // Inline function 'kotlin.collections.iterator' call
    var tmp0_iterator = from.k2().u();
    while (tmp0_iterator.v()) {
      var v = tmp0_iterator.x();
      this.q1t(v.l2(), v.m2());
    }
  };
  protoOf(CaseInsensitiveStringMap).r1t = function (key) {
    // Inline function 'kotlin.text.toLowerCase' call
    // Inline function 'kotlin.js.asDynamic' call
    var lkey = key.toLowerCase();
    var okey = this.o1t_1.s2(lkey);
    // Inline function 'kotlin.collections.remove' call
    var this_0 = this.n1t_1;
    (isInterface(this_0, MutableMap) ? this_0 : THROW_CCE()).j2(okey);
    var res = this.p1t_1.j2(lkey);
    this.o1t_1.j2(lkey);
    return res;
  };
  protoOf(CaseInsensitiveStringMap).j2 = function (key) {
    if (!(!(key == null) ? typeof key === 'string' : false))
      return null;
    return this.r1t((!(key == null) ? typeof key === 'string' : false) ? key : THROW_CCE());
  };
  protoOf(CaseInsensitiveStringMap).equals = function (other) {
    var tmp;
    if (other instanceof CaseInsensitiveStringMap) {
      tmp = equals(this.p1t_1, other.p1t_1);
    } else {
      tmp = false;
    }
    return tmp;
  };
  protoOf(CaseInsensitiveStringMap).hashCode = function () {
    return hashCode(this.p1t_1);
  };
  function toCaseInsensitiveMap(_this__u8e3s4) {
    // Inline function 'kotlin.also' call
    var this_0 = CaseInsensitiveStringMap_init_$Create$();
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.datastructure.toCaseInsensitiveMap.<anonymous>' call
    this_0.s1t(_this__u8e3s4);
    return this_0;
  }
  function _get__data__kyoi3c($this) {
    // Inline function 'korlibs.datastructure.fastCastTo' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return $this.v1t_1;
  }
  function _get_capacity__a9k9f3($this) {
    return $this.v1t_1.length;
  }
  function TGenDeque_init_$Init$($this) {
    TGenDeque.call($this, 16);
    return $this;
  }
  function TGenDeque_init_$Create$() {
    return TGenDeque_init_$Init$(objectCreate(protoOf(TGenDeque)));
  }
  function resizeIfRequiredFor($this, count) {
    if (($this.n() + count | 0) > _get_capacity__a9k9f3($this)) {
      var i = $this.v1t_1;
      var istart = $this.t1t_1;
      // Inline function 'kotlin.arrayOfNulls' call
      // Inline function 'kotlin.comparisons.maxOf' call
      var a = $this.v1t_1.length + 7 | 0;
      // Inline function 'kotlin.comparisons.maxOf' call
      var a_0 = $this.n() + count | 0;
      var b = imul($this.v1t_1.length, 2);
      var b_0 = Math.max(a_0, b);
      var size = Math.max(a, b_0);
      var _o = fillArrayVal(Array(size), null);
      var o = isArray(_o) ? _o : THROW_CCE();
      copyCyclic($this, i, istart, o, $this.u1t_1);
      $this.v1t_1 = o;
      $this.t1t_1 = 0;
    }
  }
  function copyCyclic($this, i, istart, o, count) {
    // Inline function 'kotlin.math.min' call
    var a = i.length - istart | 0;
    var size1 = Math.min(a, count);
    var size2 = count - size1 | 0;
    Memory_instance.w1t(i, istart, o, 0, size1);
    if (size2 > 0) {
      Memory_instance.w1t(i, 0, o, size1, size2);
    }
  }
  function _addLast($this, item) {
    $this.v1t_1[($this.t1t_1 + $this.u1t_1 | 0) % _get_capacity__a9k9f3($this) | 0] = item;
    $this.u1t_1 = $this.u1t_1 + 1 | 0;
  }
  function nullify($this, index) {
    _get__data__kyoi3c($this)[index] = null;
  }
  function _removeRetainAll($this, elements, retain) {
    var eset = toSet(elements);
    // Inline function 'kotlin.collections.copyOf' call
    // Inline function 'kotlin.js.asDynamic' call
    var _temp = $this.v1t_1.slice();
    var tsize = 0;
    var osize = $this.n();
    var inductionVariable = 0;
    var last = $this.n();
    if (inductionVariable < last)
      do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var c = $this.f1(n);
        if (eset.z(c) === retain) {
          var tmp1 = tsize;
          tsize = tmp1 + 1 | 0;
          _temp[tmp1] = c;
        }
      }
       while (inductionVariable < last);
    $this.v1t_1 = _temp;
    $this.t1t_1 = 0;
    $this.u1t_1 = tsize;
    return !(tsize === osize);
  }
  function internalIndex($this, index) {
    return Math_instance.m1r($this.t1t_1 + index | 0, _get_capacity__a9k9f3($this));
  }
  function TGenDeque$iterator$1($that, this$0) {
    this.y1t_1 = $that;
    this.z1t_1 = this$0;
    this.x1t_1 = 0;
  }
  protoOf(TGenDeque$iterator$1).x = function () {
    var tmp1 = this.x1t_1;
    this.x1t_1 = tmp1 + 1 | 0;
    return this.y1t_1.f1(tmp1);
  };
  protoOf(TGenDeque$iterator$1).v = function () {
    return this.x1t_1 < this.z1t_1.n();
  };
  protoOf(TGenDeque$iterator$1).w = function () {
    this.x1t_1 = this.x1t_1 - 1 | 0;
    this.z1t_1.h1(this.x1t_1);
  };
  function TGenDeque(initialCapacity) {
    this.t1t_1 = 0;
    this.u1t_1 = 0;
    var tmp = this;
    // Inline function 'kotlin.arrayOfNulls' call
    var tmp_0 = fillArrayVal(Array(initialCapacity), null);
    tmp.v1t_1 = isArray(tmp_0) ? tmp_0 : THROW_CCE();
  }
  protoOf(TGenDeque).n = function () {
    return this.u1t_1;
  };
  protoOf(TGenDeque).b1 = function () {
    return this.n() === 0;
  };
  protoOf(TGenDeque).a1u = function (item) {
    resizeIfRequiredFor(this, 1);
    _addLast(this, item);
  };
  protoOf(TGenDeque).b1u = function (list) {
    // Inline function 'korlibs.datastructure.TGenDeque._addAll' call
    var count = list.n();
    resizeIfRequiredFor(this, count);
    var base = this.t1t_1 + this.u1t_1 | 0;
    var inductionVariable = 0;
    if (inductionVariable < count)
      do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var tmp = this.v1t_1;
        var tmp_0 = (base + n | 0) % _get_capacity__a9k9f3(this) | 0;
        // Inline function 'korlibs.datastructure.TGenDeque.addAll.<anonymous>' call
        tmp[tmp_0] = list.f1(n);
      }
       while (inductionVariable < count);
    this.u1t_1 = this.u1t_1 + count | 0;
    return true;
  };
  protoOf(TGenDeque).c1u = function (elements) {
    return this.b1u(toList(elements));
  };
  protoOf(TGenDeque).y = function (elements) {
    return this.c1u(elements);
  };
  protoOf(TGenDeque).hf = function () {
    if (this.u1t_1 <= 0)
      throw IndexOutOfBoundsException_init_$Create$();
    var out = this.d1u();
    nullify(this, this.t1t_1);
    this.t1t_1 = (this.t1t_1 + 1 | 0) % _get_capacity__a9k9f3(this) | 0;
    this.u1t_1 = this.u1t_1 - 1 | 0;
    return out;
  };
  protoOf(TGenDeque).jf = function () {
    if (this.u1t_1 <= 0)
      throw IndexOutOfBoundsException_init_$Create$();
    var out = this.e1u();
    nullify(this, internalIndex(this, this.n() - 1 | 0));
    this.u1t_1 = this.u1t_1 - 1 | 0;
    return out;
  };
  protoOf(TGenDeque).h1 = function (index) {
    if (index < 0 ? true : index >= this.n())
      throw IndexOutOfBoundsException_init_$Create$();
    if (index === 0)
      return this.hf();
    if (index === (this.n() - 1 | 0))
      return this.jf();
    var old = this.f1(index);
    if (index < (this.n() / 2 | 0)) {
      var inductionVariable = index;
      if (1 <= inductionVariable)
        do {
          var n = inductionVariable;
          inductionVariable = inductionVariable + -1 | 0;
          this.f1u(n, this.f1(n - 1 | 0));
        }
         while (1 <= inductionVariable);
      this.t1t_1 = Math_instance.m1r(this.t1t_1 + 1 | 0, _get_capacity__a9k9f3(this));
    } else {
      var inductionVariable_0 = index;
      var last = this.n() - 1 | 0;
      if (inductionVariable_0 < last)
        do {
          var n_0 = inductionVariable_0;
          inductionVariable_0 = inductionVariable_0 + 1 | 0;
          this.f1u(n_0, this.f1(n_0 + 1 | 0));
        }
         while (inductionVariable_0 < last);
    }
    this.u1t_1 = this.u1t_1 - 1 | 0;
    return old;
  };
  protoOf(TGenDeque).g1u = function (element) {
    // Inline function 'kotlin.apply' call
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.datastructure.TGenDeque.add.<anonymous>' call
    this.a1u(element);
    return true;
  };
  protoOf(TGenDeque).r = function (element) {
    return this.g1u((element == null ? true : !(element == null)) ? element : THROW_CCE());
  };
  protoOf(TGenDeque).b3 = function () {
    this.u1t_1 = 0;
  };
  protoOf(TGenDeque).h1u = function (element) {
    var index = this.i1u(element);
    if (index >= 0) {
      this.h1(index);
    }
    return index >= 0;
  };
  protoOf(TGenDeque).s = function (element) {
    if (!(element == null ? true : !(element == null)))
      return false;
    return this.h1u((element == null ? true : !(element == null)) ? element : THROW_CCE());
  };
  protoOf(TGenDeque).j1u = function (elements) {
    return _removeRetainAll(this, elements, false);
  };
  protoOf(TGenDeque).d1u = function () {
    return this.v1t_1[this.t1t_1];
  };
  protoOf(TGenDeque).e1u = function () {
    return this.v1t_1[internalIndex(this, this.n() - 1 | 0)];
  };
  protoOf(TGenDeque).f1u = function (index, value) {
    this.v1t_1[internalIndex(this, index)] = value;
  };
  protoOf(TGenDeque).f1 = function (index) {
    return this.v1t_1[internalIndex(this, index)];
  };
  protoOf(TGenDeque).i1u = function (element) {
    var inductionVariable = 0;
    var last = this.n();
    if (inductionVariable < last)
      do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        if (equals(this.f1(n), element))
          return n;
      }
       while (inductionVariable < last);
    return -1;
  };
  protoOf(TGenDeque).k1u = function (elements) {
    // Inline function 'kotlin.collections.map' call
    // Inline function 'kotlin.collections.mapTo' call
    var destination = ArrayList_init_$Create$(collectionSizeOrDefault(elements, 10));
    var tmp0_iterator = elements.u();
    while (tmp0_iterator.v()) {
      var item = tmp0_iterator.x();
      // Inline function 'korlibs.datastructure.TGenDeque.containsAll.<anonymous>' call
      var tmp$ret$0 = to(item, 0);
      destination.r(tmp$ret$0);
    }
    var emap = toLinkedMap_0(destination);
    var inductionVariable = 0;
    var last = this.n();
    if (inductionVariable < last)
      do {
        var it = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var e = this.f1(it);
        // Inline function 'kotlin.collections.contains' call
        // Inline function 'kotlin.collections.containsKey' call
        if ((isInterface(emap, Map_0) ? emap : THROW_CCE()).p2(e)) {
          // Inline function 'kotlin.collections.set' call
          emap.i2(e, 1);
        }
      }
       while (inductionVariable < last);
    var tmp$ret$5;
    $l$block_0: {
      // Inline function 'kotlin.collections.all' call
      var this_0 = emap.h2();
      var tmp;
      if (isInterface(this_0, Collection)) {
        tmp = this_0.b1();
      } else {
        tmp = false;
      }
      if (tmp) {
        tmp$ret$5 = true;
        break $l$block_0;
      }
      var tmp0_iterator_0 = this_0.u();
      while (tmp0_iterator_0.v()) {
        var element = tmp0_iterator_0.x();
        // Inline function 'korlibs.datastructure.TGenDeque.containsAll.<anonymous>' call
        if (!(element === 1)) {
          tmp$ret$5 = false;
          break $l$block_0;
        }
      }
      tmp$ret$5 = true;
    }
    return tmp$ret$5;
  };
  protoOf(TGenDeque).a1 = function (elements) {
    return this.k1u(elements);
  };
  protoOf(TGenDeque).u = function () {
    var that = this;
    return new TGenDeque$iterator$1(that, this);
  };
  protoOf(TGenDeque).hashCode = function () {
    // Inline function 'korlibs.datastructure.internal.contentHashCode' call
    var size = this.n();
    var result = 1;
    var inductionVariable = 0;
    if (inductionVariable < size)
      do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var tmp = imul(31, result);
        // Inline function 'kotlin.hashCode' call
        // Inline function 'korlibs.datastructure.TGenDeque.hashCode.<anonymous>' call
        var tmp0_safe_receiver = this.f1(n);
        var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : hashCode(tmp0_safe_receiver);
        result = tmp + (tmp1_elvis_lhs == null ? 0 : tmp1_elvis_lhs) | 0;
      }
       while (inductionVariable < size);
    return result;
  };
  protoOf(TGenDeque).equals = function (other) {
    if (!(other instanceof TGenDeque))
      return false;
    if (!(other.n() === this.n()))
      return false;
    var inductionVariable = 0;
    var last = this.n();
    if (inductionVariable < last)
      do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        if (!equals(this.f1(n), other.f1(n)))
          return false;
      }
       while (inductionVariable < last);
    return true;
  };
  protoOf(TGenDeque).toString = function () {
    var sb = StringBuilder_init_$Create$_0();
    sb.v5(_Char___init__impl__6a9atx(91));
    var inductionVariable = 0;
    var last = this.n();
    if (inductionVariable < last)
      do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        sb.t5(this.f1(n));
        if (!(n === (this.n() - 1 | 0))) {
          sb.u5(', ');
        }
      }
       while (inductionVariable < last);
    sb.v5(_Char___init__impl__6a9atx(93));
    return sb.toString();
  };
  function _get__data__kyoi3c_0($this) {
    // Inline function 'korlibs.datastructure.fastCastTo' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return $this.n1u_1;
  }
  function _get_capacity__a9k9f3_0($this) {
    return $this.n1u_1.length;
  }
  function IntDeque_init_$Init$($this) {
    IntDeque.call($this, 16);
    return $this;
  }
  function IntDeque_init_$Create$() {
    return IntDeque_init_$Init$(objectCreate(protoOf(IntDeque)));
  }
  function resizeIfRequiredFor_0($this, count) {
    if (($this.n() + count | 0) > _get_capacity__a9k9f3_0($this)) {
      var i = $this.n1u_1;
      var istart = $this.l1u_1;
      // Inline function 'kotlin.comparisons.maxOf' call
      var a = $this.n1u_1.length + 7 | 0;
      // Inline function 'kotlin.comparisons.maxOf' call
      var a_0 = $this.n() + count | 0;
      var b = imul($this.n1u_1.length, 2);
      var b_0 = Math.max(a_0, b);
      var tmp$ret$1 = Math.max(a, b_0);
      var _o = new Int32Array(tmp$ret$1);
      var o = isIntArray(_o) ? _o : THROW_CCE();
      copyCyclic_0($this, i, istart, o, $this.m1u_1);
      $this.n1u_1 = o;
      $this.l1u_1 = 0;
    }
  }
  function copyCyclic_0($this, i, istart, o, count) {
    // Inline function 'kotlin.math.min' call
    var a = i.length - istart | 0;
    var size1 = Math.min(a, count);
    var size2 = count - size1 | 0;
    Memory_instance.q1s(i, istart, o, 0, size1);
    if (size2 > 0) {
      Memory_instance.q1s(i, 0, o, size1, size2);
    }
  }
  function _addLast_0($this, item) {
    $this.n1u_1[($this.l1u_1 + $this.m1u_1 | 0) % _get_capacity__a9k9f3_0($this) | 0] = item;
    $this.m1u_1 = $this.m1u_1 + 1 | 0;
  }
  function nullify_0($this, index) {
    _get__data__kyoi3c_0($this)[index] = 0;
  }
  function internalIndex_0($this, index) {
    return Math_instance.m1r($this.l1u_1 + index | 0, _get_capacity__a9k9f3_0($this));
  }
  function IntDeque$iterator$1($that, this$0) {
    this.p1u_1 = $that;
    this.q1u_1 = this$0;
    this.o1u_1 = 0;
  }
  protoOf(IntDeque$iterator$1).x = function () {
    var tmp1 = this.o1u_1;
    this.o1u_1 = tmp1 + 1 | 0;
    return this.p1u_1.f1(tmp1);
  };
  protoOf(IntDeque$iterator$1).v = function () {
    return this.o1u_1 < this.q1u_1.n();
  };
  protoOf(IntDeque$iterator$1).w = function () {
    this.o1u_1 = this.o1u_1 - 1 | 0;
    this.q1u_1.h1(this.o1u_1);
  };
  function IntDeque(initialCapacity) {
    this.l1u_1 = 0;
    this.m1u_1 = 0;
    var tmp = this;
    var tmp_0 = new Int32Array(initialCapacity);
    tmp.n1u_1 = isIntArray(tmp_0) ? tmp_0 : THROW_CCE();
  }
  protoOf(IntDeque).n = function () {
    return this.m1u_1;
  };
  protoOf(IntDeque).b1 = function () {
    return this.n() === 0;
  };
  protoOf(IntDeque).r1u = function (item) {
    resizeIfRequiredFor_0(this, 1);
    _addLast_0(this, item);
  };
  protoOf(IntDeque).s1u = function (list) {
    // Inline function 'korlibs.datastructure.IntDeque._addAll' call
    var count = list.n();
    resizeIfRequiredFor_0(this, count);
    var base = this.l1u_1 + this.m1u_1 | 0;
    var inductionVariable = 0;
    if (inductionVariable < count)
      do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var tmp = this.n1u_1;
        var tmp_0 = (base + n | 0) % _get_capacity__a9k9f3_0(this) | 0;
        // Inline function 'korlibs.datastructure.IntDeque.addAll.<anonymous>' call
        tmp[tmp_0] = list.f1(n);
      }
       while (inductionVariable < count);
    this.m1u_1 = this.m1u_1 + count | 0;
    return true;
  };
  protoOf(IntDeque).t1u = function (elements) {
    return this.s1u(toList(elements));
  };
  protoOf(IntDeque).y = function (elements) {
    return this.t1u(elements);
  };
  protoOf(IntDeque).hf = function () {
    if (this.m1u_1 <= 0)
      throw IndexOutOfBoundsException_init_$Create$();
    var out = this.d1u();
    nullify_0(this, this.l1u_1);
    this.l1u_1 = (this.l1u_1 + 1 | 0) % _get_capacity__a9k9f3_0(this) | 0;
    this.m1u_1 = this.m1u_1 - 1 | 0;
    return out;
  };
  protoOf(IntDeque).jf = function () {
    if (this.m1u_1 <= 0)
      throw IndexOutOfBoundsException_init_$Create$();
    var out = this.e1u();
    nullify_0(this, internalIndex_0(this, this.n() - 1 | 0));
    this.m1u_1 = this.m1u_1 - 1 | 0;
    return out;
  };
  protoOf(IntDeque).h1 = function (index) {
    if (index < 0 ? true : index >= this.n())
      throw IndexOutOfBoundsException_init_$Create$();
    if (index === 0)
      return this.hf();
    if (index === (this.n() - 1 | 0))
      return this.jf();
    var old = this.f1(index);
    if (index < (this.n() / 2 | 0)) {
      var inductionVariable = index;
      if (1 <= inductionVariable)
        do {
          var n = inductionVariable;
          inductionVariable = inductionVariable + -1 | 0;
          this.r1s(n, this.f1(n - 1 | 0));
        }
         while (1 <= inductionVariable);
      this.l1u_1 = Math_instance.m1r(this.l1u_1 + 1 | 0, _get_capacity__a9k9f3_0(this));
    } else {
      var inductionVariable_0 = index;
      var last = this.n() - 1 | 0;
      if (inductionVariable_0 < last)
        do {
          var n_0 = inductionVariable_0;
          inductionVariable_0 = inductionVariable_0 + 1 | 0;
          this.r1s(n_0, this.f1(n_0 + 1 | 0));
        }
         while (inductionVariable_0 < last);
    }
    this.m1u_1 = this.m1u_1 - 1 | 0;
    return old;
  };
  protoOf(IntDeque).u1u = function (element) {
    // Inline function 'kotlin.apply' call
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.datastructure.IntDeque.add.<anonymous>' call
    this.r1u(element);
    return true;
  };
  protoOf(IntDeque).r = function (element) {
    return this.u1u((!(element == null) ? typeof element === 'number' : false) ? element : THROW_CCE());
  };
  protoOf(IntDeque).v1u = function (element) {
    var index = this.w1u(element);
    if (index >= 0) {
      this.h1(index);
    }
    return index >= 0;
  };
  protoOf(IntDeque).s = function (element) {
    if (!(!(element == null) ? typeof element === 'number' : false))
      return false;
    return this.v1u((!(element == null) ? typeof element === 'number' : false) ? element : THROW_CCE());
  };
  protoOf(IntDeque).d1u = function () {
    return this.n1u_1[this.l1u_1];
  };
  protoOf(IntDeque).e1u = function () {
    return this.n1u_1[internalIndex_0(this, this.n() - 1 | 0)];
  };
  protoOf(IntDeque).r1s = function (index, value) {
    this.n1u_1[internalIndex_0(this, index)] = value;
  };
  protoOf(IntDeque).f1 = function (index) {
    return this.n1u_1[internalIndex_0(this, index)];
  };
  protoOf(IntDeque).w1u = function (element) {
    var inductionVariable = 0;
    var last = this.n();
    if (inductionVariable < last)
      do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        if (this.f1(n) === element)
          return n;
      }
       while (inductionVariable < last);
    return -1;
  };
  protoOf(IntDeque).s1s = function (elements) {
    // Inline function 'kotlin.collections.map' call
    // Inline function 'kotlin.collections.mapTo' call
    var destination = ArrayList_init_$Create$(collectionSizeOrDefault(elements, 10));
    var tmp0_iterator = elements.u();
    while (tmp0_iterator.v()) {
      var item = tmp0_iterator.x();
      // Inline function 'korlibs.datastructure.IntDeque.containsAll.<anonymous>' call
      var tmp$ret$0 = to(item, 0);
      destination.r(tmp$ret$0);
    }
    var emap = toLinkedMap_0(destination);
    var inductionVariable = 0;
    var last = this.n();
    if (inductionVariable < last)
      do {
        var it = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var e = this.f1(it);
        // Inline function 'kotlin.collections.contains' call
        // Inline function 'kotlin.collections.containsKey' call
        if ((isInterface(emap, Map_0) ? emap : THROW_CCE()).p2(e)) {
          // Inline function 'kotlin.collections.set' call
          emap.i2(e, 1);
        }
      }
       while (inductionVariable < last);
    var tmp$ret$5;
    $l$block_0: {
      // Inline function 'kotlin.collections.all' call
      var this_0 = emap.h2();
      var tmp;
      if (isInterface(this_0, Collection)) {
        tmp = this_0.b1();
      } else {
        tmp = false;
      }
      if (tmp) {
        tmp$ret$5 = true;
        break $l$block_0;
      }
      var tmp0_iterator_0 = this_0.u();
      while (tmp0_iterator_0.v()) {
        var element = tmp0_iterator_0.x();
        // Inline function 'korlibs.datastructure.IntDeque.containsAll.<anonymous>' call
        if (!(element === 1)) {
          tmp$ret$5 = false;
          break $l$block_0;
        }
      }
      tmp$ret$5 = true;
    }
    return tmp$ret$5;
  };
  protoOf(IntDeque).a1 = function (elements) {
    return this.s1s(elements);
  };
  protoOf(IntDeque).u = function () {
    var that = this;
    return new IntDeque$iterator$1(that, this);
  };
  protoOf(IntDeque).hashCode = function () {
    // Inline function 'korlibs.datastructure.internal.contentHashCode' call
    var size = this.n();
    var result = 1;
    var inductionVariable = 0;
    if (inductionVariable < size)
      do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var tmp = imul(31, result);
        // Inline function 'kotlin.hashCode' call
        // Inline function 'korlibs.datastructure.IntDeque.hashCode.<anonymous>' call
        var tmp0_safe_receiver = this.f1(n);
        var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : hashCode(tmp0_safe_receiver);
        result = tmp + (tmp1_elvis_lhs == null ? 0 : tmp1_elvis_lhs) | 0;
      }
       while (inductionVariable < size);
    return result;
  };
  protoOf(IntDeque).equals = function (other) {
    if (!(other instanceof IntDeque))
      return false;
    if (!(other.n() === this.n()))
      return false;
    var inductionVariable = 0;
    var last = this.n();
    if (inductionVariable < last)
      do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        if (!(this.f1(n) === other.f1(n)))
          return false;
      }
       while (inductionVariable < last);
    return true;
  };
  protoOf(IntDeque).toString = function () {
    var sb = StringBuilder_init_$Create$_0();
    sb.v5(_Char___init__impl__6a9atx(91));
    var inductionVariable = 0;
    var last = this.n();
    if (inductionVariable < last)
      do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        sb.j8(this.f1(n));
        if (!(n === (this.n() - 1 | 0))) {
          sb.u5(', ');
        }
      }
       while (inductionVariable < last);
    sb.v5(_Char___init__impl__6a9atx(93));
    return sb.toString();
  };
  function fastArrayListOf(values) {
    // Inline function 'kotlin.also' call
    var this_0 = FastArrayList_init_$Create$_0(values.length);
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.datastructure.fastArrayListOf.<anonymous>' call
    addAll(this_0, values);
    return this_0;
  }
  function toFastList(_this__u8e3s4) {
    // Inline function 'kotlin.also' call
    var this_0 = FastArrayList_init_$Create$_0(_this__u8e3s4.n());
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.datastructure.toFastList.<anonymous>' call
    // Inline function 'korlibs.datastructure.iterators.fastForEach' call
    var n = 0;
    while (n < _this__u8e3s4.n()) {
      // Inline function 'korlibs.datastructure.toFastList.<anonymous>.<anonymous>' call
      var tmp0 = n;
      n = tmp0 + 1 | 0;
      var it = _this__u8e3s4.f1(tmp0);
      this_0.r(it);
    }
    return this_0;
  }
  function toFastList_0(_this__u8e3s4) {
    // Inline function 'kotlin.also' call
    var this_0 = FastArrayList_init_$Create$_0(_this__u8e3s4.length);
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.datastructure.toFastList.<anonymous>' call
    // Inline function 'korlibs.datastructure.iterators.fastForEach' call
    var n = 0;
    while (n < _this__u8e3s4.length) {
      // Inline function 'korlibs.datastructure.toFastList.<anonymous>.<anonymous>' call
      var tmp0 = n;
      n = tmp0 + 1 | 0;
      var it = _this__u8e3s4[tmp0];
      this_0.r(it);
    }
    return this_0;
  }
  function toFastList_1(_this__u8e3s4, out) {
    out = out === VOID ? FastArrayList_init_$Create$() : out;
    out.z1u(0, _this__u8e3s4);
    out.a1v(_this__u8e3s4.n());
    return out;
  }
  function MutableListEx() {
  }
  function FastIdentityCacheMap() {
    this.f1v_1 = null;
    this.g1v_1 = null;
    this.h1v_1 = null;
    this.i1v_1 = null;
    this.j1v_1 = FastIdentityMap();
  }
  protoOf(FastIdentityCacheMap).b3 = function () {
    this.k1v();
    clear(this.j1v_1);
  };
  protoOf(FastIdentityCacheMap).k1v = function () {
    this.f1v_1 = null;
    this.g1v_1 = null;
    this.h1v_1 = null;
    this.i1v_1 = null;
  };
  function getAndRemove(_this__u8e3s4, key) {
    // Inline function 'kotlin.also' call
    var this_0 = get(_this__u8e3s4, key);
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.datastructure.getAndRemove.<anonymous>' call
    remove(_this__u8e3s4, key);
    return this_0;
  }
  function get_keys(_this__u8e3s4) {
    return keys(_this__u8e3s4);
  }
  function get_keys_0(_this__u8e3s4) {
    return keys_0(_this__u8e3s4);
  }
  function get_values(_this__u8e3s4) {
    return values(_this__u8e3s4);
  }
  function values(_this__u8e3s4) {
    // Inline function 'kotlin.collections.map' call
    var this_0 = keys_0(_this__u8e3s4);
    // Inline function 'kotlin.collections.mapTo' call
    var destination = ArrayList_init_$Create$(collectionSizeOrDefault(this_0, 10));
    var tmp0_iterator = this_0.u();
    while (tmp0_iterator.v()) {
      var item = tmp0_iterator.x();
      // Inline function 'korlibs.datastructure.values.<anonymous>' call
      // Inline function 'korlibs.datastructure.get' call
      // Inline function 'kotlin.js.asDynamic' call
      var tmp$ret$2 = _this__u8e3s4.get(item);
      destination.r(tmp$ret$2);
    }
    var tmp = destination;
    return isInterface(tmp, List) ? tmp : THROW_CCE();
  }
  function toLinkedMap(_this__u8e3s4) {
    var out = linkedHashMapOf([]);
    // Inline function 'korlibs.datastructure.fastForEachNullable' call
    // Inline function 'korlibs.datastructure.fastKeyForEach' call
    // Inline function 'kotlin.js.asDynamic' call
    var mapIterator = _this__u8e3s4.keys();
    $l$loop: while (true) {
      var v = mapIterator.next();
      if (v.done)
        break $l$loop;
      // Inline function 'korlibs.datastructure.fastForEachNullable.<anonymous>' call
      var it = v.value;
      // Inline function 'korlibs.datastructure.toLinkedMap.<anonymous>' call
      // Inline function 'korlibs.datastructure.get' call
      // Inline function 'kotlin.js.asDynamic' call
      var value = _this__u8e3s4.get(it);
      if (!(value == null)) {
        // Inline function 'kotlin.collections.set' call
        out.i2(it, value);
      }
    }
    return out;
  }
  function FastSmallSet() {
    AbstractMutableSet.call(this);
    this.l1v_1 = LinkedHashSet_init_$Create$();
    this.m1v_1 = null;
    this.n1v_1 = null;
    this.o1v_1 = null;
  }
  protoOf(FastSmallSet).n = function () {
    return this.l1v_1.n();
  };
  protoOf(FastSmallSet).u = function () {
    return this.l1v_1.u();
  };
  protoOf(FastSmallSet).p1v = function (element) {
    if (this.pf(element))
      return false;
    this.l1v_1.r(element);
    return true;
  };
  protoOf(FastSmallSet).r = function (element) {
    return this.p1v((element == null ? true : !(element == null)) ? element : THROW_CCE());
  };
  protoOf(FastSmallSet).q1v = function (element) {
    this.m1v_1 = null;
    this.n1v_1 = null;
    this.o1v_1 = null;
    this.l1v_1.s(element);
    return true;
  };
  protoOf(FastSmallSet).s = function (element) {
    if (!(element == null ? true : !(element == null)))
      return false;
    return this.q1v((element == null ? true : !(element == null)) ? element : THROW_CCE());
  };
  protoOf(FastSmallSet).pf = function (element) {
    if ((element === this.m1v_1 ? true : element === this.n1v_1) ? true : element === this.m1v_1)
      return true;
    var result = this.l1v_1.z(element);
    if (result) {
      this.n1v_1 = this.m1v_1;
      this.o1v_1 = this.n1v_1;
      this.m1v_1 = element;
    }
    return result;
  };
  protoOf(FastSmallSet).z = function (element) {
    if (!(element == null ? true : !(element == null)))
      return false;
    return this.pf((element == null ? true : !(element == null)) ? element : THROW_CCE());
  };
  protoOf(FastSmallSet).b3 = function () {
    this.l1v_1.b3();
    this.m1v_1 = null;
    this.n1v_1 = null;
    this.o1v_1 = null;
  };
  function translateIndex(_this__u8e3s4, $this) {
    if (!(0 <= _this__u8e3s4 ? _this__u8e3s4 < $this.n() : false))
      throw IndexOutOfBoundsException_init_$Create$_0('' + _this__u8e3s4);
    return $this.s1v_1 + _this__u8e3s4 | 0;
  }
  function GenericSubList(base, start, end) {
    this.r1v_1 = base;
    this.s1v_1 = start;
    this.t1v_1 = end;
    var containsUpper = this.r1v_1.n();
    var containsArg = this.s1v_1;
    if (!(0 <= containsArg ? containsArg <= containsUpper : false))
      throw IndexOutOfBoundsException_init_$Create$_0('' + this.s1v_1);
    var containsUpper_0 = this.r1v_1.n();
    var containsArg_0 = this.t1v_1;
    if (!(0 <= containsArg_0 ? containsArg_0 <= containsUpper_0 : false))
      throw IndexOutOfBoundsException_init_$Create$_0('' + this.t1v_1);
  }
  protoOf(GenericSubList).n = function () {
    return this.t1v_1 - this.s1v_1 | 0;
  };
  protoOf(GenericSubList).qf = function (elements) {
    var elementsSet = toMutableSet(elements);
    var inductionVariable = 0;
    var last = this.n();
    if (inductionVariable < last)
      do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        // Inline function 'kotlin.collections.minusAssign' call
        var element = this.f1(n);
        elementsSet.s(element);
      }
       while (inductionVariable < last);
    return elementsSet.b1();
  };
  protoOf(GenericSubList).a1 = function (elements) {
    return this.qf(elements);
  };
  protoOf(GenericSubList).f1 = function (index) {
    return this.r1v_1.f1(translateIndex(index, this));
  };
  protoOf(GenericSubList).b1 = function () {
    return this.n() === 0;
  };
  protoOf(GenericSubList).u = function () {
    return new GenericListIterator(this);
  };
  protoOf(GenericSubList).w1 = function (index) {
    return new GenericListIterator(this, index);
  };
  protoOf(GenericSubList).x1 = function (fromIndex, toIndex) {
    return new GenericSubList(this, fromIndex, toIndex);
  };
  protoOf(GenericSubList).toString = function () {
    // Inline function 'kotlin.collections.map' call
    var this_0 = until(0, this.n());
    // Inline function 'kotlin.collections.mapTo' call
    var destination = ArrayList_init_$Create$(collectionSizeOrDefault(this_0, 10));
    var tmp0_iterator = this_0.u();
    while (tmp0_iterator.v()) {
      var item = tmp0_iterator.x();
      // Inline function 'korlibs.datastructure.GenericSubList.toString.<anonymous>' call
      var tmp$ret$0 = this.f1(item);
      destination.r(tmp$ret$0);
    }
    return toString(destination);
  };
  protoOf(GenericSubList).equals = function (other) {
    var tmp;
    if (other instanceof GenericSubList) {
      var tmp$ret$1;
      $l$block: {
        // Inline function 'korlibs.datastructure.internal.equaler' call
        var count = this.n();
        var inductionVariable = 0;
        if (inductionVariable < count)
          do {
            var n = inductionVariable;
            inductionVariable = inductionVariable + 1 | 0;
            // Inline function 'korlibs.datastructure.GenericSubList.equals.<anonymous>' call
            if (!equals(this.f1(n), other.f1(n))) {
              tmp$ret$1 = false;
              break $l$block;
            }
          }
           while (inductionVariable < count);
        tmp$ret$1 = true;
      }
      tmp = tmp$ret$1;
    } else {
      tmp = false;
    }
    return tmp;
  };
  protoOf(GenericSubList).hashCode = function () {
    // Inline function 'korlibs.datastructure.internal.hashCoder' call
    var count = this.n();
    var out = 0;
    var inductionVariable = 0;
    if (inductionVariable < count)
      do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        out = imul(out, 7);
        var tmp = out;
        // Inline function 'korlibs.datastructure.GenericSubList.hashCode.<anonymous>' call
        // Inline function 'kotlin.hashCode' call
        var tmp0_safe_receiver = this.f1(n);
        var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : hashCode(tmp0_safe_receiver);
        out = tmp + (tmp1_elvis_lhs == null ? 0 : tmp1_elvis_lhs) | 0;
      }
       while (inductionVariable < count);
    return out;
  };
  function GenericListIterator(list, iindex) {
    iindex = iindex === VOID ? 0 : iindex;
    this.u1v_1 = list;
    this.v1v_1 = iindex;
    var containsUpper = this.u1v_1.n();
    var containsArg = this.v1v_1;
    if (!(0 <= containsArg ? containsArg < containsUpper : false))
      throw IndexOutOfBoundsException_init_$Create$_0('' + this.v1v_1);
    this.w1v_1 = this.v1v_1;
  }
  protoOf(GenericListIterator).v = function () {
    return this.w1v_1 < this.u1v_1.n();
  };
  protoOf(GenericListIterator).x = function () {
    if (!this.v())
      throw NoSuchElementException_init_$Create$();
    var tmp1 = this.w1v_1;
    this.w1v_1 = tmp1 + 1 | 0;
    return this.u1v_1.f1(tmp1);
  };
  protoOf(GenericListIterator).n1 = function () {
    return this.w1v_1 > 0;
  };
  protoOf(GenericListIterator).o1 = function () {
    if (!this.n1())
      throw NoSuchElementException_init_$Create$();
    this.w1v_1 = this.w1v_1 - 1 | 0;
    return this.u1v_1.f1(this.w1v_1);
  };
  protoOf(GenericListIterator).equals = function (other) {
    var tmp;
    var tmp_0;
    if (other instanceof GenericListIterator) {
      tmp_0 = equals(this.u1v_1, other.u1v_1);
    } else {
      tmp_0 = false;
    }
    if (tmp_0) {
      tmp = this.w1v_1 === other.w1v_1;
    } else {
      tmp = false;
    }
    return tmp;
  };
  protoOf(GenericListIterator).hashCode = function () {
    return hashCode(this.u1v_1) + this.w1v_1 | 0;
  };
  function Companion_4() {
  }
  protoOf(Companion_4).w1q = function (width, height, arraySize) {
    // Inline function 'kotlin.check' call
    // Inline function 'kotlin.contracts.contract' call
    if (!(arraySize >= imul(width, height))) {
      // Inline function 'korlibs.datastructure.Companion.checkArraySize.<anonymous>' call
      var message = 'backing array of size=' + arraySize + ', has less elements than ' + width + ' * ' + height;
      throw IllegalStateException_init_$Create$(toString(message));
    }
  };
  var Companion_instance_4;
  function Companion_getInstance_4() {
    return Companion_instance_4;
  }
  function IArray2$asString$lambda(this$0) {
    return function (y) {
      // Inline function 'kotlin.collections.map' call
      var this_0 = until(0, this$0.x1q());
      // Inline function 'kotlin.collections.mapTo' call
      var destination = ArrayList_init_$Create$(collectionSizeOrDefault(this_0, 10));
      var tmp0_iterator = this_0.u();
      while (tmp0_iterator.v()) {
        var item = tmp0_iterator.x();
        // Inline function 'korlibs.datastructure.IArray2.asString.<anonymous>.<anonymous>' call
        var tmp$ret$0 = this$0.f1r(item, y);
        destination.r(tmp$ret$0);
      }
      return joinToString(destination, ', ');
    };
  }
  function IArray2() {
  }
  function index(_this__u8e3s4, x, y) {
    if (!(0 <= x ? x < _this__u8e3s4.x1q() : false) ? true : !(0 <= y ? y < _this__u8e3s4.y1q() : false))
      throw IndexOutOfBoundsException_init_$Create$();
    return imul(y, _this__u8e3s4.x1q()) + x | 0;
  }
  function currentKey($this) {
    switch ($this.y1v_1) {
      case 2147483647:
      case 2147483646:
        return 0;
      default:
        return $this.x1v_1.h1w_1[$this.y1v_1];
    }
  }
  function currentValue($this) {
    switch ($this.y1v_1) {
      case 2147483647:
        return $this.x1v_1.e1w_1;
      case 2147483646:
        return null;
      default:
        return $this.x1v_1.i1w_1[$this.y1v_1];
    }
  }
  function nextNonEmptyIndex($this, keys, offset) {
    var inductionVariable = offset;
    var last = keys.length;
    if (inductionVariable < last)
      do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        if (!(keys[n] === 0))
          return n;
      }
       while (inductionVariable < last);
    return 2147483646;
  }
  function next($this) {
    if (!($this.y1v_1 === 2147483646))
      $this.y1v_1 = nextNonEmptyIndex($this, $this.x1v_1.h1w_1, $this.y1v_1 === 2147483647 ? 0 : $this.y1v_1 + 1 | 0);
  }
  function IntMap$_get_keys_$o$iterator$lambda_bn8atq($it) {
    return function () {
      return $it.v();
    };
  }
  function IntMap$_get_keys_$o$iterator$lambda_bn8atq_0($it) {
    return function () {
      return $it.l1w();
    };
  }
  function IntMap$_get_values_$o$iterator$lambda_ggo058($it) {
    return function () {
      return $it.v();
    };
  }
  function IntMap$_get_values_$o$iterator$lambda_ggo058_0($it) {
    return function () {
      return $it.m1w();
    };
  }
  function IntMap_init_$Init$(initialCapacity, loadFactor, $this) {
    initialCapacity = initialCapacity === VOID ? 16 : initialCapacity;
    loadFactor = loadFactor === VOID ? 0.75 : loadFactor;
    // Inline function 'kotlin.math.max' call
    var b = Math_instance.n1w(initialCapacity);
    var tmp$ret$0 = Math.max(4, b);
    IntMap.call($this, tmp$ret$0, loadFactor, true);
    return $this;
  }
  function IntMap_init_$Create$(initialCapacity, loadFactor) {
    return IntMap_init_$Init$(initialCapacity, loadFactor, objectCreate(protoOf(IntMap)));
  }
  function Companion_5() {
    this.o1w_1 = 2147483646;
    this.p1w_1 = 2147483647;
    this.q1w_1 = 0;
  }
  var Companion_instance_5;
  function Companion_getInstance_5() {
    return Companion_instance_5;
  }
  function _get_stashStart__3psegu($this) {
    return $this.h1w_1.length - $this.g1w_1 | 0;
  }
  function grow($this) {
    var inc = $this.a1w_1 < 20 ? 3 : 1;
    var newnbits = $this.a1w_1 + inc | 0;
    var new_0 = new IntMap(newnbits, $this.b1w_1, true);
    var inductionVariable = 0;
    var last = $this.h1w_1.length - 1 | 0;
    if (inductionVariable <= last)
      do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var k = $this.h1w_1[n];
        if (!(k === 0)) {
          new_0.r1w(k, $this.i1w_1[n]);
        }
      }
       while (inductionVariable <= last);
    $this.a1w_1 = new_0.a1w_1;
    $this.c1w_1 = new_0.c1w_1;
    $this.f1w_1 = new_0.f1w_1;
    $this.g1w_1 = new_0.g1w_1;
    $this.h1w_1 = new_0.h1w_1;
    $this.i1w_1 = new_0.i1w_1;
    $this.j1w_1 = new_0.j1w_1;
  }
  function growStash($this) {
    $this.g1w_1 = imul($this.g1w_1, 2);
    $this.h1w_1 = copyOf_0($this.h1w_1, $this.s1w());
    $this.i1w_1 = copyOf_2($this.i1w_1, $this.s1w());
  }
  function _getKeyIndex($this, key) {
    if (key === 0)
      return $this.d1w_1 ? 2147483647 : -1;
    var index1 = hash1($this, key);
    if ($this.h1w_1[index1] === key)
      return index1;
    var index2 = hash2($this, key);
    if ($this.h1w_1[index2] === key)
      return index2;
    var index3 = hash3($this, key);
    if ($this.h1w_1[index3] === key)
      return index3;
    var inductionVariable = _get_stashStart__3psegu($this);
    var last = $this.h1w_1.length;
    if (inductionVariable < last)
      do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        if ($this.h1w_1[n] === key)
          return n;
      }
       while (inductionVariable < last);
    return -1;
  }
  function setEmptySlot($this, index, key, value) {
    if (!($this.h1w_1[index] === 0))
      throw IllegalStateException_init_$Create$_0();
    $this.h1w_1[index] = key;
    $this.i1w_1[index] = value;
    $this.k1w_1 = $this.k1w_1 + 1 | 0;
    return null;
  }
  function hash1($this, key) {
    return _hash1(key, $this.f1w_1);
  }
  function hash2($this, key) {
    return _hash2(key, $this.f1w_1);
  }
  function hash3($this, key) {
    return _hash3(key, $this.f1w_1);
  }
  function Entry(key, value) {
    this.t1w_1 = key;
    this.u1w_1 = value;
  }
  protoOf(Entry).toString = function () {
    return 'Entry(key=' + this.t1w_1 + ', value=' + this.u1w_1 + ')';
  };
  protoOf(Entry).hashCode = function () {
    var result = this.t1w_1;
    result = imul(result, 31) + (this.u1w_1 == null ? 0 : hashCode(this.u1w_1)) | 0;
    return result;
  };
  protoOf(Entry).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof Entry))
      return false;
    var tmp0_other_with_cast = other instanceof Entry ? other : THROW_CCE();
    if (!(this.t1w_1 === tmp0_other_with_cast.t1w_1))
      return false;
    if (!equals(this.u1w_1, tmp0_other_with_cast.u1w_1))
      return false;
    return true;
  };
  function Iterator(map) {
    this.x1v_1 = map;
    this.y1v_1 = this.x1v_1.d1w_1 ? 2147483647 : nextNonEmptyIndex(this, this.x1v_1.h1w_1, 0);
    this.z1v_1 = new Entry(0, null);
  }
  protoOf(Iterator).v = function () {
    return !(this.y1v_1 === 2147483646);
  };
  protoOf(Iterator).l1w = function () {
    // Inline function 'kotlin.apply' call
    var this_0 = currentKey(this);
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.datastructure.Iterator.nextKey.<anonymous>' call
    next(this);
    return this_0;
  };
  protoOf(Iterator).m1w = function () {
    // Inline function 'kotlin.apply' call
    var this_0 = currentValue(this);
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.datastructure.Iterator.nextValue.<anonymous>' call
    next(this);
    return this_0;
  };
  function _no_name_provided__qut3iv(this$0) {
    this.v1w_1 = this$0;
  }
  protoOf(_no_name_provided__qut3iv).u = function () {
    // Inline function 'korlibs.datastructure.IntMap.<get-keys>.<anonymous>' call
    // Inline function 'kotlin.let' call
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.datastructure.IntMap.<get-keys>.<anonymous>.<anonymous>' call
    var it = new Iterator(this.v1w_1);
    var tmp = IntMap$_get_keys_$o$iterator$lambda_bn8atq(it);
    return Iterator_0(tmp, IntMap$_get_keys_$o$iterator$lambda_bn8atq_0(it));
  };
  function _no_name_provided__qut3iv_0(this$0) {
    this.w1w_1 = this$0;
  }
  protoOf(_no_name_provided__qut3iv_0).u = function () {
    // Inline function 'korlibs.datastructure.IntMap.<get-values>.<anonymous>' call
    // Inline function 'kotlin.let' call
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.datastructure.IntMap.<get-values>.<anonymous>.<anonymous>' call
    var it = new Iterator(this.w1w_1);
    var tmp = IntMap$_get_values_$o$iterator$lambda_ggo058(it);
    return Iterator_0(tmp, IntMap$_get_values_$o$iterator$lambda_ggo058_0(it));
  };
  function IntMap(nbits, loadFactor, dummy) {
    dummy = dummy === VOID ? false : dummy;
    this.a1w_1 = nbits;
    this.b1w_1 = loadFactor;
    this.c1w_1 = 1 << this.a1w_1;
    this.d1w_1 = false;
    this.e1w_1 = null;
    this.f1w_1 = this.c1w_1 - 1 | 0;
    this.g1w_1 = 1 + imul(this.a1w_1, this.a1w_1) | 0;
    this.h1w_1 = new Int32Array(this.s1w());
    var tmp = this;
    // Inline function 'kotlin.arrayOfNulls' call
    var size = this.s1w();
    var tmp_0 = fillArrayVal(Array(size), null);
    tmp.i1w_1 = isArray(tmp_0) ? tmp_0 : THROW_CCE();
    this.j1w_1 = numberToInt(this.c1w_1 * this.b1w_1);
    this.k1w_1 = 0;
  }
  protoOf(IntMap).s1w = function () {
    return this.c1w_1 + this.g1w_1 | 0;
  };
  protoOf(IntMap).f1 = function (key) {
    var index = _getKeyIndex(this, key);
    if (index < 0)
      return null;
    if (index === 2147483647)
      return this.e1w_1;
    return this.i1w_1[index];
  };
  protoOf(IntMap).r1w = function (key, value) {
    retry: while (true) {
      var index = _getKeyIndex(this, key);
      if (index < 0) {
        if (key === 0) {
          this.d1w_1 = true;
          this.e1w_1 = value;
          this.k1w_1 = this.k1w_1 + 1 | 0;
          return null;
        }
        if (this.k1w_1 >= this.j1w_1) {
          grow(this);
        }
        var index1 = hash1(this, key);
        if (this.h1w_1[index1] === 0)
          return setEmptySlot(this, index1, key, value);
        var index2 = hash2(this, key);
        if (this.h1w_1[index2] === 0)
          return setEmptySlot(this, index2, key, value);
        var index3 = hash3(this, key);
        if (this.h1w_1[index3] === 0)
          return setEmptySlot(this, index3, key, value);
        var inductionVariable = _get_stashStart__3psegu(this);
        var last = this.h1w_1.length;
        if (inductionVariable < last)
          do {
            var n = inductionVariable;
            inductionVariable = inductionVariable + 1 | 0;
            if (this.h1w_1[n] === 0)
              return setEmptySlot(this, n, key, value);
          }
           while (inductionVariable < last);
        if (this.g1w_1 > 512) {
          grow(this);
        } else {
          growStash(this);
        }
        continue retry;
      } else if (index === 2147483647) {
        // Inline function 'kotlin.apply' call
        var this_0 = this.e1w_1;
        // Inline function 'kotlin.contracts.contract' call
        // Inline function 'korlibs.datastructure.IntMap.set.<anonymous>' call
        this.e1w_1 = value;
        return this_0;
      } else {
        // Inline function 'kotlin.apply' call
        var this_1 = this.i1w_1[index];
        // Inline function 'kotlin.contracts.contract' call
        // Inline function 'korlibs.datastructure.IntMap.set.<anonymous>' call
        this.i1w_1[index] = value;
        return this_1;
      }
    }
  };
  protoOf(IntMap).g2 = function () {
    // Inline function 'kotlin.collections.Iterable' call
    return new _no_name_provided__qut3iv(this);
  };
  protoOf(IntMap).h2 = function () {
    // Inline function 'kotlin.collections.Iterable' call
    return new _no_name_provided__qut3iv_0(this);
  };
  protoOf(IntMap).x1w = function (keys, offset) {
    var inductionVariable = offset;
    var last = keys.length;
    if (inductionVariable < last)
      do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        if (!(keys[n] === 0))
          return n;
      }
       while (inductionVariable < last);
    return 2147483646;
  };
  protoOf(IntMap).equals = function (other) {
    if (!(other instanceof IntMap))
      return false;
    // Inline function 'korlibs.datastructure.IntMap.fastForEachNullable' call
    // Inline function 'korlibs.datastructure.IntMap.fastKeyForEach' call
    var index = this.d1w_1 ? 2147483647 : this.x1w(this.h1w_1, 0);
    while (!(index === 2147483646)) {
      // Inline function 'korlibs.datastructure.IntMap.fastForEachNullable.<anonymous>' call
      var it;
      switch (index) {
        case 2147483647:
        case 2147483646:
          it = 0;
          break;
        default:
          it = this.h1w_1[index];
          break;
      }
      // Inline function 'korlibs.datastructure.IntMap.equals.<anonymous>' call
      var key = it;
      var value = this.f1(it);
      if (!equals(other.f1(key), value))
        return false;
      index = this.x1w(this.h1w_1, index === 2147483647 ? 0 : index + 1 | 0);
    }
    return true;
  };
  protoOf(IntMap).hashCode = function () {
    var out = 0;
    // Inline function 'korlibs.datastructure.IntMap.fastForEachNullable' call
    // Inline function 'korlibs.datastructure.IntMap.fastKeyForEach' call
    var index = this.d1w_1 ? 2147483647 : this.x1w(this.h1w_1, 0);
    while (!(index === 2147483646)) {
      // Inline function 'korlibs.datastructure.IntMap.fastForEachNullable.<anonymous>' call
      var it;
      switch (index) {
        case 2147483647:
        case 2147483646:
          it = 0;
          break;
        default:
          it = this.h1w_1[index];
          break;
      }
      // Inline function 'korlibs.datastructure.IntMap.hashCode.<anonymous>' call
      var tmp = out;
      var tmp_0 = it;
      // Inline function 'kotlin.hashCode' call
      var tmp0_safe_receiver = this.f1(it);
      var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : hashCode(tmp0_safe_receiver);
      out = tmp + (tmp_0 + (tmp1_elvis_lhs == null ? 0 : tmp1_elvis_lhs) | 0) | 0;
      index = this.x1w(this.h1w_1, index === 2147483647 ? 0 : index + 1 | 0);
    }
    return out;
  };
  protoOf(IntMap).y1w = function () {
    // Inline function 'korlibs.datastructure.IntMap.fastValueForEach' call
    // Inline function 'korlibs.datastructure.IntMap.fastKeyForEach' call
    var index = this.d1w_1 ? 2147483647 : this.x1w(this.h1w_1, 0);
    while (!(index === 2147483646)) {
      // Inline function 'korlibs.datastructure.IntMap.fastValueForEach.<anonymous>' call
      var it;
      switch (index) {
        case 2147483647:
        case 2147483646:
          it = 0;
          break;
        default:
          it = this.h1w_1[index];
          break;
      }
      // Inline function 'korlibs.datastructure.IntMap.firstValue.<anonymous>' call
      return ensureNotNull(this.f1(it));
    }
    // Inline function 'kotlin.error' call
    var message = 'firstValue on empty IntMap';
    throw IllegalStateException_init_$Create$(toString(message));
  };
  function IntIntMap_init_$Init$(initialCapacity, loadFactor, $this) {
    initialCapacity = initialCapacity === VOID ? 16 : initialCapacity;
    loadFactor = loadFactor === VOID ? 0.75 : loadFactor;
    // Inline function 'kotlin.math.max' call
    var b = Math_instance.n1w(initialCapacity);
    var tmp$ret$0 = Math.max(4, b);
    IntIntMap.call($this, tmp$ret$0, loadFactor, true);
    return $this;
  }
  function IntIntMap_init_$Create$(initialCapacity, loadFactor) {
    return IntIntMap_init_$Init$(initialCapacity, loadFactor, objectCreate(protoOf(IntIntMap)));
  }
  function Companion_6() {
    this.z1w_1 = 2147483646;
    this.a1x_1 = 2147483647;
    this.b1x_1 = 0;
  }
  var Companion_instance_6;
  function Companion_getInstance_6() {
    return Companion_instance_6;
  }
  function _get_stashStart__3psegu_0($this) {
    return $this.j1x_1.length - $this.i1x_1 | 0;
  }
  function grow_0($this) {
    var inc = $this.c1x_1 < 20 ? 3 : 1;
    var newnbits = $this.c1x_1 + inc | 0;
    var new_0 = new IntIntMap(newnbits, $this.d1x_1, true);
    var inductionVariable = 0;
    var last = $this.j1x_1.length - 1 | 0;
    if (inductionVariable <= last)
      do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var k = $this.j1x_1[n];
        if (!(k === 0)) {
          new_0.n1x(k, $this.k1x_1[n]);
        }
      }
       while (inductionVariable <= last);
    $this.c1x_1 = new_0.c1x_1;
    $this.e1x_1 = new_0.e1x_1;
    $this.h1x_1 = new_0.h1x_1;
    $this.i1x_1 = new_0.i1x_1;
    $this.j1x_1 = new_0.j1x_1;
    $this.k1x_1 = new_0.k1x_1;
    $this.l1x_1 = new_0.l1x_1;
  }
  function growStash_0($this) {
    $this.i1x_1 = imul($this.i1x_1, 2);
    $this.j1x_1 = copyOf_0($this.j1x_1, $this.s1w());
    $this.k1x_1 = copyOf_0($this.k1x_1, $this.s1w());
  }
  function _getKeyIndex_0($this, key) {
    if (key === 0)
      return $this.f1x_1 ? 2147483647 : -1;
    var index1 = hash1_0($this, key);
    if ($this.j1x_1[index1] === key)
      return index1;
    var index2 = hash2_0($this, key);
    if ($this.j1x_1[index2] === key)
      return index2;
    var index3 = hash3_0($this, key);
    if ($this.j1x_1[index3] === key)
      return index3;
    var inductionVariable = _get_stashStart__3psegu_0($this);
    var last = $this.j1x_1.length;
    if (inductionVariable < last)
      do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        if ($this.j1x_1[n] === key)
          return n;
      }
       while (inductionVariable < last);
    return -1;
  }
  function setEmptySlot_0($this, index, key, value) {
    if (!($this.j1x_1[index] === 0))
      throw IllegalStateException_init_$Create$_0();
    $this.j1x_1[index] = key;
    $this.k1x_1[index] = value;
    $this.m1x_1 = $this.m1x_1 + 1 | 0;
    return 0;
  }
  function hash1_0($this, key) {
    return _hash1(key, $this.h1x_1);
  }
  function hash2_0($this, key) {
    return _hash2(key, $this.h1x_1);
  }
  function hash3_0($this, key) {
    return _hash3(key, $this.h1x_1);
  }
  function IntIntMap(nbits, loadFactor, dummy) {
    this.c1x_1 = nbits;
    this.d1x_1 = loadFactor;
    this.e1x_1 = 1 << this.c1x_1;
    this.f1x_1 = false;
    this.g1x_1 = 0;
    this.h1x_1 = this.e1x_1 - 1 | 0;
    this.i1x_1 = 1 + imul(this.c1x_1, this.c1x_1) | 0;
    this.j1x_1 = new Int32Array(this.s1w());
    this.k1x_1 = new Int32Array(this.s1w());
    this.l1x_1 = numberToInt(this.e1x_1 * this.d1x_1);
    this.m1x_1 = 0;
  }
  protoOf(IntIntMap).toString = function () {
    return toString(this.o1x());
  };
  protoOf(IntIntMap).s1w = function () {
    return this.e1x_1 + this.i1x_1 | 0;
  };
  protoOf(IntIntMap).p1x = function (out) {
    // Inline function 'korlibs.datastructure.IntIntMap.fastForEach' call
    // Inline function 'korlibs.datastructure.IntIntMap.fastKeyForEach' call
    var index = this.f1x_1 ? 2147483647 : this.x1w(this.j1x_1, 0);
    while (!(index === 2147483646)) {
      // Inline function 'korlibs.datastructure.IntIntMap.fastForEach.<anonymous>' call
      var it;
      switch (index) {
        case 2147483647:
        case 2147483646:
          it = 0;
          break;
        default:
          it = this.j1x_1[index];
          break;
      }
      // Inline function 'korlibs.datastructure.IntIntMap.toMap.<anonymous>' call
      var key = it;
      // Inline function 'kotlin.collections.set' call
      var value = this.f1(it);
      out.i2(key, value);
      index = this.x1w(this.j1x_1, index === 2147483647 ? 0 : index + 1 | 0);
    }
    return out;
  };
  protoOf(IntIntMap).o1x = function (out, $super) {
    out = out === VOID ? linkedHashMapOf([]) : out;
    return $super === VOID ? this.p1x(out) : $super.p1x.call(this, out);
  };
  protoOf(IntIntMap).zh = function (key) {
    return _getKeyIndex_0(this, key) >= 0;
  };
  protoOf(IntIntMap).b3 = function () {
    this.f1x_1 = false;
    this.g1x_1 = 0;
    fill(this.j1x_1, 0);
    fill(this.k1x_1, 0);
    this.m1x_1 = 0;
  };
  protoOf(IntIntMap).f1 = function (key) {
    var index = _getKeyIndex_0(this, key);
    if (index < 0)
      return 0;
    if (index === 2147483647)
      return this.g1x_1;
    return this.k1x_1[index];
  };
  protoOf(IntIntMap).n1x = function (key, value) {
    retry: while (true) {
      var index = _getKeyIndex_0(this, key);
      if (index < 0) {
        if (key === 0) {
          this.f1x_1 = true;
          this.g1x_1 = value;
          this.m1x_1 = this.m1x_1 + 1 | 0;
          return 0;
        }
        if (this.m1x_1 >= this.l1x_1) {
          grow_0(this);
        }
        var index1 = hash1_0(this, key);
        if (this.j1x_1[index1] === 0)
          return setEmptySlot_0(this, index1, key, value);
        var index2 = hash2_0(this, key);
        if (this.j1x_1[index2] === 0)
          return setEmptySlot_0(this, index2, key, value);
        var index3 = hash3_0(this, key);
        if (this.j1x_1[index3] === 0)
          return setEmptySlot_0(this, index3, key, value);
        var inductionVariable = _get_stashStart__3psegu_0(this);
        var last = this.j1x_1.length;
        if (inductionVariable < last)
          do {
            var n = inductionVariable;
            inductionVariable = inductionVariable + 1 | 0;
            if (this.j1x_1[n] === 0)
              return setEmptySlot_0(this, n, key, value);
          }
           while (inductionVariable < last);
        if (this.i1x_1 > 512) {
          grow_0(this);
        } else {
          growStash_0(this);
        }
        continue retry;
      } else if (index === 2147483647) {
        // Inline function 'kotlin.apply' call
        var this_0 = this.g1x_1;
        // Inline function 'kotlin.contracts.contract' call
        // Inline function 'korlibs.datastructure.IntIntMap.set.<anonymous>' call
        this.g1x_1 = value;
        return this_0;
      } else {
        // Inline function 'kotlin.apply' call
        var this_1 = this.k1x_1[index];
        // Inline function 'kotlin.contracts.contract' call
        // Inline function 'korlibs.datastructure.IntIntMap.set.<anonymous>' call
        this.k1x_1[index] = value;
        return this_1;
      }
    }
  };
  protoOf(IntIntMap).x1w = function (keys, offset) {
    var inductionVariable = offset;
    var last = keys.length;
    if (inductionVariable < last)
      do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        if (!(keys[n] === 0))
          return n;
      }
       while (inductionVariable < last);
    return 2147483646;
  };
  protoOf(IntIntMap).equals = function (other) {
    if (!(other instanceof IntIntMap))
      return false;
    // Inline function 'korlibs.datastructure.IntIntMap.fastForEach' call
    // Inline function 'korlibs.datastructure.IntIntMap.fastKeyForEach' call
    var index = this.f1x_1 ? 2147483647 : this.x1w(this.j1x_1, 0);
    while (!(index === 2147483646)) {
      // Inline function 'korlibs.datastructure.IntIntMap.fastForEach.<anonymous>' call
      var it;
      switch (index) {
        case 2147483647:
        case 2147483646:
          it = 0;
          break;
        default:
          it = this.j1x_1[index];
          break;
      }
      // Inline function 'korlibs.datastructure.IntIntMap.equals.<anonymous>' call
      var key = it;
      var value = this.f1(it);
      if (!(other.f1(key) === value))
        return false;
      index = this.x1w(this.j1x_1, index === 2147483647 ? 0 : index + 1 | 0);
    }
    return true;
  };
  protoOf(IntIntMap).hashCode = function () {
    var out = 0;
    // Inline function 'korlibs.datastructure.IntIntMap.fastForEach' call
    // Inline function 'korlibs.datastructure.IntIntMap.fastKeyForEach' call
    var index = this.f1x_1 ? 2147483647 : this.x1w(this.j1x_1, 0);
    while (!(index === 2147483646)) {
      // Inline function 'korlibs.datastructure.IntIntMap.fastForEach.<anonymous>' call
      var it;
      switch (index) {
        case 2147483647:
        case 2147483646:
          it = 0;
          break;
        default:
          it = this.j1x_1[index];
          break;
      }
      // Inline function 'korlibs.datastructure.IntIntMap.hashCode.<anonymous>' call
      out = out + (it + this.f1(it) | 0) | 0;
      index = this.x1w(this.j1x_1, index === 2147483647 ? 0 : index + 1 | 0);
    }
    return out;
  };
  function toIntMap(_this__u8e3s4) {
    var out = IntMap_init_$Create$(numberToInt(_this__u8e3s4.n() * 1.25));
    // Inline function 'kotlin.collections.iterator' call
    var tmp0_iterator = _this__u8e3s4.k2().u();
    while (tmp0_iterator.v()) {
      var tmp1_loop_parameter = tmp0_iterator.x();
      // Inline function 'kotlin.collections.component1' call
      var k = tmp1_loop_parameter.l2();
      // Inline function 'kotlin.collections.component2' call
      var v = tmp1_loop_parameter.m2();
      out.r1w(k, v);
    }
    return out;
  }
  function _hash1(key, mask) {
    return _mask(key, mask);
  }
  function _hash2(key, mask) {
    return _mask(imul(key, 1294968109), mask);
  }
  function _hash3(key, mask) {
    return _mask(imul(key, 294969449), mask);
  }
  function _mask(value, mask) {
    return (((value + ((value >>> 8 | 0) & 255) | 0) + ((value >>> 16 | 0) & 255) | 0) + (value >> 24 & 255) | 0) & mask;
  }
  function associateByInt(_this__u8e3s4, block) {
    var n = 0;
    var out = IntMap_init_$Create$();
    var tmp0_iterator = _this__u8e3s4.u();
    while (tmp0_iterator.v()) {
      var it = tmp0_iterator.x();
      var tmp1 = n;
      n = tmp1 + 1 | 0;
      out.r1w(block(tmp1, it), it);
    }
    return out;
  }
  function Iterator_0(hasNext, next) {
    return new Iterator$1(hasNext, next);
  }
  function Iterator$1($hasNext, $next) {
    this.q1x_1 = $hasNext;
    this.r1x_1 = $next;
  }
  protoOf(Iterator$1).v = function () {
    return this.q1x_1();
  };
  protoOf(Iterator$1).x = function () {
    return this.r1x_1();
  };
  function ConcurrentPool$_init_$lambda_gqhtk8(it) {
    return Unit_instance;
  }
  function ConcurrentPool(reset, preallocate, gen) {
    var tmp;
    if (reset === VOID) {
      tmp = ConcurrentPool$_init_$lambda_gqhtk8;
    } else {
      tmp = reset;
    }
    reset = tmp;
    preallocate = preallocate === VOID ? 0 : preallocate;
    Pool.call(this, reset, preallocate, gen);
    this.w1x_1 = reset;
    this.x1x_1 = gen;
    this.y1x_1 = new NonRecursiveLock();
  }
  protoOf(ConcurrentPool).z1x = function () {
    // Inline function 'korlibs.concurrent.lock.NonRecursiveLock.invoke' call
    this.y1x_1;
    // Inline function 'korlibs.datastructure.ConcurrentPool.alloc.<anonymous>' call
    return protoOf(Pool).z1x.call(this);
  };
  protoOf(ConcurrentPool).b3 = function () {
    // Inline function 'korlibs.concurrent.lock.NonRecursiveLock.invoke' call
    this.y1x_1;
    protoOf(Pool).b3.call(this);
  };
  protoOf(ConcurrentPool).e1y = function (element) {
    // Inline function 'korlibs.concurrent.lock.NonRecursiveLock.invoke' call
    this.y1x_1;
    protoOf(Pool).e1y.call(this, element);
  };
  function Companion_7() {
  }
  var Companion_instance_7;
  function Companion_getInstance_7() {
    return Companion_instance_7;
  }
  function Pool_init_$Init$(preallocate, gen, $this) {
    preallocate = preallocate === VOID ? 0 : preallocate;
    Pool.call($this, Pool$_init_$lambda_q3cbhr_0, preallocate, gen);
    return $this;
  }
  function Pool_init_$Create$(preallocate, gen) {
    return Pool_init_$Init$(preallocate, gen, objectCreate(protoOf(Pool)));
  }
  function Pool$_init_$lambda_q3cbhr(it) {
    return Unit_instance;
  }
  function Pool$_init_$lambda_q3cbhr_0(it) {
    return Unit_instance;
  }
  function Pool(reset, preallocate, gen) {
    var tmp;
    if (reset === VOID) {
      tmp = Pool$_init_$lambda_q3cbhr;
    } else {
      tmp = reset;
    }
    reset = tmp;
    preallocate = preallocate === VOID ? 0 : preallocate;
    this.a1y_1 = reset;
    this.b1y_1 = gen;
    this.c1y_1 = _TGenStack___init__impl__yynjgt();
    this.d1y_1 = 0;
    var inductionVariable = 0;
    if (inductionVariable < preallocate)
      do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var tmp2 = this.d1y_1;
        this.d1y_1 = tmp2 + 1 | 0;
        TGenStack__push_impl_9yh33t(this.c1y_1, this.b1y_1(tmp2));
      }
       while (inductionVariable < preallocate);
  }
  protoOf(Pool).f1y = function () {
    return _TGenStack___get_size__impl__cvg66t(this.c1y_1);
  };
  protoOf(Pool).z1x = function () {
    var tmp;
    // Inline function 'kotlin.collections.isNotEmpty' call
    if (!(new TGenStack(this.c1y_1)).b1()) {
      tmp = TGenStack__pop_impl_qisxa0(this.c1y_1);
    } else {
      var tmp1 = this.d1y_1;
      this.d1y_1 = tmp1 + 1 | 0;
      tmp = this.b1y_1(tmp1);
    }
    return tmp;
  };
  protoOf(Pool).b3 = function () {
    TGenStack__clear_impl_pali4s(this.c1y_1);
    this.d1y_1 = 0;
  };
  protoOf(Pool).e1y = function (element) {
    this.a1y_1(element);
    TGenStack__push_impl_9yh33t(this.c1y_1, element);
  };
  protoOf(Pool).h1y = function (element) {
    if (element == null)
      return Unit_instance;
    this.e1y(element);
  };
  protoOf(Pool).g1y = function (elements) {
    var tmp0_iterator = elements.u();
    while (tmp0_iterator.v()) {
      var element = tmp0_iterator.x();
      this.e1y(element);
    }
  };
  protoOf(Pool).hashCode = function () {
    return TGenStack__hashCode_impl_l04zom(this.c1y_1);
  };
  protoOf(Pool).equals = function (other) {
    var tmp;
    var tmp_0;
    if (other instanceof Pool) {
      tmp_0 = equals(this.c1y_1, other.c1y_1);
    } else {
      tmp_0 = false;
    }
    if (tmp_0) {
      tmp = this.f1y() === other.f1y();
    } else {
      tmp = false;
    }
    return tmp;
  };
  function ReturnablePool$_init_$lambda_rsm60r(it) {
    return Unit_instance;
  }
  function ReturnablePool$list$lambda(this$0) {
    return function (it) {
      this$0.i1y_1(it);
      return Unit_instance;
    };
  }
  function ReturnablePool$list$lambda_0(this$0) {
    return function (it) {
      return this$0.j1y_1(it);
    };
  }
  function ReturnablePool(_reset, gen) {
    var tmp;
    if (_reset === VOID) {
      tmp = ReturnablePool$_init_$lambda_rsm60r;
    } else {
      tmp = _reset;
    }
    _reset = tmp;
    this.i1y_1 = _reset;
    this.j1y_1 = gen;
    this.k1y_1 = fastArrayListOf([]);
    var tmp_0 = this;
    var tmp_1 = ReturnablePool$list$lambda(this);
    tmp_0.l1y_1 = new Pool(tmp_1, VOID, ReturnablePool$list$lambda_0(this));
    this.m1y_1 = this.l1y_1.z1x();
  }
  protoOf(ReturnablePool).x = function () {
    // Inline function 'kotlin.collections.plusAssign' call
    var this_0 = this.k1y_1;
    var element = this.m1y_1;
    this_0.r(element);
    this.m1y_1 = this.l1y_1.z1x();
    return this.m1y_1;
  };
  protoOf(ReturnablePool).n1y = function () {
    // Inline function 'korlibs.datastructure.FastArrayList.fastForEach' call
    // Inline function 'korlibs.datastructure.FastArrayList.jsArray' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var array = this.k1y_1.y1u_1;
    var n = 0;
    while (n < array.length) {
      // Inline function 'korlibs.datastructure.ReturnablePool.reset.<anonymous>' call
      // Inline function 'kotlin.js.unsafeCast' call
      // Inline function 'get' call
      var tmp0 = n;
      n = tmp0 + 1 | 0;
      // Inline function 'kotlin.js.asDynamic' call
      // Inline function 'kotlin.js.asDynamic' call
      var it = array[tmp0];
      this.l1y_1.e1y(it);
    }
    this.k1y_1.b3();
  };
  function sam$kotlin_Comparator$0(function_0) {
    this.o1y_1 = function_0;
  }
  protoOf(sam$kotlin_Comparator$0).aa = function (a, b) {
    return this.o1y_1(a, b);
  };
  protoOf(sam$kotlin_Comparator$0).compare = function (a, b) {
    return this.aa(a, b);
  };
  function Companion_8() {
  }
  protoOf(Companion_8).p1y = function (comparator, reversed_0) {
    // Inline function 'kotlin.arrayOfNulls' call
    var tmp = fillArrayVal(Array(16), null);
    return new TGenPriorityQueue(isArray(tmp) ? tmp : THROW_CCE(), reversed_0 ? reversed(comparator) : comparator);
  };
  protoOf(Companion_8).q1y = function (reversed, comparator) {
    return Companion_instance_8.p1y(new sam$kotlin_Comparator$0(comparator), reversed);
  };
  protoOf(Companion_8).r1y = function (reversed, comparator, $super) {
    reversed = reversed === VOID ? false : reversed;
    return $super === VOID ? this.q1y(reversed, comparator) : $super.q1y.call(this, reversed, comparator);
  };
  var Companion_instance_8;
  function Companion_getInstance_8() {
    return Companion_instance_8;
  }
  function _set_value__lx0xdg(_this__u8e3s4, $this, value) {
    $this.s1y_1[_PriorityQueueNode___get_index__impl__b6r7i5(_this__u8e3s4)] = value;
  }
  function _get_value__a43j40(_this__u8e3s4, $this) {
    return $this.s1y_1[_PriorityQueueNode___get_index__impl__b6r7i5(_this__u8e3s4)];
  }
  function _get_isRoot__1006zj(_this__u8e3s4, $this) {
    return _PriorityQueueNode___get_index__impl__b6r7i5(_this__u8e3s4) === 0;
  }
  function _get_parent__oo9xup(_this__u8e3s4, $this) {
    return _PriorityQueueNode___init__impl__34dlfu((_PriorityQueueNode___get_index__impl__b6r7i5(_this__u8e3s4) - 1 | 0) / 2 | 0);
  }
  function _get_left__d9qyp0(_this__u8e3s4, $this) {
    return _PriorityQueueNode___init__impl__34dlfu(imul(2, _PriorityQueueNode___get_index__impl__b6r7i5(_this__u8e3s4)) + 1 | 0);
  }
  function _get_right__bvz45n(_this__u8e3s4, $this) {
    return _PriorityQueueNode___init__impl__34dlfu(imul(2, _PriorityQueueNode___get_index__impl__b6r7i5(_this__u8e3s4)) + 2 | 0);
  }
  function gt($this, a, b) {
    return $this.t1y_1.compare(a, b) > 0;
  }
  function lt($this, a, b) {
    return $this.t1y_1.compare(a, b) < 0;
  }
  function _get_capacity__a9k9f3_1($this) {
    return $this.s1y_1.length;
  }
  function ensure_1($this, index) {
    if (index >= _get_capacity__a9k9f3_1($this)) {
      var tmp = $this;
      var tmp_0 = copyOf_2($this.s1y_1, 2 + imul(_get_capacity__a9k9f3_1($this), 2) | 0);
      tmp.s1y_1 = isArray(tmp_0) ? tmp_0 : THROW_CCE();
    }
  }
  function minHeapify($this, index) {
    var i = _PriorityQueueNode___init__impl__34dlfu(index);
    $l$loop: while (true) {
      var left = _get_left__d9qyp0(i, $this);
      var right = _get_right__bvz45n(i, $this);
      var smallest = i;
      if (_PriorityQueueNode___get_index__impl__b6r7i5(left) < $this.u1y_1 ? lt($this, _get_value__a43j40(left, $this), _get_value__a43j40(i, $this)) : false)
        smallest = left;
      if (_PriorityQueueNode___get_index__impl__b6r7i5(right) < $this.u1y_1 ? lt($this, _get_value__a43j40(right, $this), _get_value__a43j40(smallest, $this)) : false)
        smallest = right;
      if (!(smallest === i)) {
        swap_0($this, i, smallest);
        i = smallest;
      } else {
        break $l$loop;
      }
    }
  }
  function swap_0($this, l, r) {
    var temp = _get_value__a43j40(r, $this);
    _set_value__lx0xdg(r, $this, _get_value__a43j40(l, $this));
    _set_value__lx0xdg(l, $this, temp);
  }
  function TGenPriorityQueue$iterator$1($index, this$0) {
    this.v1y_1 = $index;
    this.w1y_1 = this$0;
  }
  protoOf(TGenPriorityQueue$iterator$1).v = function () {
    return this.v1y_1._v < this.w1y_1.u1y_1;
  };
  protoOf(TGenPriorityQueue$iterator$1).x = function () {
    var tmp0 = this.v1y_1._v;
    this.v1y_1._v = tmp0 + 1 | 0;
    return _get_value__a43j40(_PriorityQueueNode___init__impl__34dlfu(tmp0), this.w1y_1);
  };
  protoOf(TGenPriorityQueue$iterator$1).i1i = function () {
    throw new NotImplementedError();
  };
  protoOf(TGenPriorityQueue$iterator$1).w = function () {
    return this.i1i();
  };
  function TGenPriorityQueue(data, comparator) {
    this.s1y_1 = data;
    this.t1y_1 = comparator;
    this.u1y_1 = 0;
  }
  protoOf(TGenPriorityQueue).n = function () {
    return this.u1y_1;
  };
  protoOf(TGenPriorityQueue).x1y = function () {
    if (this.u1y_1 <= 0)
      throw IndexOutOfBoundsException_init_$Create$();
    return this.s1y_1[0];
  };
  protoOf(TGenPriorityQueue).g1u = function (element) {
    this.u1y_1 = this.u1y_1 + 1 | 0;
    ensure_1(this, this.u1y_1);
    var i = _PriorityQueueNode___init__impl__34dlfu(this.u1y_1 - 1 | 0);
    _set_value__lx0xdg(i, this, element);
    while (!_get_isRoot__1006zj(i, this) ? gt(this, _get_value__a43j40(_get_parent__oo9xup(i, this), this), _get_value__a43j40(i, this)) : false) {
      swap_0(this, i, _get_parent__oo9xup(i, this));
      i = _get_parent__oo9xup(i, this);
    }
    return true;
  };
  protoOf(TGenPriorityQueue).r = function (element) {
    return this.g1u((element == null ? true : !(element == null)) ? element : THROW_CCE());
  };
  protoOf(TGenPriorityQueue).y1y = function () {
    if (this.u1y_1 <= 0)
      throw IndexOutOfBoundsException_init_$Create$();
    if (this.u1y_1 === 1) {
      this.u1y_1 = this.u1y_1 - 1 | 0;
      return _get_value__a43j40(_PriorityQueueNode___init__impl__34dlfu(0), this);
    }
    var root = _get_value__a43j40(_PriorityQueueNode___init__impl__34dlfu(0), this);
    _set_value__lx0xdg(_PriorityQueueNode___init__impl__34dlfu(0), this, _get_value__a43j40(_PriorityQueueNode___init__impl__34dlfu(this.u1y_1 - 1 | 0), this));
    this.u1y_1 = this.u1y_1 - 1 | 0;
    minHeapify(this, 0);
    return root;
  };
  protoOf(TGenPriorityQueue).i1u = function (element) {
    var inductionVariable = 0;
    var last = this.u1y_1;
    if (inductionVariable < last)
      do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        if (equals(this.s1y_1[n], element))
          return n;
      }
       while (inductionVariable < last);
    return -1;
  };
  protoOf(TGenPriorityQueue).h1u = function (element) {
    var index = this.i1u(element);
    if (index >= 0) {
      this.z1y(index);
    }
    return index >= 0;
  };
  protoOf(TGenPriorityQueue).s = function (element) {
    if (!(element == null ? true : !(element == null)))
      return false;
    return this.h1u((element == null ? true : !(element == null)) ? element : THROW_CCE());
  };
  protoOf(TGenPriorityQueue).z1y = function (index) {
    var i = _PriorityQueueNode___init__impl__34dlfu(index);
    while (!(_PriorityQueueNode___get_index__impl__b6r7i5(i) === 0)) {
      swap_0(this, i, _get_parent__oo9xup(i, this));
      i = _get_parent__oo9xup(i, this);
    }
    this.y1y();
  };
  protoOf(TGenPriorityQueue).k1u = function (elements) {
    var thisSet = toSet(this);
    var tmp$ret$0;
    $l$block_0: {
      // Inline function 'kotlin.collections.all' call
      var tmp;
      if (isInterface(elements, Collection)) {
        tmp = elements.b1();
      } else {
        tmp = false;
      }
      if (tmp) {
        tmp$ret$0 = true;
        break $l$block_0;
      }
      var tmp0_iterator = elements.u();
      while (tmp0_iterator.v()) {
        var element = tmp0_iterator.x();
        // Inline function 'korlibs.datastructure.TGenPriorityQueue.containsAll.<anonymous>' call
        if (!thisSet.z(element)) {
          tmp$ret$0 = false;
          break $l$block_0;
        }
      }
      tmp$ret$0 = true;
    }
    return tmp$ret$0;
  };
  protoOf(TGenPriorityQueue).a1 = function (elements) {
    return this.k1u(elements);
  };
  protoOf(TGenPriorityQueue).b1 = function () {
    return this.u1y_1 === 0;
  };
  protoOf(TGenPriorityQueue).c1u = function (elements) {
    var tmp0_iterator = elements.u();
    while (tmp0_iterator.v()) {
      var e = tmp0_iterator.x();
      this.g1u(e);
    }
    // Inline function 'kotlin.collections.isNotEmpty' call
    return !elements.b1();
  };
  protoOf(TGenPriorityQueue).y = function (elements) {
    return this.c1u(elements);
  };
  protoOf(TGenPriorityQueue).u = function () {
    var index = {_v: 0};
    return new TGenPriorityQueue$iterator$1(index, this);
  };
  protoOf(TGenPriorityQueue).toString = function () {
    return toString(toList(this));
  };
  protoOf(TGenPriorityQueue).equals = function (other) {
    var tmp;
    var tmp_0;
    if (other instanceof TGenPriorityQueue) {
      tmp_0 = contentEquals_1(this.s1y_1, other.s1y_1);
    } else {
      tmp_0 = false;
    }
    if (tmp_0) {
      tmp = equals(this.t1y_1, other.t1y_1);
    } else {
      tmp = false;
    }
    return tmp;
  };
  protoOf(TGenPriorityQueue).hashCode = function () {
    return contentHashCode_1(this.s1y_1);
  };
  function _PriorityQueueNode___init__impl__34dlfu(index) {
    return index;
  }
  function _PriorityQueueNode___get_index__impl__b6r7i5($this) {
    return $this;
  }
  function TGenQueue() {
    this.a1z_1 = TGenDeque_init_$Create$();
  }
  protoOf(TGenQueue).n = function () {
    return this.a1z_1.n();
  };
  protoOf(TGenQueue).b1 = function () {
    return this.n() === 0;
  };
  protoOf(TGenQueue).b1z = function (v) {
    this.a1z_1.a1u(v);
  };
  protoOf(TGenQueue).c1z = function () {
    return this.a1z_1.hf();
  };
  protoOf(TGenQueue).k1u = function (elements) {
    return this.a1z_1.k1u(elements);
  };
  protoOf(TGenQueue).a1 = function (elements) {
    return this.k1u(elements);
  };
  protoOf(TGenQueue).u = function () {
    return this.a1z_1.u();
  };
  protoOf(TGenQueue).hashCode = function () {
    return this.a1z_1.hashCode();
  };
  protoOf(TGenQueue).equals = function (other) {
    var tmp;
    if (other instanceof TGenQueue) {
      tmp = this.a1z_1.equals(other.a1z_1);
    } else {
      tmp = false;
    }
    return tmp;
  };
  function Ref(value) {
    // Inline function 'kotlin.also' call
    var this_0 = Ref_0();
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.datastructure.Ref.<anonymous>' call
    this_0.d1z(value);
    return this_0;
  }
  function toRef(_this__u8e3s4) {
    return Ref_1(_this__u8e3s4);
  }
  function Ref_0() {
    return new Ref$2();
  }
  function Ref_1(prop) {
    return new Ref$3(prop);
  }
  function Ref$2() {
  }
  protoOf(Ref$2).d1z = function (_set____db54di) {
    this.e1z_1 = _set____db54di;
  };
  protoOf(Ref$2).m2 = function () {
    var tmp = this.e1z_1;
    if (!(tmp == null))
      return tmp;
    else {
      throwUninitializedPropertyAccessException('value');
    }
  };
  function Ref$3($prop) {
    this.f1z_1 = $prop;
  }
  protoOf(Ref$3).d1z = function (value) {
    this.f1z_1.set(value);
  };
  protoOf(Ref$3).m2 = function () {
    return this.f1z_1.get();
  };
  function RingBuffer(bits) {
    ByteRingBuffer.call(this, bits);
  }
  function ByteRingBuffer(bits) {
    this.g1z_1 = bits;
    this.h1z_1 = 1 << this.g1z_1;
    this.i1z_1 = this.h1z_1 - 1 | 0;
    this.j1z_1 = new Int8Array(this.h1z_1);
    this.k1z_1 = 0;
    this.l1z_1 = 0;
    this.m1z_1 = this.h1z_1;
    this.n1z_1 = 0;
  }
  protoOf(ByteRingBuffer).o1z = function () {
    return this.j1z_1;
  };
  protoOf(ByteRingBuffer).p1z = function () {
    return this.l1z_1 & this.i1z_1;
  };
  protoOf(ByteRingBuffer).q1z = function (count) {
    if (count < 0 ? true : count > this.m1z_1) {
      // Inline function 'kotlin.error' call
      var message = 'Try to write more than available';
      throw IllegalStateException_init_$Create$(toString(message));
    }
    this.l1z_1 = this.l1z_1 + count | 0;
    this.n1z_1 = this.n1z_1 + count | 0;
    this.m1z_1 = this.m1z_1 - count | 0;
  };
  protoOf(ByteRingBuffer).r1z = function () {
    // Inline function 'kotlin.math.min' call
    var a = this.n1z_1;
    var b = this.h1z_1 - (this.k1z_1 & this.i1z_1) | 0;
    return Math.min(a, b);
  };
  protoOf(ByteRingBuffer).s1z = function () {
    // Inline function 'kotlin.math.min' call
    var a = this.m1z_1;
    var b = this.h1z_1 - (this.l1z_1 & this.i1z_1) | 0;
    return Math.min(a, b);
  };
  protoOf(ByteRingBuffer).t1z = function (data, offset, size) {
    return this.u1z(this.v1z(data, offset, size));
  };
  protoOf(ByteRingBuffer).u1z = function (size) {
    // Inline function 'kotlin.math.min' call
    var a = this.n1z_1;
    var toRead = Math.min(a, size);
    this.k1z_1 = (this.k1z_1 + toRead | 0) & this.i1z_1;
    this.m1z_1 = this.m1z_1 + toRead | 0;
    this.n1z_1 = this.n1z_1 - toRead | 0;
    return toRead;
  };
  protoOf(ByteRingBuffer).v1z = function (data, offset, size) {
    // Inline function 'kotlin.math.min' call
    var a = this.n1z_1;
    var toRead = Math.min(a, size);
    var readCount = 0;
    var buffer = this.j1z_1;
    var mask = this.i1z_1;
    var coffset = offset;
    var lReadPos = this.k1z_1;
    $l$loop: while (true) {
      // Inline function 'kotlin.math.min' call
      var a_0 = toRead;
      var b = this.r1z();
      var toReadChunk = Math.min(a_0, b);
      if (toReadChunk <= 0)
        break $l$loop;
      Memory_instance.z1z(buffer, lReadPos & mask, data, coffset, toReadChunk);
      toRead = toRead - toReadChunk | 0;
      coffset = coffset + toReadChunk | 0;
      lReadPos = lReadPos + toReadChunk | 0;
      readCount = readCount + toReadChunk | 0;
    }
    return readCount;
  };
  protoOf(ByteRingBuffer).x1z = function () {
    if (this.n1z_1 <= 0)
      return -1;
    var out = this.j1z_1[this.k1z_1] & 255;
    this.k1z_1 = (this.k1z_1 + 1 | 0) & this.i1z_1;
    this.n1z_1 = this.n1z_1 - 1 | 0;
    this.m1z_1 = this.m1z_1 + 1 | 0;
    return out;
  };
  protoOf(ByteRingBuffer).w1z = function (offset) {
    return this.j1z_1[(this.k1z_1 + offset | 0) & this.i1z_1];
  };
  protoOf(ByteRingBuffer).equals = function (other) {
    var tmp;
    var tmp_0;
    if (other instanceof ByteRingBuffer) {
      tmp_0 = this.n1z_1 === other.n1z_1;
    } else {
      tmp_0 = false;
    }
    if (tmp_0) {
      var tmp$ret$1;
      $l$block: {
        // Inline function 'korlibs.datastructure.internal.equaler' call
        var count = this.n1z_1;
        var inductionVariable = 0;
        if (inductionVariable < count)
          do {
            var n = inductionVariable;
            inductionVariable = inductionVariable + 1 | 0;
            // Inline function 'korlibs.datastructure.ByteRingBuffer.equals.<anonymous>' call
            if (!(this.w1z(n) === other.w1z(n))) {
              tmp$ret$1 = false;
              break $l$block;
            }
          }
           while (inductionVariable < count);
        tmp$ret$1 = true;
      }
      tmp = tmp$ret$1;
    } else {
      tmp = false;
    }
    return tmp;
  };
  protoOf(ByteRingBuffer).hashCode = function () {
    return this.y1z();
  };
  protoOf(ByteRingBuffer).y1z = function () {
    // Inline function 'korlibs.datastructure.internal.hashCoder' call
    var count = this.n1z_1;
    var out = 0;
    var inductionVariable = 0;
    if (inductionVariable < count)
      do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        out = imul(out, 7);
        var tmp = out;
        // Inline function 'korlibs.datastructure.ByteRingBuffer.contentHashCode.<anonymous>' call
        out = tmp + this.w1z(n) | 0;
      }
       while (inductionVariable < count);
    return out;
  };
  function chunkX(_this__u8e3s4, $this, x) {
    return x - _this__u8e3s4.a20() | 0;
  }
  function chunkY(_this__u8e3s4, $this, y) {
    return y - _this__u8e3s4.b20() | 0;
  }
  function containsChunk(_this__u8e3s4, $this, x, y) {
    var tmp;
    var containsLower = _this__u8e3s4.a20();
    if (x < get_endX(_this__u8e3s4) ? containsLower <= x : false) {
      var containsLower_0 = _this__u8e3s4.b20();
      tmp = y < get_endY(_this__u8e3s4) ? containsLower_0 <= y : false;
    } else {
      tmp = false;
    }
    return tmp;
  }
  function SparseChunkedStackedIntArray2(empty) {
    empty = empty === VOID ? -1 : empty;
    this.c20_1 = empty;
    this.d20_1 = 0;
    this.e20_1 = 0;
    this.f20_1 = 0;
    this.g20_1 = 0;
    this.h20_1 = 0;
    this.i20_1 = new BVH(2);
    this.j20_1 = null;
    this.k20_1 = null;
    this.l20_1 = null;
  }
  protoOf(SparseChunkedStackedIntArray2).m20 = function () {
    return this.c20_1;
  };
  protoOf(SparseChunkedStackedIntArray2).n20 = function () {
    return this.h20_1;
  };
  protoOf(SparseChunkedStackedIntArray2).o20 = function (chunk) {
    if (this.j20_1 == null) {
      this.j20_1 = chunk;
      this.c20_1 = chunk.m20();
      this.d20_1 = IntCompanionObject_instance.MAX_VALUE;
      this.e20_1 = IntCompanionObject_instance.MAX_VALUE;
      this.f20_1 = IntCompanionObject_instance.MIN_VALUE;
      this.g20_1 = IntCompanionObject_instance.MIN_VALUE;
    }
    this.k20_1 = chunk;
    this.i20_1.w20(Companion_instance_12.p20(new Int32Array([chunk.a20(), chunk.x1q(), chunk.b20(), chunk.y1q()])), chunk);
    var tmp = this;
    // Inline function 'kotlin.math.min' call
    var a = this.d20_1;
    var b = chunk.a20();
    tmp.d20_1 = Math.min(a, b);
    var tmp_0 = this;
    // Inline function 'kotlin.math.min' call
    var a_0 = this.e20_1;
    var b_0 = chunk.b20();
    tmp_0.e20_1 = Math.min(a_0, b_0);
    var tmp_1 = this;
    // Inline function 'kotlin.math.max' call
    var a_1 = this.f20_1;
    var b_1 = get_endX(chunk);
    tmp_1.f20_1 = Math.max(a_1, b_1);
    var tmp_2 = this;
    // Inline function 'kotlin.math.max' call
    var a_2 = this.g20_1;
    var b_2 = get_endY(chunk);
    tmp_2.g20_1 = Math.max(a_2, b_2);
    var tmp_3 = this;
    // Inline function 'kotlin.math.max' call
    var a_3 = this.h20_1;
    var b_3 = chunk.n20();
    tmp_3.h20_1 = Math.max(a_3, b_3);
  };
  protoOf(SparseChunkedStackedIntArray2).a20 = function () {
    return this.d20_1;
  };
  protoOf(SparseChunkedStackedIntArray2).b20 = function () {
    return this.e20_1;
  };
  protoOf(SparseChunkedStackedIntArray2).x1q = function () {
    return this.f20_1 - this.d20_1 | 0;
  };
  protoOf(SparseChunkedStackedIntArray2).y1q = function () {
    return this.g20_1 - this.e20_1 | 0;
  };
  protoOf(SparseChunkedStackedIntArray2).x20 = function (x, y) {
    var tmp0_safe_receiver = this.l20_1;
    if (tmp0_safe_receiver == null)
      null;
    else {
      // Inline function 'kotlin.let' call
      // Inline function 'kotlin.contracts.contract' call
      var tmp;
      if (containsChunk(tmp0_safe_receiver, this, x, y)) {
        return tmp0_safe_receiver;
      }
    }
    this.l20_1 = firstOrNull(this.i20_1.y20(Companion_instance_12.p20(new Int32Array([x, 1, y, 1]))));
    return this.l20_1;
  };
  protoOf(SparseChunkedStackedIntArray2).z20 = function (x, y, level) {
    var tmp0_safe_receiver = this.x20(x, y);
    if (tmp0_safe_receiver == null)
      null;
    else {
      // Inline function 'kotlin.let' call
      // Inline function 'kotlin.contracts.contract' call
      return tmp0_safe_receiver.z20(chunkX(tmp0_safe_receiver, this, x), chunkY(tmp0_safe_receiver, this, y), level);
    }
    return this.c20_1;
  };
  protoOf(SparseChunkedStackedIntArray2).a21 = function (x, y) {
    var tmp0_safe_receiver = this.x20(x, y);
    if (tmp0_safe_receiver == null)
      null;
    else {
      // Inline function 'kotlin.let' call
      // Inline function 'kotlin.contracts.contract' call
      return tmp0_safe_receiver.a21(chunkX(tmp0_safe_receiver, this, x), chunkY(tmp0_safe_receiver, this, y));
    }
    return 0;
  };
  function _TGenStack___init__impl__yynjgt(items) {
    items = items === VOID ? FastArrayList_init_$Create$() : items;
    return items;
  }
  function _get_items__fzd5gv($this) {
    return $this;
  }
  function _TGenStack___get_size__impl__cvg66t($this) {
    return _get_items__fzd5gv($this).n();
  }
  function TGenStack__isEmpty_impl_bsbpyi($this) {
    return _TGenStack___get_size__impl__cvg66t($this) === 0;
  }
  function Companion_9() {
  }
  var Companion_instance_9;
  function Companion_getInstance_9() {
    return Companion_instance_9;
  }
  function TGenStack__push_impl_9yh33t($this, v) {
    _get_items__fzd5gv($this).r(v);
  }
  function TGenStack__pop_impl_qisxa0($this) {
    return _get_items__fzd5gv($this).h1(_get_items__fzd5gv($this).n() - 1 | 0);
  }
  function TGenStack__clear_impl_pali4s($this) {
    _get_items__fzd5gv($this).b3();
  }
  function TGenStack__containsAll_impl_ic9i7r($this, elements) {
    return _get_items__fzd5gv($this).a1(elements);
  }
  function TGenStack__containsAll_impl_ic9i7r_0($this, elements) {
    return TGenStack__containsAll_impl_ic9i7r($this.c21_1, elements);
  }
  function TGenStack__iterator_impl_2pdia5($this) {
    return _get_items__fzd5gv($this).u();
  }
  function TGenStack__toString_impl_s9t5hn($this) {
    return 'TGenStack(items=' + $this + ')';
  }
  function TGenStack__hashCode_impl_l04zom($this) {
    return $this.hashCode();
  }
  function TGenStack__equals_impl_w9i35u($this, other) {
    if (!(other instanceof TGenStack))
      return false;
    var tmp0_other_with_cast = other instanceof TGenStack ? other.c21_1 : THROW_CCE();
    if (!$this.equals(tmp0_other_with_cast))
      return false;
    return true;
  }
  function TGenStack(items) {
    this.c21_1 = items;
  }
  protoOf(TGenStack).n = function () {
    return _TGenStack___get_size__impl__cvg66t(this.c21_1);
  };
  protoOf(TGenStack).b1 = function () {
    return TGenStack__isEmpty_impl_bsbpyi(this.c21_1);
  };
  protoOf(TGenStack).k1u = function (elements) {
    return TGenStack__containsAll_impl_ic9i7r(this.c21_1, elements);
  };
  protoOf(TGenStack).a1 = function (elements) {
    return TGenStack__containsAll_impl_ic9i7r_0(this, elements);
  };
  protoOf(TGenStack).u = function () {
    return TGenStack__iterator_impl_2pdia5(this.c21_1);
  };
  protoOf(TGenStack).toString = function () {
    return TGenStack__toString_impl_s9t5hn(this.c21_1);
  };
  protoOf(TGenStack).hashCode = function () {
    return TGenStack__hashCode_impl_l04zom(this.c21_1);
  };
  protoOf(TGenStack).equals = function (other) {
    return TGenStack__equals_impl_w9i35u(this.c21_1, other);
  };
  function IStackedIntArray2() {
  }
  function Companion_10() {
  }
  protoOf(Companion_10).d21 = function (layers, width, height, empty, startX, startY) {
    var stacked = new StackedIntArray2(width, height, empty, startX, startY);
    // Inline function 'korlibs.datastructure.fill' call
    var this_0 = stacked.j21_1;
    var n = 0;
    var inductionVariable = 0;
    var last = this_0.y1q();
    if (inductionVariable < last)
      do {
        var y = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var inductionVariable_0 = 0;
        var last_0 = this_0.x1q();
        if (inductionVariable_0 < last_0)
          do {
            var x = inductionVariable_0;
            inductionVariable_0 = inductionVariable_0 + 1 | 0;
            var tmp = n;
            // Inline function 'korlibs.datastructure.Companion.invoke.<anonymous>' call
            this_0.b1r(n);
            var tmp$ret$0 = layers.length;
            this_0.a1r(tmp, tmp$ret$0);
            n = n + 1 | 0;
          }
           while (inductionVariable_0 < last_0);
      }
       while (inductionVariable < last);
    addAll(stacked.k21_1, layers);
    return stacked;
  };
  protoOf(Companion_10).l21 = function (layers, width, height, empty, startX, startY, $super) {
    width = width === VOID ? first(layers).t1q_1 : width;
    height = height === VOID ? first(layers).u1q_1 : height;
    empty = empty === VOID ? -1 : empty;
    startX = startX === VOID ? 0 : startX;
    startY = startY === VOID ? 0 : startY;
    return $super === VOID ? this.d21(layers, width, height, empty, startX, startY) : $super.d21.call(this, layers, width, height, empty, startX, startY);
  };
  var Companion_instance_10;
  function Companion_getInstance_10() {
    return Companion_instance_10;
  }
  function StackedIntArray2(width, height, empty, startX, startY) {
    empty = empty === VOID ? -1 : empty;
    startX = startX === VOID ? 0 : startX;
    startY = startY === VOID ? 0 : startY;
    this.e21_1 = width;
    this.f21_1 = height;
    this.g21_1 = empty;
    this.h21_1 = startX;
    this.i21_1 = startY;
    var tmp = this;
    // Inline function 'korlibs.datastructure.Companion.invoke' call
    var width_0 = this.e21_1;
    var height_0 = this.f21_1;
    var tmp_0 = 0;
    var tmp_1 = imul(width_0, height_0);
    var tmp_2 = new Int32Array(tmp_1);
    while (tmp_0 < tmp_1) {
      tmp_2[tmp_0] = 0;
      tmp_0 = tmp_0 + 1 | 0;
    }
    var tmp_3 = tmp_2;
    tmp.j21_1 = new IntArray2(width_0, height_0, isIntArray(tmp_3) ? tmp_3 : THROW_CCE());
    this.k21_1 = fastArrayListOf([]);
  }
  protoOf(StackedIntArray2).x1q = function () {
    return this.e21_1;
  };
  protoOf(StackedIntArray2).y1q = function () {
    return this.f21_1;
  };
  protoOf(StackedIntArray2).m20 = function () {
    return this.g21_1;
  };
  protoOf(StackedIntArray2).a20 = function () {
    return this.h21_1;
  };
  protoOf(StackedIntArray2).b20 = function () {
    return this.i21_1;
  };
  protoOf(StackedIntArray2).n20 = function () {
    return this.k21_1.n();
  };
  protoOf(StackedIntArray2).m21 = function (level) {
    while (level >= this.k21_1.n()) {
      // Inline function 'korlibs.datastructure.Companion.invoke' call
      var width = this.e21_1;
      var height = this.f21_1;
      var fill = this.g21_1;
      var tmp = 0;
      var tmp_0 = imul(width, height);
      var tmp_1 = new Int32Array(tmp_0);
      while (tmp < tmp_0) {
        tmp_1[tmp] = fill;
        tmp = tmp + 1 | 0;
      }
      var tmp_2 = tmp_1;
      var tmp$ret$1 = new IntArray2(width, height, isIntArray(tmp_2) ? tmp_2 : THROW_CCE());
      this.k21_1.r(tmp$ret$1);
    }
  };
  protoOf(StackedIntArray2).n21 = function (x, y, level, value) {
    this.m21(level);
    this.k21_1.f1(level).d1r(x, y, value);
  };
  protoOf(StackedIntArray2).z20 = function (x, y, level) {
    if (level > this.j21_1.c1r(x, y))
      return this.g21_1;
    return this.k21_1.f1(level).c1r(x, y);
  };
  protoOf(StackedIntArray2).a21 = function (x, y) {
    return this.j21_1.c1r(x, y);
  };
  protoOf(StackedIntArray2).o21 = function (x, y, value) {
    var tmp0_array = this.j21_1;
    var tmp3 = tmp0_array.c1r(x, y);
    tmp0_array.d1r(x, y, tmp3 + 1 | 0);
    this.n21(x, y, tmp3, value);
  };
  function get_endX(_this__u8e3s4) {
    return _this__u8e3s4.a20() + _this__u8e3s4.x1q() | 0;
  }
  function get_endY(_this__u8e3s4) {
    return _this__u8e3s4.b20() + _this__u8e3s4.y1q() | 0;
  }
  function toStacked(_this__u8e3s4) {
    return Companion_instance_10.l21([_this__u8e3s4]);
  }
  function Closeable() {
  }
  function Companion_11() {
    Companion_instance_11 = this;
    Comparators.call(this);
  }
  var Companion_instance_11;
  function Companion_getInstance_11() {
    if (Companion_instance_11 == null)
      new Companion_11();
    return Companion_instance_11;
  }
  function Node(d, id, nodes, value) {
    id = id === VOID ? null : id;
    nodes = nodes === VOID ? null : nodes;
    value = value === VOID ? null : value;
    this.s21_1 = d;
    this.t21_1 = id;
    this.u21_1 = nodes;
    this.v21_1 = value;
  }
  protoOf(Node).toString = function () {
    return 'Node(d=' + new BVHRect(this.s21_1) + ', id=' + this.t21_1 + ', nodes=' + this.u21_1 + ', value=' + this.v21_1 + ')';
  };
  protoOf(Node).hashCode = function () {
    var result = BVHRect__hashCode_impl_dhse2i(this.s21_1);
    result = imul(result, 31) + (this.t21_1 == null ? 0 : getStringHashCode(this.t21_1)) | 0;
    result = imul(result, 31) + (this.u21_1 == null ? 0 : this.u21_1.hashCode()) | 0;
    result = imul(result, 31) + (this.v21_1 == null ? 0 : hashCode(this.v21_1)) | 0;
    return result;
  };
  protoOf(Node).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof Node))
      return false;
    var tmp0_other_with_cast = other instanceof Node ? other : THROW_CCE();
    if (!equals(this.s21_1, tmp0_other_with_cast.s21_1))
      return false;
    if (!(this.t21_1 == tmp0_other_with_cast.t21_1))
      return false;
    if (!equals(this.u21_1, tmp0_other_with_cast.u21_1))
      return false;
    if (!equals(this.v21_1, tmp0_other_with_cast.v21_1))
      return false;
    return true;
  };
  function RemoveSubtreeRetObject(d, target, nodes) {
    target = target === VOID ? null : target;
    nodes = nodes === VOID ? null : nodes;
    this.w21_1 = d;
    this.x21_1 = target;
    this.y21_1 = nodes;
  }
  function Comparators() {
    Companion_getInstance_11();
  }
  protoOf(Comparators).q21 = function (a, b) {
    if (!(_BVHRect___get_length__impl__sgc79u(a) === _BVHRect___get_length__impl__sgc79u(b))) {
      // Inline function 'kotlin.error' call
      var message = 'Not matching dimensions';
      throw IllegalStateException_init_$Create$(toString(message));
    }
    var inductionVariable = 0;
    var last = _BVHRect___get_length__impl__sgc79u(a);
    if (inductionVariable < last)
      do {
        var i = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        if (!(BVHRect__min_impl_5ss93n(a, i) < BVHRect__max_impl_z6ab7l(b, i) ? BVHRect__max_impl_z6ab7l(a, i) > BVHRect__min_impl_5ss93n(b, i) : false))
          return false;
      }
       while (inductionVariable < last);
    return true;
  };
  protoOf(Comparators).r21 = function (a, b) {
    if (!(_BVHRect___get_length__impl__sgc79u(a) === _BVHRect___get_length__impl__sgc79u(b))) {
      // Inline function 'kotlin.error' call
      var message = 'Not matching dimensions';
      throw IllegalStateException_init_$Create$(toString(message));
    }
    var inductionVariable = 0;
    var last = _BVHRect___get_length__impl__sgc79u(a);
    if (inductionVariable < last)
      do {
        var i = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        if (!(BVHRect__max_impl_z6ab7l(a, i) <= BVHRect__max_impl_z6ab7l(b, i) ? BVHRect__min_impl_5ss93n(a, i) >= BVHRect__min_impl_5ss93n(b, i) : false))
          return false;
      }
       while (inductionVariable < last);
    return true;
  };
  function _make_Empty($this) {
    return _BVHRect___init__impl__pawpsv(BVHIntervals_init_$Create$($this.q20_1));
  }
  function _make_Intervals($this, other, out) {
    return BVHRect__copyFrom_impl_kjg73e(out, other);
  }
  function _make_Intervals$default($this, other, out, $super) {
    out = out === VOID ? _BVHRect___init__impl__pawpsv_0($this.q20_1) : out;
    return _make_Intervals($this, other, out);
  }
  function _expand_intervals($this, a, b) {
    var inductionVariable = 0;
    var last = $this.q20_1;
    if (inductionVariable < last)
      do {
        var i = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var a_a = BVHRect__min_impl_5ss93n(a, i);
        var b_a = BVHRect__min_impl_5ss93n(b, i);
        var a_b = BVHRect__size_impl_axghd8(a, i);
        var b_b = BVHRect__size_impl_axghd8(b, i);
        // Inline function 'kotlin.math.min' call
        var n = Math.min(a_a, b_a);
        // Inline function 'kotlin.math.max' call
        var a_0 = a_a + a_b;
        var b_0 = b_a + b_b;
        var tmp$ret$1 = Math.max(a_0, b_0);
        BVHRect__size_impl_axghd8_0(a, i, tmp$ret$1 - n);
        BVHRect__min_impl_5ss93n_0(a, i, n);
      }
       while (inductionVariable < last);
    return a;
  }
  function _make_MBV($this, nodes, intervals) {
    if (nodes.b1())
      return _make_Empty($this);
    var tmp;
    var tmp_0 = intervals;
    if ((tmp_0 == null ? null : new BVHRect(tmp_0)) == null) {
      tmp = null;
    } else {
      tmp = BVHRect__copyFrom_impl_kjg73e(intervals, nodes.f1(0).s21_1);
    }
    var tmp1_elvis_lhs = tmp;
    var tmp_1;
    var tmp_2 = tmp1_elvis_lhs;
    if ((tmp_2 == null ? null : new BVHRect(tmp_2)) == null) {
      tmp_1 = BVHRect__clone_impl_weisiw(nodes.f1(0).s21_1);
    } else {
      tmp_1 = tmp1_elvis_lhs;
    }
    var ints = tmp_1;
    var inductionVariable = nodes.n() - 1 | 0;
    if (1 <= inductionVariable)
      do {
        var i = inductionVariable;
        inductionVariable = inductionVariable + -1 | 0;
        _expand_intervals($this, ints, nodes.f1(i).s21_1);
      }
       while (1 <= inductionVariable);
    return ints;
  }
  function _jons_ratio($this, intervals, count) {
    var dims = _BVHRect___get_length__impl__sgc79u(intervals);
    var sum = _BVHRect___get_intervals__impl__r54djc(intervals).b22();
    var mul = _BVHRect___get_intervals__impl__r54djc(intervals).c22();
    sum = sum / dims;
    // Inline function 'kotlin.math.pow' call
    var this_0 = sum;
    var lgeo = mul / Math.pow(this_0, dims);
    return mul * count / lgeo;
  }
  function checkDimensions(_this__u8e3s4, $this) {
    return BVHRect__checkDimensions_impl_tlq5ao(_this__u8e3s4, $this.q20_1);
  }
  function _remove_subtree($this, intervals, obj, root, comparators) {
    var hit_stack = fastArrayListOf([]);
    var count_stack = fastArrayListOf([]);
    var ret_array = fastArrayListOf([]);
    var current_depth = 1;
    var tmp;
    var tmp_0 = intervals;
    if ((tmp_0 == null ? null : new BVHRect(tmp_0)) == null) {
      tmp = true;
    } else {
      tmp = !comparators.q21(intervals, root.s21_1);
    }
    if (tmp)
      return ret_array;
    var ret_obj = new RemoveSubtreeRetObject(BVHRect__clone_impl_weisiw(intervals), obj);
    count_stack.r(ensureNotNull(root.u21_1).n());
    hit_stack.r(root);
    $l$1: do {
      $l$0: do {
        var tree = removeLast(hit_stack);
        var i = removeLast(count_stack) - 1 | 0;
        if (!(ret_obj.x21_1 == null)) {
          $l$loop: while (i >= 0) {
            var ltree = ensureNotNull(tree.u21_1).f1(i);
            if (comparators.q21(ret_obj.w21_1, ltree.s21_1)) {
              if (((!(ret_obj.x21_1 == null) ? !(ltree.v21_1 == null) : false) ? ltree.v21_1 === ret_obj.x21_1 : false) ? true : ret_obj.x21_1 == null ? !(ltree.v21_1 == null) ? true : comparators.r21(ltree.s21_1, ret_obj.w21_1) : false) {
                if (!(ltree.u21_1 == null)) {
                  var tmp0_intervals = ltree.s21_1;
                  ret_array = _search_subtree$default($this, tmp0_intervals, comparators, VOID, ltree);
                  var tmp1_safe_receiver = tree.u21_1;
                  if (tmp1_safe_receiver == null)
                    null;
                  else
                    tmp1_safe_receiver.h1(i);
                } else {
                  ret_array = fastArrayListOf([ensureNotNull(tree.u21_1).h1(i)]);
                }
                _make_MBV($this, ensureNotNull(tree.u21_1), tree.s21_1);
                ret_obj.x21_1 = null;
                if (ensureNotNull(tree.u21_1).n() < $this.t20_1) {
                  var tmp_1 = ret_obj;
                  var tmp2_intervals = tree.s21_1;
                  var tmp3_root = tree;
                  tmp_1.y21_1 = _search_subtree$default($this, tmp2_intervals, comparators, VOID, tmp3_root);
                }
                break $l$loop;
              } else if (!(ltree.u21_1 == null)) {
                current_depth = current_depth + 1 | 0;
                count_stack.r(i);
                hit_stack.r(tree);
                tree = ltree;
                i = ensureNotNull(ltree.u21_1).n();
              }
            }
            i = i - 1 | 0;
          }
        } else if (!(ret_obj.y21_1 == null)) {
          if (ensureNotNull(tree.u21_1).n() >= (i + 1 | 0)) {
            ensureNotNull(tree.u21_1).h1(i + 1 | 0);
          }
          // Inline function 'kotlin.collections.isNotEmpty' call
          if (!ensureNotNull(tree.u21_1).b1()) {
            _make_MBV($this, ensureNotNull(tree.u21_1), tree.s21_1);
          }
          var inductionVariable = 0;
          var last = ensureNotNull(ret_obj.y21_1).n();
          if (inductionVariable < last)
            do {
              var t = inductionVariable;
              inductionVariable = inductionVariable + 1 | 0;
              _insert_subtree($this, tree, ensureNotNull(ret_obj.y21_1).f1(t));
            }
             while (inductionVariable < last);
          ensureNotNull(ret_obj.y21_1).b3();
          if (hit_stack.b1() ? ensureNotNull(tree.u21_1).n() <= 1 : false) {
            var tmp_2 = ret_obj;
            var tmp5_intervals = tree.s21_1;
            var tmp6_return_array = ensureNotNull(ret_obj.y21_1);
            var tmp7_root = tree;
            tmp_2.y21_1 = _search_subtree($this, tmp5_intervals, comparators, tmp6_return_array, tmp7_root);
            ensureNotNull(tree.u21_1).b3();
            hit_stack.r(tree);
            count_stack.r(1);
          } else {
            var tmp_3;
            // Inline function 'kotlin.collections.isNotEmpty' call
            if (!hit_stack.b1()) {
              tmp_3 = ensureNotNull(tree.u21_1).n() < $this.t20_1;
            } else {
              tmp_3 = false;
            }
            if (tmp_3) {
              var tmp_4 = ret_obj;
              var tmp8_intervals = tree.s21_1;
              var tmp9_return_array = ensureNotNull(ret_obj.y21_1);
              var tmp10_root = tree;
              tmp_4.y21_1 = _search_subtree($this, tmp8_intervals, comparators, tmp9_return_array, tmp10_root);
              ensureNotNull(tree.u21_1).b3();
            } else {
              ret_obj.y21_1 = null;
            }
          }
        } else {
          _make_MBV($this, ensureNotNull(tree.u21_1), tree.s21_1);
        }
        current_depth = current_depth - 1 | 0;
      }
       while (false);
      // Inline function 'kotlin.collections.isNotEmpty' call
      var tmp$ret$2 = !hit_stack.b1();
    }
     while (tmp$ret$2);
    return ret_array;
  }
  function _choose_leaf_subtree($this, intervals, root) {
    var best_choice_index = -1;
    var best_choice_stack = fastArrayListOf([]);
    var best_choice_area = 0.0;
    best_choice_stack.r(root);
    var nodes = ensureNotNull(root.u21_1);
    do {
      if (!(best_choice_index === -1)) {
        best_choice_stack.r(nodes.f1(best_choice_index));
        nodes = ensureNotNull(nodes.f1(best_choice_index).u21_1);
        best_choice_index = -1;
      }
      var inductionVariable = nodes.n() - 1 | 0;
      if (0 <= inductionVariable)
        $l$loop: do {
          var i = inductionVariable;
          inductionVariable = inductionVariable + -1 | 0;
          var ltree = nodes.f1(i);
          if (!(ltree.v21_1 == null)) {
            best_choice_index = -1;
            break $l$loop;
          }
          var old_lratio = _jons_ratio($this, ltree.s21_1, ensureNotNull(ltree.u21_1).n() + 1 | 0);
          var copy_of_intervals = BVHRect__clone_impl_weisiw(ltree.s21_1);
          _expand_intervals($this, copy_of_intervals, intervals);
          var lratio = _jons_ratio($this, copy_of_intervals, ensureNotNull(ltree.u21_1).n() + 2 | 0);
          var tmp;
          if (best_choice_index < 0) {
            tmp = true;
          } else {
            // Inline function 'kotlin.math.abs' call
            var x = lratio - old_lratio;
            tmp = Math.abs(x) < best_choice_area;
          }
          if (tmp) {
            // Inline function 'kotlin.math.abs' call
            var x_0 = lratio - old_lratio;
            best_choice_area = Math.abs(x_0);
            best_choice_index = i;
          }
        }
         while (0 <= inductionVariable);
    }
     while (!(best_choice_index === -1));
    return best_choice_stack;
  }
  function _linear_split($this, nodes) {
    var n = _pick_linear($this, nodes);
    $l$loop: while (true) {
      // Inline function 'kotlin.collections.isNotEmpty' call
      if (!!nodes.b1()) {
        break $l$loop;
      }
      _pick_next($this, nodes, n.f1(0), n.f1(1));
    }
    return n;
  }
  function _pick_next($this, nodes, a, b) {
    var area_a = _jons_ratio($this, a.s21_1, ensureNotNull(a.u21_1).n() + 1 | 0);
    var area_b = _jons_ratio($this, b.s21_1, ensureNotNull(b.u21_1).n() + 1 | 0);
    var high_area_delta = null;
    var high_area_node = null;
    var lowest_growth_group = null;
    var inductionVariable = nodes.n() - 1 | 0;
    if (0 <= inductionVariable)
      do {
        var i = inductionVariable;
        inductionVariable = inductionVariable + -1 | 0;
        var l = nodes.f1(i);
        var copy_of_intervals = _make_Intervals$default($this, a.s21_1);
        _expand_intervals($this, copy_of_intervals, l.s21_1);
        // Inline function 'kotlin.math.abs' call
        var x = _jons_ratio($this, copy_of_intervals, ensureNotNull(a.u21_1).n() + 2 | 0) - area_a;
        var change_new_area_a = Math.abs(x);
        copy_of_intervals = _make_Intervals$default($this, b.s21_1);
        _expand_intervals($this, copy_of_intervals, l.s21_1);
        // Inline function 'kotlin.math.abs' call
        var x_0 = _jons_ratio($this, copy_of_intervals, ensureNotNull(b.u21_1).n() + 2 | 0) - area_b;
        var change_new_area_b = Math.abs(x_0);
        var tmp;
        if (high_area_node == null ? true : high_area_delta == null) {
          tmp = true;
        } else {
          // Inline function 'kotlin.math.abs' call
          var x_1 = change_new_area_b - change_new_area_a;
          tmp = Math.abs(x_1) < high_area_delta;
        }
        if (tmp) {
          high_area_node = i;
          // Inline function 'kotlin.math.abs' call
          var x_2 = change_new_area_b - change_new_area_a;
          high_area_delta = Math.abs(x_2);
          lowest_growth_group = change_new_area_b < change_new_area_a ? b : a;
        }
      }
       while (0 <= inductionVariable);
    var temp_node = nodes.h1(ensureNotNull(high_area_node));
    if (((ensureNotNull(a.u21_1).n() + nodes.n() | 0) + 1 | 0) <= $this.t20_1) {
      ensureNotNull(a.u21_1).r(temp_node);
      _expand_intervals($this, a.s21_1, temp_node.s21_1);
    } else if (((ensureNotNull(b.u21_1).n() + nodes.n() | 0) + 1 | 0) <= $this.t20_1) {
      ensureNotNull(b.u21_1).r(temp_node);
      _expand_intervals($this, b.s21_1, temp_node.s21_1);
    } else {
      var tmp_0;
      if (lowest_growth_group == null) {
        throwUninitializedPropertyAccessException('lowest_growth_group');
      } else {
        tmp_0 = lowest_growth_group;
      }
      ensureNotNull(tmp_0.u21_1).r(temp_node);
      var tmp_1;
      if (lowest_growth_group == null) {
        throwUninitializedPropertyAccessException('lowest_growth_group');
      } else {
        tmp_1 = lowest_growth_group;
      }
      _expand_intervals($this, tmp_1.s21_1, temp_node.s21_1);
    }
  }
  function _pick_linear($this, nodes) {
    var tmp = 0;
    var tmp_0 = $this.q20_1;
    // Inline function 'kotlin.arrayOfNulls' call
    var tmp_1 = fillArrayVal(Array(tmp_0), null);
    while (tmp < tmp_0) {
      tmp_1[tmp] = nodes.n() - 1 | 0;
      tmp = tmp + 1 | 0;
    }
    var lowest_high = tmp_1;
    var tmp_2 = 0;
    var tmp_3 = $this.q20_1;
    // Inline function 'kotlin.arrayOfNulls' call
    var tmp_4 = fillArrayVal(Array(tmp_3), null);
    while (tmp_2 < tmp_3) {
      tmp_4[tmp_2] = 0;
      tmp_2 = tmp_2 + 1 | 0;
    }
    var highest_low = tmp_4;
    var inductionVariable = nodes.n() - 2 | 0;
    if (0 <= inductionVariable)
      do {
        var i = inductionVariable;
        inductionVariable = inductionVariable + -1 | 0;
        var l = nodes.f1(i);
        var inductionVariable_0 = 0;
        var last = $this.q20_1;
        if (inductionVariable_0 < last)
          do {
            var d = inductionVariable_0;
            inductionVariable_0 = inductionVariable_0 + 1 | 0;
            if (BVHRect__min_impl_5ss93n(l.s21_1, d) > BVHRect__min_impl_5ss93n(nodes.f1(highest_low[d]).s21_1, d)) {
              highest_low[d] = i;
            } else if (BVHRect__min_impl_5ss93n(l.s21_1, d) + BVHRect__size_impl_axghd8(l.s21_1, d) < BVHRect__min_impl_5ss93n(nodes.f1(lowest_high[d]).s21_1, d) + BVHRect__size_impl_axghd8(nodes.f1(lowest_high[d]).s21_1, d)) {
              lowest_high[d] = i;
            }
          }
           while (inductionVariable_0 < last);
      }
       while (0 <= inductionVariable);
    var d_0 = 0;
    var last_difference = 0.0;
    var inductionVariable_1 = 0;
    var last_0 = $this.q20_1;
    if (inductionVariable_1 < last_0)
      do {
        var i_0 = inductionVariable_1;
        inductionVariable_1 = inductionVariable_1 + 1 | 0;
        // Inline function 'kotlin.math.abs' call
        var x = BVHRect__min_impl_5ss93n(nodes.f1(lowest_high[i_0]).s21_1, i_0) + BVHRect__size_impl_axghd8(nodes.f1(lowest_high[i_0]).s21_1, i_0) - BVHRect__min_impl_5ss93n(nodes.f1(highest_low[i_0]).s21_1, i_0);
        var difference = Math.abs(x);
        if (difference > last_difference) {
          d_0 = i_0;
          last_difference = difference;
        }
      }
       while (inductionVariable_1 < last_0);
    var t1;
    var t2;
    if (lowest_high[d_0] > highest_low[d_0]) {
      t1 = nodes.h1(lowest_high[d_0]);
      t2 = nodes.h1(highest_low[d_0]);
    } else {
      t2 = nodes.h1(highest_low[d_0]);
      t1 = nodes.h1(lowest_high[d_0]);
    }
    return fastArrayListOf([new Node(_make_Intervals$default($this, t1.s21_1), VOID, fastArrayListOf([t1])), new Node(_make_Intervals$default($this, t2.s21_1), VOID, fastArrayListOf([t2]))]);
  }
  function _insert_subtree($this, root, node) {
    var bc = null;
    if (ensureNotNull(root.u21_1).b1()) {
      _make_Intervals($this, node.s21_1, root.s21_1);
      ensureNotNull(root.u21_1).r(node);
      return Unit_instance;
    }
    var tree_stack = _choose_leaf_subtree($this, node.s21_1, root);
    var ret_obj_array = null;
    var ret_obj = node;
    $l$1: do {
      $l$0: do {
        var tmp;
        var tmp0_safe_receiver = bc;
        if (!((tmp0_safe_receiver == null ? null : tmp0_safe_receiver.u21_1) == null)) {
          tmp = ensureNotNull(bc.u21_1).b1();
        } else {
          tmp = false;
        }
        if (tmp) {
          var pbc = bc;
          bc = removeLast(tree_stack);
          var inductionVariable = 0;
          var last = ensureNotNull(bc.u21_1).n();
          if (inductionVariable < last)
            $l$loop: do {
              var t = inductionVariable;
              inductionVariable = inductionVariable + 1 | 0;
              if (ensureNotNull(bc.u21_1).f1(t) === pbc ? true : ensureNotNull(ensureNotNull(bc.u21_1).f1(t).u21_1).b1()) {
                ensureNotNull(bc.u21_1).h1(t);
                break $l$loop;
              }
            }
             while (inductionVariable < last);
        } else {
          bc = removeLast(tree_stack);
        }
        if ((!(ret_obj_array == null) ? true : !(ensureNotNull(ret_obj).v21_1 == null)) ? true : !(ret_obj.u21_1 == null)) {
          if (!(ret_obj_array == null)) {
            var inductionVariable_0 = 0;
            var last_0 = ret_obj_array.n();
            if (inductionVariable_0 < last_0)
              do {
                var ai = inductionVariable_0;
                inductionVariable_0 = inductionVariable_0 + 1 | 0;
                _expand_intervals($this, bc.s21_1, ret_obj_array.f1(ai).s21_1);
              }
               while (inductionVariable_0 < last_0);
            ensureNotNull(bc.u21_1).d22(ret_obj_array);
          } else {
            _expand_intervals($this, bc.s21_1, ensureNotNull(ret_obj).s21_1);
            ensureNotNull(bc.u21_1).r(ret_obj);
          }
          if (ensureNotNull(bc.u21_1).n() <= $this.s20_1) {
            ret_obj_array = null;
            ret_obj = new Node(_make_Intervals$default($this, bc.s21_1));
          } else {
            var a = _linear_split($this, ensureNotNull(bc.u21_1));
            ret_obj_array = a;
            ret_obj = null;
            if (tree_stack.b1()) {
              ensureNotNull(bc.u21_1).r(a.f1(0));
              tree_stack.r(bc);
              ret_obj_array = null;
              ret_obj = a.f1(1);
            }
          }
        } else {
          _expand_intervals($this, bc.s21_1, ret_obj.s21_1);
          ret_obj_array = null;
          ret_obj = new Node(_make_Intervals$default($this, bc.s21_1));
        }
      }
       while (false);
      // Inline function 'kotlin.collections.isNotEmpty' call
      var tmp$ret$0 = !tree_stack.b1();
    }
     while (tmp$ret$0);
  }
  function _search_subtree($this, intervals, comparators, return_array, root) {
    checkDimensions(intervals, $this);
    var hit_stack = fastArrayListOf([]);
    if (!comparators.q21(intervals, root.s21_1))
      return return_array;
    hit_stack.r(ensureNotNull(root.u21_1));
    $l$1: do {
      $l$0: do {
        var nodes = removeLast(hit_stack);
        var inductionVariable = nodes.n() - 1 | 0;
        if (0 <= inductionVariable)
          do {
            var i = inductionVariable;
            inductionVariable = inductionVariable + -1 | 0;
            var ltree = nodes.f1(i);
            if (comparators.q21(intervals, ltree.s21_1)) {
              if (!(ltree.u21_1 == null)) {
                hit_stack.r(ensureNotNull(ltree.u21_1));
              } else if (!(ltree.v21_1 == null)) {
                return_array.r(ltree);
              }
            }
          }
           while (0 <= inductionVariable);
      }
       while (false);
      // Inline function 'kotlin.collections.isNotEmpty' call
      var tmp$ret$0 = !hit_stack.b1();
    }
     while (tmp$ret$0);
    return return_array;
  }
  function _search_subtree$default($this, intervals, comparators, return_array, root, $super) {
    return_array = return_array === VOID ? fastArrayListOf([]) : return_array;
    root = root === VOID ? $this.u20_1 : root;
    return _search_subtree($this, intervals, comparators, return_array, root);
  }
  function BVH$iterator$slambda(this$0, resultContinuation) {
    this.m22_1 = this$0;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(BVH$iterator$slambda).q22 = function ($this$iterator, $completion) {
    var tmp = this.r22($this$iterator, $completion);
    tmp.hd_1 = Unit_instance;
    tmp.id_1 = null;
    return tmp.qd();
  };
  protoOf(BVH$iterator$slambda).ne = function (p1, $completion) {
    return this.q22(p1 instanceof SequenceScope ? p1 : THROW_CCE(), $completion);
  };
  protoOf(BVH$iterator$slambda).qd = function () {
    var suspendResult = this.hd_1;
    $sm: do
      try {
        var tmp = this.fd_1;
        switch (tmp) {
          case 0:
            this.gd_1 = 4;
            this.o22_1 = TGenDeque_init_$Create$();
            this.o22_1.a1u(this.m22_1.u20_1);
            this.fd_1 = 1;
            continue $sm;
          case 1:
            if (!!this.o22_1.b1()) {
              this.fd_1 = 3;
              continue $sm;
            }

            this.p22_1 = this.o22_1.hf();
            this.fd_1 = 2;
            suspendResult = this.n22_1.ig(this.p22_1, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 2:
            var tmp0_safe_receiver = this.p22_1.u21_1;
            if (tmp0_safe_receiver == null)
              null;
            else {
              this.o22_1.b1u(tmp0_safe_receiver);
            }

            this.fd_1 = 1;
            continue $sm;
          case 3:
            return Unit_instance;
          case 4:
            throw this.id_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.gd_1 === 4) {
          throw e;
        } else {
          this.fd_1 = this.gd_1;
          this.id_1 = e;
        }
      }
     while (true);
  };
  protoOf(BVH$iterator$slambda).r22 = function ($this$iterator, completion) {
    var i = new BVH$iterator$slambda(this.m22_1, completion);
    i.n22_1 = $this$iterator;
    return i;
  };
  function BVH$iterator$slambda_0(this$0, resultContinuation) {
    var i = new BVH$iterator$slambda(this$0, resultContinuation);
    var l = function ($this$iterator, $completion) {
      return i.q22($this$iterator, $completion);
    };
    l.$arity = 1;
    return l;
  }
  function BVH(dimensions, width, allowUpdateObjects) {
    width = width === VOID ? imul(dimensions, 3) : width;
    allowUpdateObjects = allowUpdateObjects === VOID ? true : allowUpdateObjects;
    this.q20_1 = dimensions;
    this.r20_1 = allowUpdateObjects;
    this.s20_1 = width;
    var tmp = this;
    // Inline function 'kotlin.math.floor' call
    var x = this.s20_1 / this.q20_1;
    var tmp$ret$0 = Math.floor(x);
    tmp.t20_1 = numberToInt(tmp$ret$0);
    this.u20_1 = new Node(_make_Empty(this), 'root', fastArrayListOf([]));
    this.v20_1 = HashMap_init_$Create$();
  }
  protoOf(BVH).u = function () {
    return iterator(BVH$iterator$slambda_0(this, null));
  };
  protoOf(BVH).s22 = function (intervals, comparators) {
    return this.t22(_BVHRect___init__impl__pawpsv(intervals), comparators);
  };
  protoOf(BVH).y20 = function (intervals, comparators, $super) {
    comparators = comparators === VOID ? Companion_getInstance_11() : comparators;
    return $super === VOID ? this.s22(intervals, comparators) : $super.s22.call(this, intervals, comparators);
  };
  protoOf(BVH).t22 = function (rect, comparators) {
    // Inline function 'kotlin.collections.mapNotNull' call
    var tmp0_root = this.u20_1;
    // Inline function 'kotlin.collections.mapNotNullTo' call
    var this_0 = _search_subtree$default(this, rect, comparators, VOID, tmp0_root);
    var destination = ArrayList_init_$Create$_0();
    // Inline function 'kotlin.collections.forEach' call
    var tmp0_iterator = this_0.u();
    while (tmp0_iterator.v()) {
      var element = tmp0_iterator.x();
      // Inline function 'kotlin.collections.mapNotNullTo.<anonymous>' call
      // Inline function 'korlibs.datastructure.ds.BVH.searchValues.<anonymous>' call
      var tmp0_safe_receiver = element.v21_1;
      if (tmp0_safe_receiver == null)
        null;
      else {
        // Inline function 'kotlin.let' call
        // Inline function 'kotlin.contracts.contract' call
        destination.r(tmp0_safe_receiver);
      }
    }
    return destination;
  };
  protoOf(BVH).w20 = function (intervals, obj) {
    return this.u22(_BVHRect___init__impl__pawpsv(intervals), obj);
  };
  protoOf(BVH).u22 = function (rect, obj) {
    checkDimensions(rect, this);
    if (this.r20_1) {
      var tmp = this.v20_1.s2(obj);
      var oldIntervals = tmp == null ? null : tmp.v22_1;
      var tmp_0 = oldIntervals;
      if (!((tmp_0 == null ? null : new BVHRect(tmp_0)) == null)) {
        var tmp_1 = oldIntervals;
        if (equals(new BVHRect(rect), tmp_1 == null ? null : new BVHRect(tmp_1))) {
          return Unit_instance;
        }
        // Inline function 'kotlin.collections.contains' call
        // Inline function 'kotlin.collections.containsKey' call
        var this_0 = this.v20_1;
        if ((isInterface(this_0, Map_0) ? this_0 : THROW_CCE()).p2(obj)) {
          this.w22(obj);
        }
      }
    }
    _insert_subtree(this, this.u20_1, new Node(rect, VOID, VOID, obj));
    if (this.r20_1) {
      // Inline function 'kotlin.collections.set' call
      var this_1 = this.v20_1;
      var value = new BVHRect(rect);
      this_1.i2(obj, value);
    }
  };
  protoOf(BVH).w22 = function (obj) {
    if (!this.r20_1) {
      // Inline function 'kotlin.error' call
      var message = 'allowUpdateObjects not enabled';
      throw IllegalStateException_init_$Create$(toString(message));
    }
    var tmp = this.v20_1.s2(obj);
    var intervals = tmp == null ? null : tmp.v22_1;
    var tmp_0 = intervals;
    if (!((tmp_0 == null ? null : new BVHRect(tmp_0)) == null)) {
      this.x22(intervals, obj);
    }
  };
  protoOf(BVH).y22 = function (rect, obj, comparators) {
    checkDimensions(rect, this);
    // Inline function 'kotlin.also' call
    var tmp;
    if (obj == null) {
      var ret_array = fastArrayListOf([]);
      do {
        var numberdeleted = ret_array.n();
        var tmp0_root = this.u20_1;
        ret_array.d22(_remove_subtree(this, rect, null, tmp0_root, comparators));
      }
       while (!(numberdeleted === ret_array.n()));
      tmp = ret_array;
    } else {
      var tmp1_root = this.u20_1;
      tmp = _remove_subtree(this, rect, obj, tmp1_root, comparators);
    }
    var this_0 = tmp;
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.datastructure.ds.BVH.remove.<anonymous>' call
    if (this.r20_1) {
      // Inline function 'korlibs.datastructure.FastArrayList.fastForEach' call
      // Inline function 'korlibs.datastructure.FastArrayList.jsArray' call
      // Inline function 'kotlin.js.unsafeCast' call
      // Inline function 'kotlin.js.asDynamic' call
      var array = this_0.y1u_1;
      var n = 0;
      while (n < array.length) {
        // Inline function 'korlibs.datastructure.ds.BVH.remove.<anonymous>.<anonymous>' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'get' call
        var tmp0 = n;
        n = tmp0 + 1 | 0;
        // Inline function 'kotlin.js.asDynamic' call
        // Inline function 'kotlin.js.asDynamic' call
        var node = array[tmp0];
        // Inline function 'kotlin.collections.remove' call
        var this_1 = this.v20_1;
        var key = node.v21_1;
        var tmp_0 = (isInterface(this_1, MutableMap) ? this_1 : THROW_CCE()).j2(key);
        tmp_0 == null || tmp_0.v22_1;
      }
    }
    return this_0;
  };
  protoOf(BVH).x22 = function (rect, obj, comparators, $super) {
    obj = obj === VOID ? null : obj;
    comparators = comparators === VOID ? Companion_getInstance_11() : comparators;
    return $super === VOID ? this.y22(rect, obj, comparators) : $super.y22.call(this, new BVHRect(rect), obj, comparators);
  };
  function _BVHRect___init__impl__pawpsv(intervals) {
    return intervals;
  }
  function _BVHRect___get_intervals__impl__r54djc($this) {
    return $this;
  }
  function _BVHRect___init__impl__pawpsv_0(dimensions) {
    return _BVHRect___init__impl__pawpsv(BVHIntervals_init_$Create$(dimensions));
  }
  function BVHRect__checkDimensions_impl_tlq5ao($this, dimensions) {
    checkDimensions_0(_BVHRect___get_dimensions__impl__9rcjgr($this), dimensions);
  }
  function _BVHRect___get_data__impl__kn7sj6($this) {
    return _BVHRect___get_intervals__impl__r54djc($this).z21_1;
  }
  function BVHRect__copyFrom_impl_kjg73e($this, other) {
    _BVHRect___get_intervals__impl__r54djc($this).z22(_BVHRect___get_intervals__impl__r54djc(other));
    return $this;
  }
  function BVHRect__clone_impl_weisiw($this) {
    // Inline function 'kotlin.collections.copyOf' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$1 = _BVHRect___get_data__impl__kn7sj6($this).slice();
    return _BVHRect___init__impl__pawpsv(new BVHIntervals(tmp$ret$1));
  }
  function _BVHRect___get_length__impl__sgc79u($this) {
    return _BVHRect___get_dimensions__impl__9rcjgr($this);
  }
  function _BVHRect___get_dimensions__impl__9rcjgr($this) {
    return _BVHRect___get_data__impl__kn7sj6($this).length / 2 | 0;
  }
  function BVHRect__min_impl_5ss93n($this, dim) {
    return _BVHRect___get_data__impl__kn7sj6($this)[imul(dim, 2) + 0 | 0];
  }
  function BVHRect__size_impl_axghd8($this, dim) {
    return _BVHRect___get_data__impl__kn7sj6($this)[imul(dim, 2) + 1 | 0];
  }
  function BVHRect__max_impl_z6ab7l($this, dim) {
    return BVHRect__min_impl_5ss93n($this, dim) + BVHRect__size_impl_axghd8($this, dim);
  }
  function BVHRect__min_impl_5ss93n_0($this, dim, value) {
    _BVHRect___get_data__impl__kn7sj6($this)[imul(dim, 2) + 0 | 0] = value;
  }
  function BVHRect__size_impl_axghd8_0($this, dim, value) {
    _BVHRect___get_data__impl__kn7sj6($this)[imul(dim, 2) + 1 | 0] = value;
  }
  function _BVHRect___get_min__impl__nebhl8($this) {
    var tmp = 0;
    var tmp_0 = _BVHRect___get_dimensions__impl__9rcjgr($this);
    var tmp_1 = new Float64Array(tmp_0);
    while (tmp < tmp_0) {
      var tmp_2 = tmp;
      tmp_1[tmp_2] = BVHRect__min_impl_5ss93n($this, tmp_2);
      tmp = tmp + 1 | 0;
    }
    return new BVHVector(tmp_1);
  }
  function _BVHRect___get_max__impl__6r11ia($this) {
    var tmp = 0;
    var tmp_0 = _BVHRect___get_dimensions__impl__9rcjgr($this);
    var tmp_1 = new Float64Array(tmp_0);
    while (tmp < tmp_0) {
      var tmp_2 = tmp;
      tmp_1[tmp_2] = BVHRect__max_impl_z6ab7l($this, tmp_2);
      tmp = tmp + 1 | 0;
    }
    return new BVHVector(tmp_1);
  }
  function BVHRect__toString_impl_z8yavd($this) {
    return 'BVHRect(min=' + _BVHRect___get_min__impl__nebhl8($this) + ', max=' + _BVHRect___get_max__impl__6r11ia($this) + ')';
  }
  function BVHRect__hashCode_impl_dhse2i($this) {
    return $this.hashCode();
  }
  function BVHRect__equals_impl_cirifq($this, other) {
    if (!(other instanceof BVHRect))
      return false;
    var tmp0_other_with_cast = other instanceof BVHRect ? other.v22_1 : THROW_CCE();
    if (!$this.equals(tmp0_other_with_cast))
      return false;
    return true;
  }
  function BVHRect(intervals) {
    this.v22_1 = intervals;
  }
  protoOf(BVHRect).toString = function () {
    return BVHRect__toString_impl_z8yavd(this.v22_1);
  };
  protoOf(BVHRect).hashCode = function () {
    return BVHRect__hashCode_impl_dhse2i(this.v22_1);
  };
  protoOf(BVHRect).equals = function (other) {
    return BVHRect__equals_impl_cirifq(this.v22_1, other);
  };
  function BVHIntervals_init_$Init$(dimensions, $this) {
    BVHIntervals.call($this, new Float64Array(imul(dimensions, 2)));
    return $this;
  }
  function BVHIntervals_init_$Create$(dimensions) {
    return BVHIntervals_init_$Init$(dimensions, objectCreate(protoOf(BVHIntervals)));
  }
  function Companion_12() {
  }
  protoOf(Companion_12).p20 = function (values) {
    var tmp = 0;
    var tmp_0 = values.length;
    var tmp_1 = new Float64Array(tmp_0);
    while (tmp < tmp_0) {
      var tmp_2 = tmp;
      tmp_1[tmp_2] = values[tmp_2];
      tmp = tmp + 1 | 0;
    }
    return new BVHIntervals(tmp_1);
  };
  var Companion_instance_12;
  function Companion_getInstance_12() {
    return Companion_instance_12;
  }
  function BVHIntervals(data) {
    this.z21_1 = data;
    this.a22_1 = contentHashCode_2(this.z21_1);
  }
  protoOf(BVHIntervals).hashCode = function () {
    return this.a22_1;
  };
  protoOf(BVHIntervals).equals = function (other) {
    var tmp;
    if (other instanceof BVHIntervals) {
      tmp = contentEquals_2(this.z21_1, other.z21_1);
    } else {
      tmp = false;
    }
    return tmp;
  };
  protoOf(BVHIntervals).a = function () {
    return this.z21_1.length / 2 | 0;
  };
  protoOf(BVHIntervals).a23 = function (dim) {
    return this.z21_1[imul(dim, 2) + 0 | 0];
  };
  protoOf(BVHIntervals).b23 = function (dim) {
    return this.z21_1[imul(dim, 2) + 1 | 0];
  };
  protoOf(BVHIntervals).b22 = function () {
    var result = 0.0;
    var data = this.z21_1;
    var inductionVariable = 0;
    var last = this.a();
    if (inductionVariable < last)
      do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        result = result + data[imul(n, 2) + 1 | 0];
      }
       while (inductionVariable < last);
    return result;
  };
  protoOf(BVHIntervals).c22 = function () {
    var result = 1.0;
    var data = this.z21_1;
    var inductionVariable = 0;
    var last = this.a();
    if (inductionVariable < last)
      do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        result = result * data[imul(n, 2) + 1 | 0];
      }
       while (inductionVariable < last);
    return result;
  };
  protoOf(BVHIntervals).z22 = function (other) {
    // Inline function 'kotlin.collections.copyInto' call
    var this_0 = other.z21_1;
    var destination = this.z21_1;
    var endIndex = this_0.length;
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp = this_0;
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    arrayCopy(tmp, destination, 0, 0, endIndex);
    return this;
  };
  protoOf(BVHIntervals).toString = function () {
    // Inline function 'kotlin.text.buildString' call
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'kotlin.apply' call
    var this_0 = StringBuilder_init_$Create$_0();
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.datastructure.ds.BVHIntervals.toString.<anonymous>' call
    this_0.v5(_Char___init__impl__6a9atx(91));
    var inductionVariable = 0;
    var last = this.a();
    if (inductionVariable < last)
      do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        if (!(n === 0)) {
          this_0.u5(', ');
        }
        this_0.v5(Char__plus_impl_qi7pgj(_Char___init__impl__6a9atx(120), n));
        this_0.v5(_Char___init__impl__6a9atx(61));
        this_0.v5(_Char___init__impl__6a9atx(40));
        this_0.m8(this.a23(n));
        this_0.v5(_Char___init__impl__6a9atx(44));
        this_0.m8(this.b23(n));
        this_0.v5(_Char___init__impl__6a9atx(41));
      }
       while (inductionVariable < last);
    this_0.v5(_Char___init__impl__6a9atx(93));
    return this_0.toString();
  };
  function Companion_13() {
  }
  var Companion_instance_13;
  function Companion_getInstance_13() {
    return Companion_instance_13;
  }
  function BVHVector$toString$lambda(it) {
    return get_niceStr(it);
  }
  function BVHVector(data) {
    this.c23_1 = data;
  }
  protoOf(BVHVector).equals = function (other) {
    var tmp;
    if (other instanceof BVHVector) {
      tmp = contentEquals_2(this.c23_1, other.c23_1);
    } else {
      tmp = false;
    }
    return tmp;
  };
  protoOf(BVHVector).toString = function () {
    return 'BVHVector(' + joinToString_0(this.c23_1, ', ', VOID, VOID, VOID, VOID, BVHVector$toString$lambda) + ')';
  };
  protoOf(BVHVector).hashCode = function () {
    return hashCode(this.c23_1);
  };
  function checkDimensions_0(actual, expected) {
    if (!(actual === expected)) {
      // Inline function 'kotlin.error' call
      var message = 'element ' + actual + " doesn't match dimensions " + expected;
      throw IllegalStateException_init_$Create$(toString(message));
    }
  }
  function contentHashCode_3(_this__u8e3s4, src, dst) {
    // Inline function 'korlibs.datastructure.internal.hashCoder' call
    var count = dst - src | 0;
    var out = 0;
    var inductionVariable = 0;
    if (inductionVariable < count)
      do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        out = imul(out, 7);
        var tmp = out;
        // Inline function 'korlibs.datastructure.internal.contentHashCode.<anonymous>' call
        out = tmp + numberToInt(_this__u8e3s4[src + n | 0]) | 0;
      }
       while (inductionVariable < count);
    return out;
  }
  function contentEquals_3(_this__u8e3s4, that, src, dst) {
    var tmp$ret$1;
    $l$block: {
      // Inline function 'korlibs.datastructure.internal.equaler' call
      var count = dst - src | 0;
      var inductionVariable = 0;
      if (inductionVariable < count)
        do {
          var n = inductionVariable;
          inductionVariable = inductionVariable + 1 | 0;
          // Inline function 'korlibs.datastructure.internal.contentEquals.<anonymous>' call
          if (!(_this__u8e3s4[src + n | 0] === that[src + n | 0])) {
            tmp$ret$1 = false;
            break $l$block;
          }
        }
         while (inductionVariable < count);
      tmp$ret$1 = true;
    }
    return tmp$ret$1;
  }
  function contentHashCode_4(_this__u8e3s4, src, dst) {
    // Inline function 'korlibs.datastructure.internal.hashCoder' call
    var count = dst - src | 0;
    var out = 0;
    var inductionVariable = 0;
    if (inductionVariable < count)
      do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        out = imul(out, 7);
        var tmp = out;
        // Inline function 'korlibs.datastructure.internal.contentHashCode.<anonymous>' call
        out = tmp + _this__u8e3s4[src + n | 0] | 0;
      }
       while (inductionVariable < count);
    return out;
  }
  function contentEquals_4(_this__u8e3s4, that, src, dst) {
    var tmp$ret$1;
    $l$block: {
      // Inline function 'korlibs.datastructure.internal.equaler' call
      var count = dst - src | 0;
      var inductionVariable = 0;
      if (inductionVariable < count)
        do {
          var n = inductionVariable;
          inductionVariable = inductionVariable + 1 | 0;
          // Inline function 'korlibs.datastructure.internal.contentEquals.<anonymous>' call
          if (!(_this__u8e3s4[src + n | 0] === that[src + n | 0])) {
            tmp$ret$1 = false;
            break $l$block;
          }
        }
         while (inductionVariable < count);
      tmp$ret$1 = true;
    }
    return tmp$ret$1;
  }
  function contentHashCode_5(_this__u8e3s4, src, dst) {
    // Inline function 'korlibs.datastructure.internal.hashCoder' call
    var count = dst - src | 0;
    var out = 0;
    var inductionVariable = 0;
    if (inductionVariable < count)
      do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        out = imul(out, 7);
        var tmp = out;
        // Inline function 'korlibs.datastructure.internal.contentHashCode.<anonymous>' call
        out = tmp + toRawBits(_this__u8e3s4[src + n | 0]) | 0;
      }
       while (inductionVariable < count);
    return out;
  }
  function contentEquals_5(_this__u8e3s4, that, src, dst) {
    var tmp$ret$1;
    $l$block: {
      // Inline function 'korlibs.datastructure.internal.equaler' call
      var count = dst - src | 0;
      var inductionVariable = 0;
      if (inductionVariable < count)
        do {
          var n = inductionVariable;
          inductionVariable = inductionVariable + 1 | 0;
          // Inline function 'korlibs.datastructure.internal.contentEquals.<anonymous>' call
          if (!(_this__u8e3s4[src + n | 0] === that[src + n | 0])) {
            tmp$ret$1 = false;
            break $l$block;
          }
        }
         while (inductionVariable < count);
      tmp$ret$1 = true;
    }
    return tmp$ret$1;
  }
  function fill(_this__u8e3s4, value) {
    var inductionVariable = 0;
    var last = _this__u8e3s4.length - 1 | 0;
    if (inductionVariable <= last)
      do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        _this__u8e3s4[n] = value;
      }
       while (inductionVariable <= last);
  }
  function SyncPauseable() {
    this.d23_1 = new Lock();
    this.e23_1 = false;
  }
  protoOf(SyncPauseable).f23 = function (value) {
    if (!(this.e23_1 === value)) {
      this.e23_1 = value;
      $l$block: {
        // Inline function 'korlibs.concurrent.lock.Lock.invoke' call
        var this_0 = this.d23_1;
        this_0.y1p_1 = true;
        try {
          this.d23_1.x1p();
          break $l$block;
        }finally {
          this_0.y1p_1 = false;
        }
      }
    }
  };
  function Extra$PropertyThis$transform$lambda($this$null, it) {
    return it;
  }
  function Mixin(extra) {
    extra = extra === VOID ? null : extra;
    this.g23_1 = extra;
  }
  protoOf(Mixin).h23 = function (_set____db54di) {
    this.g23_1 = _set____db54di;
  };
  protoOf(Mixin).i23 = function () {
    return this.g23_1;
  };
  function Property(name, defaultGen) {
    name = name === VOID ? null : name;
    this.j23_1 = name;
    this.k23_1 = defaultGen;
  }
  function PropertyThis(name, defaultGen) {
    name = name === VOID ? null : name;
    this.l23_1 = name;
    this.m23_1 = defaultGen;
    var tmp = this;
    tmp.n23_1 = Extra$PropertyThis$transform$lambda;
  }
  function ExtraObject() {
    this.o23_1 = new Lock();
    this.p23_1 = FastStringMap();
    var tmp = this;
    var tmp$ret$1;
    $l$block: {
      // Inline function 'korlibs.concurrent.lock.Lock.invoke' call
      var this_0 = this.o23_1;
      this_0.y1p_1 = true;
      try {
        // Inline function 'korlibs.datastructure.ExtraObject.values.<anonymous>' call
        tmp$ret$1 = toMutableList(get_values(this.p23_1));
        break $l$block;
      }finally {
        this_0.y1p_1 = false;
      }
    }
    tmp.q23_1 = tmp$ret$1;
  }
  protoOf(ExtraObject).n = function () {
    var tmp$ret$1;
    $l$block: {
      // Inline function 'korlibs.concurrent.lock.Lock.invoke' call
      var this_0 = this.o23_1;
      this_0.y1p_1 = true;
      try {
        // Inline function 'korlibs.datastructure.ExtraObject.<get-size>.<anonymous>' call
        tmp$ret$1 = get_size_1(this.p23_1);
        break $l$block;
      }finally {
        this_0.y1p_1 = false;
      }
    }
    return tmp$ret$1;
  };
  protoOf(ExtraObject).k2 = function () {
    var tmp$ret$6;
    $l$block: {
      // Inline function 'korlibs.concurrent.lock.Lock.invoke' call
      var this_0 = this.o23_1;
      this_0.y1p_1 = true;
      try {
        // Inline function 'korlibs.datastructure.ExtraObject.<get-entries>.<anonymous>' call
        // Inline function 'kotlin.collections.associateWith' call
        var this_1 = get_keys_0(this.p23_1);
        var result = LinkedHashMap_init_$Create$_0(coerceAtLeast(mapCapacity(collectionSizeOrDefault(this_1, 10)), 16));
        // Inline function 'kotlin.collections.associateWithTo' call
        var tmp0_iterator = this_1.u();
        while (tmp0_iterator.v()) {
          var element = tmp0_iterator.x();
          // Inline function 'korlibs.datastructure.ExtraObject.<get-entries>.<anonymous>.<anonymous>' call
          // Inline function 'korlibs.datastructure.get' call
          // Inline function 'kotlin.js.asDynamic' call
          var tmp$ret$2 = this.p23_1.get(element);
          result.i2(element, tmp$ret$2);
        }
        tmp$ret$6 = toMutableSet(toMutableMap(result).k2());
        break $l$block;
      }finally {
        this_0.y1p_1 = false;
      }
    }
    return tmp$ret$6;
  };
  protoOf(ExtraObject).g2 = function () {
    var tmp$ret$1;
    $l$block: {
      // Inline function 'korlibs.concurrent.lock.Lock.invoke' call
      var this_0 = this.o23_1;
      this_0.y1p_1 = true;
      try {
        // Inline function 'korlibs.datastructure.ExtraObject.<get-keys>.<anonymous>' call
        tmp$ret$1 = toMutableSet(get_keys_0(this.p23_1));
        break $l$block;
      }finally {
        this_0.y1p_1 = false;
      }
    }
    return tmp$ret$1;
  };
  protoOf(ExtraObject).h2 = function () {
    return this.q23_1;
  };
  protoOf(ExtraObject).s13 = function (key) {
    var tmp$ret$3;
    $l$block: {
      // Inline function 'korlibs.concurrent.lock.Lock.invoke' call
      var this_0 = this.o23_1;
      this_0.y1p_1 = true;
      try {
        // Inline function 'korlibs.datastructure.ExtraObject.get.<anonymous>' call
        // Inline function 'korlibs.datastructure.get' call
        // Inline function 'kotlin.js.asDynamic' call
        tmp$ret$3 = this.p23_1.get(key);
        break $l$block;
      }finally {
        this_0.y1p_1 = false;
      }
    }
    return tmp$ret$3;
  };
  protoOf(ExtraObject).s2 = function (key) {
    if (!(!(key == null) ? typeof key === 'string' : false))
      return null;
    return this.s13((!(key == null) ? typeof key === 'string' : false) ? key : THROW_CCE());
  };
  protoOf(ExtraObject).r23 = function (key, value) {
    var tmp$ret$3;
    $l$block: {
      // Inline function 'korlibs.concurrent.lock.Lock.invoke' call
      var this_0 = this.o23_1;
      this_0.y1p_1 = true;
      try {
        // Inline function 'korlibs.datastructure.set' call
        // Inline function 'kotlin.run' call
        // Inline function 'kotlin.contracts.contract' call
        // Inline function 'kotlin.js.asDynamic' call
        tmp$ret$3 = this.p23_1.set(key, value);
        break $l$block;
      }finally {
        this_0.y1p_1 = false;
      }
    }
    return tmp$ret$3;
  };
  protoOf(ExtraObject).s23 = function (key) {
    var tmp$ret$3;
    $l$block: {
      // Inline function 'korlibs.concurrent.lock.Lock.invoke' call
      var this_0 = this.o23_1;
      this_0.y1p_1 = true;
      try {
        // Inline function 'korlibs.datastructure.ExtraObject.contains.<anonymous>' call
        // Inline function 'korlibs.datastructure.contains' call
        // Inline function 'kotlin.js.asDynamic' call
        tmp$ret$3 = this.p23_1.has(key);
        break $l$block;
      }finally {
        this_0.y1p_1 = false;
      }
    }
    return tmp$ret$3;
  };
  protoOf(ExtraObject).b1 = function () {
    return this.n() === 0;
  };
  protoOf(ExtraObject).b3 = function () {
    var tmp$ret$1;
    $l$block: {
      // Inline function 'korlibs.concurrent.lock.Lock.invoke' call
      var this_0 = this.o23_1;
      this_0.y1p_1 = true;
      try {
        // Inline function 'kotlin.js.asDynamic' call
        tmp$ret$1 = this.p23_1.clear();
        break $l$block;
      }finally {
        this_0.y1p_1 = false;
      }
    }
    return tmp$ret$1;
  };
  protoOf(ExtraObject).r1t = function (key) {
    $l$block: {
      // Inline function 'korlibs.concurrent.lock.Lock.invoke' call
      var this_0 = this.o23_1;
      this_0.y1p_1 = true;
      try {
        // Inline function 'kotlin.js.asDynamic' call
        this.p23_1.delete(key);
        break $l$block;
      }finally {
        this_0.y1p_1 = false;
      }
    }
    return Unit_instance;
  };
  protoOf(ExtraObject).j2 = function (key) {
    if (!(!(key == null) ? typeof key === 'string' : false))
      return null;
    return this.r1t((!(key == null) ? typeof key === 'string' : false) ? key : THROW_CCE());
  };
  protoOf(ExtraObject).t23 = function (key, value) {
    $l$block: {
      // Inline function 'korlibs.concurrent.lock.Lock.invoke' call
      var this_0 = this.o23_1;
      this_0.y1p_1 = true;
      try {
        // Inline function 'korlibs.datastructure.set' call
        // Inline function 'kotlin.run' call
        // Inline function 'kotlin.contracts.contract' call
        // Inline function 'kotlin.js.asDynamic' call
        this.p23_1.set(key, value);
        break $l$block;
      }finally {
        this_0.y1p_1 = false;
      }
    }
    return Unit_instance;
  };
  protoOf(ExtraObject).i2 = function (key, value) {
    var tmp = (!(key == null) ? typeof key === 'string' : false) ? key : THROW_CCE();
    return this.t23(tmp, (value == null ? true : !(value == null)) ? value : THROW_CCE());
  };
  protoOf(ExtraObject).r13 = function (key) {
    var tmp$ret$3;
    $l$block: {
      // Inline function 'korlibs.concurrent.lock.Lock.invoke' call
      var this_0 = this.o23_1;
      this_0.y1p_1 = true;
      try {
        // Inline function 'korlibs.datastructure.ExtraObject.containsKey.<anonymous>' call
        // Inline function 'korlibs.datastructure.contains' call
        // Inline function 'kotlin.js.asDynamic' call
        tmp$ret$3 = this.p23_1.has(key);
        break $l$block;
      }finally {
        this_0.y1p_1 = false;
      }
    }
    return tmp$ret$3;
  };
  protoOf(ExtraObject).p2 = function (key) {
    if (!(!(key == null) ? typeof key === 'string' : false))
      return false;
    return this.r13((!(key == null) ? typeof key === 'string' : false) ? key : THROW_CCE());
  };
  function getExtra(_this__u8e3s4, name) {
    var tmp0_safe_receiver = _this__u8e3s4.i23();
    return tmp0_safe_receiver == null ? null : tmp0_safe_receiver.s13(name);
  }
  function setExtra(_this__u8e3s4, name, value) {
    if (_this__u8e3s4.i23() == null) {
      if (value == null)
        return Unit_instance;
      _this__u8e3s4.h23(ExtraTypeCreate());
    }
    var tmp0_safe_receiver = _this__u8e3s4.i23();
    if (tmp0_safe_receiver == null)
      null;
    else {
      tmp0_safe_receiver.r23(name, value);
    }
  }
  function hasExtra(_this__u8e3s4, name) {
    var tmp0_safe_receiver = _this__u8e3s4.i23();
    return (tmp0_safe_receiver == null ? null : tmp0_safe_receiver.s23(name)) === true;
  }
  function getExtraTyped(_this__u8e3s4, name) {
    // Inline function 'korlibs.datastructure.fastCastTo' call
    var tmp0_safe_receiver = _this__u8e3s4.i23();
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return tmp0_safe_receiver == null ? null : tmp0_safe_receiver.s13(name);
  }
  function ExtraTypeCreate() {
    return new ExtraObject();
  }
  function _BSearchResult___init__impl__em6zam(raw) {
    return raw;
  }
  function _BSearchResult___get_raw__impl__uyuhf3($this) {
    return $this;
  }
  function _BSearchResult___get_found__impl__om04iz($this) {
    return _BSearchResult___get_raw__impl__uyuhf3($this) >= 0;
  }
  function _BSearchResult___get_index__impl__b5kraz($this) {
    return _BSearchResult___get_found__impl__om04iz($this) ? _BSearchResult___get_raw__impl__uyuhf3($this) : -1;
  }
  function _BSearchResult___get_nearIndex__impl__s8nq43($this) {
    return _BSearchResult___get_found__impl__om04iz($this) ? _BSearchResult___get_raw__impl__uyuhf3($this) : (-_BSearchResult___get_raw__impl__uyuhf3($this) | 0) - 1 | 0;
  }
  function binarySearch(_this__u8e3s4, v, fromIndex, toIndex) {
    fromIndex = fromIndex === VOID ? 0 : fromIndex;
    toIndex = toIndex === VOID ? _this__u8e3s4.n() : toIndex;
    // Inline function 'korlibs.datastructure.genericBinarySearchResult' call
    var tmp$ret$1;
    $l$block: {
      // Inline function 'korlibs.datastructure.genericBinarySearch' call
      var low = fromIndex;
      var high = toIndex - 1 | 0;
      while (low <= high) {
        var mid = (low + high | 0) / 2 | 0;
        // Inline function 'korlibs.datastructure.binarySearch.<anonymous>' call
        var mval = compareTo(_this__u8e3s4.b1r(mid), v);
        if (mval < 0)
          low = mid + 1 | 0;
        else if (mval > 0)
          high = mid - 1 | 0;
        else {
          tmp$ret$1 = mid;
          break $l$block;
        }
      }
      // Inline function 'korlibs.datastructure.genericBinarySearchResult.<anonymous>' call
      tmp$ret$1 = (-low | 0) - 1 | 0;
    }
    return _BSearchResult___init__impl__em6zam(tmp$ret$1);
  }
  function getCyclic(_this__u8e3s4, index) {
    return _this__u8e3s4.f1(Math_instance.m1r(index, _this__u8e3s4.n()));
  }
  function linkedHashMapOf(pairs) {
    // Inline function 'kotlin.also' call
    var this_0 = LinkedHashMap_init_$Create$();
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.datastructure.linkedHashMapOf.<anonymous>' call
    var inductionVariable = 0;
    var last = pairs.length;
    while (inductionVariable < last) {
      var tmp1_loop_parameter = pairs[inductionVariable];
      inductionVariable = inductionVariable + 1 | 0;
      var key = tmp1_loop_parameter.cg();
      var value = tmp1_loop_parameter.dg();
      // Inline function 'kotlin.collections.set' call
      this_0.i2(key, value);
    }
    return this_0;
  }
  function flip(_this__u8e3s4) {
    // Inline function 'kotlin.collections.map' call
    // Inline function 'kotlin.collections.mapTo' call
    var destination = ArrayList_init_$Create$(_this__u8e3s4.n());
    // Inline function 'kotlin.collections.iterator' call
    var tmp0_iterator = _this__u8e3s4.k2().u();
    while (tmp0_iterator.v()) {
      var item = tmp0_iterator.x();
      // Inline function 'korlibs.datastructure.flip.<anonymous>' call
      var tmp$ret$1 = new Pair(item.m2(), item.l2());
      destination.r(tmp$ret$1);
    }
    return toMap(destination);
  }
  function getCyclicOrNull(_this__u8e3s4, index) {
    return _this__u8e3s4.b1() ? null : getOrNull(_this__u8e3s4, Math_instance.m1r(index, _this__u8e3s4.n()));
  }
  function toLinkedMap_0(_this__u8e3s4) {
    // Inline function 'kotlin.also' call
    var this_0 = LinkedHashMap_init_$Create$();
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.datastructure.toLinkedMap.<anonymous>' call
    var tmp0_iterator = _this__u8e3s4.u();
    while (tmp0_iterator.v()) {
      var tmp1_loop_parameter = tmp0_iterator.x();
      var key = tmp1_loop_parameter.cg();
      var value = tmp1_loop_parameter.dg();
      // Inline function 'kotlin.collections.set' call
      this_0.i2(key, value);
    }
    return this_0;
  }
  function getCyclic_0(_this__u8e3s4, index) {
    return _this__u8e3s4[Math_instance.m1r(index, _this__u8e3s4.length)];
  }
  function genericSort(subject, left, right, ops) {
    return genericSort_0(subject, left, right, ops, false);
  }
  function SortOps() {
  }
  protoOf(SortOps).m1t = function (subject, indexL, indexR) {
    var inductionVariable = indexR;
    var last = indexL + 1 | 0;
    if (last <= inductionVariable)
      do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + -1 | 0;
        this.l1t(subject, n - 1 | 0, n);
      }
       while (!(n === last));
  };
  protoOf(SortOps).h1t = function (subject, indexL, indexR) {
    var count = (indexR - indexL | 0) + 1 | 0;
    var inductionVariable = 0;
    var last = count / 2 | 0;
    if (inductionVariable < last)
      do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        this.l1t(subject, indexL + n | 0, indexR - n | 0);
      }
       while (inductionVariable < last);
  };
  function genericSort_0(subject, left, right, ops, reversed) {
    // Inline function 'kotlin.also' call
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.datastructure.genericSort.<anonymous>' call
    timSort(subject, left, right, ops, reversed);
    return subject;
  }
  function timSort(arr, l, r, ops, reversed, RUN) {
    RUN = RUN === VOID ? 32 : RUN;
    var n = (r - l | 0) + 1 | 0;
    var progression = step(until(0, n), RUN);
    var inductionVariable = progression.fb_1;
    var last = progression.gb_1;
    var step_0 = progression.hb_1;
    if ((step_0 > 0 ? inductionVariable <= last : false) ? true : step_0 < 0 ? last <= inductionVariable : false)
      do {
        var i = inductionVariable;
        inductionVariable = inductionVariable + step_0 | 0;
        var tmp = l + i | 0;
        // Inline function 'kotlin.math.min' call
        var a = (i + RUN | 0) - 1 | 0;
        var b = n - 1 | 0;
        var tmp$ret$0 = Math.min(a, b);
        insertionSort(arr, tmp, l + tmp$ret$0 | 0, ops, reversed);
      }
       while (!(i === last));
    var size = RUN;
    while (size < n) {
      var progression_0 = step(until(0, n), imul(2, size));
      var inductionVariable_0 = progression_0.fb_1;
      var last_0 = progression_0.gb_1;
      var step_1 = progression_0.hb_1;
      if ((step_1 > 0 ? inductionVariable_0 <= last_0 : false) ? true : step_1 < 0 ? last_0 <= inductionVariable_0 : false)
        do {
          var left = inductionVariable_0;
          inductionVariable_0 = inductionVariable_0 + step_1 | 0;
          // Inline function 'kotlin.math.min' call
          var a_0 = size;
          var b_0 = (n - left | 0) - 1 | 0;
          var rize = Math.min(a_0, b_0);
          var mid = (left + rize | 0) - 1 | 0;
          // Inline function 'kotlin.math.min' call
          var a_1 = (left + imul(2, rize) | 0) - 1 | 0;
          var b_1 = n - 1 | 0;
          var right = Math.min(a_1, b_1);
          merge(arr, l + left | 0, l + mid | 0, l + right | 0, ops, reversed);
        }
         while (!(left === last_0));
      size = imul(size, 2);
    }
  }
  function insertionSort(arr, left, right, ops, reversed) {
    var inductionVariable = left + 1 | 0;
    if (inductionVariable <= right)
      do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var m = n - 1 | 0;
        $l$loop: while (m >= left && negateIf(ops.j1t(arr, m, n), reversed) > 0) {
          m = m - 1 | 0;
        }
        m = m + 1 | 0;
        if (!(m === n)) {
          ops.m1t(arr, m, n);
        }
      }
       while (!(n === right));
  }
  function merge(arr, start, mid, end, ops, reversed) {
    var s = start;
    var m = mid;
    var s2 = m + 1 | 0;
    if (negateIf(ops.j1t(arr, m, s2), reversed) <= 0)
      return Unit_instance;
    while (s <= m ? s2 <= end : false) {
      if (negateIf(ops.j1t(arr, s, s2), reversed) <= 0) {
        s = s + 1 | 0;
      } else {
        ops.m1t(arr, s, s2);
        s = s + 1 | 0;
        m = m + 1 | 0;
        s2 = s2 + 1 | 0;
      }
    }
  }
  function negateIf(_this__u8e3s4, doNegate) {
    return doNegate ? -_this__u8e3s4 | 0 : _this__u8e3s4;
  }
  function isAlmostEquals(_this__u8e3s4, other, epsilon) {
    epsilon = epsilon === VOID ? 1.0E-6 : epsilon;
    // Inline function 'kotlin.math.absoluteValue' call
    var this_0 = _this__u8e3s4 - other;
    return Math.abs(this_0) < epsilon;
  }
  function Math_0() {
    this.l1r_1 = -0.0;
  }
  protoOf(Math_0).m1r = function (_this__u8e3s4, other) {
    var rm = _this__u8e3s4 % other | 0;
    var remainder = rm === 0 ? 0 : rm;
    return remainder < 0 ? remainder + other | 0 : remainder;
  };
  protoOf(Math_0).n1w = function (v) {
    // Inline function 'kotlin.math.ceil' call
    // Inline function 'kotlin.math.log2' call
    var x = log2(v);
    var tmp$ret$1 = Math.ceil(x);
    return numberToInt(tmp$ret$1);
  };
  var Math_instance;
  function Math_getInstance() {
    return Math_instance;
  }
  function get_niceStr(_this__u8e3s4) {
    return niceStr(_this__u8e3s4, -1, false);
  }
  function niceStr(_this__u8e3s4, decimalPlaces, zeroSuffix) {
    zeroSuffix = zeroSuffix === VOID ? false : zeroSuffix;
    // Inline function 'kotlin.text.buildString' call
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'kotlin.apply' call
    var this_0 = StringBuilder_init_$Create$_0();
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.datastructure.internal.math.niceStr.<anonymous>' call
    appendNice(this_0, roundDecimalPlaces(_this__u8e3s4, decimalPlaces), zeroSuffix ? decimalPlaces > 0 : false);
    return this_0.toString();
  }
  function appendNice(_this__u8e3s4, value, zeroSuffix) {
    zeroSuffix = zeroSuffix === VOID ? false : zeroSuffix;
    if (isAlmostEquals(round(value), value))
      if (value >= IntCompanionObject_instance.MIN_VALUE ? value <= IntCompanionObject_instance.MAX_VALUE : false) {
        _this__u8e3s4.j8(numberToInt(round(value)));
      } else {
        _this__u8e3s4.k8(numberToLong(round(value)));
      }
     else {
      _this__u8e3s4.m8(value);
      return Unit_instance;
    }
    if (zeroSuffix) {
      _this__u8e3s4.u5('.0');
    }
  }
  function roundDecimalPlaces(_this__u8e3s4, places) {
    if (places < 0)
      return _this__u8e3s4;
    // Inline function 'kotlin.math.pow' call
    var placesFactor = Math.pow(10.0, places);
    return round(_this__u8e3s4 * placesFactor) / placesFactor;
  }
  function Memory() {
  }
  protoOf(Memory).w1t = function (src, srcPos, dst, dstPos, size) {
    // Inline function 'kotlin.collections.copyInto' call
    var destination = isArray(dst) ? dst : THROW_CCE();
    var endIndex = srcPos + size | 0;
    arrayCopy(src, destination, dstPos, srcPos, endIndex);
  };
  protoOf(Memory).z1z = function (src, srcPos, dst, dstPos, size) {
    // Inline function 'kotlin.collections.copyInto' call
    var endIndex = srcPos + size | 0;
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp = src;
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    arrayCopy(tmp, dst, dstPos, srcPos, endIndex);
  };
  protoOf(Memory).q1s = function (src, srcPos, dst, dstPos, size) {
    // Inline function 'kotlin.collections.copyInto' call
    var endIndex = srcPos + size | 0;
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp = src;
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    arrayCopy(tmp, dst, dstPos, srcPos, endIndex);
  };
  protoOf(Memory).d1t = function (src, srcPos, dst, dstPos, size) {
    // Inline function 'kotlin.collections.copyInto' call
    var endIndex = srcPos + size | 0;
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp = src;
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    arrayCopy(tmp, dst, dstPos, srcPos, endIndex);
  };
  protoOf(Memory).z1r = function (src, srcPos, dst, dstPos, size) {
    // Inline function 'kotlin.collections.copyInto' call
    var endIndex = srcPos + size | 0;
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp = src;
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    arrayCopy(tmp, dst, dstPos, srcPos, endIndex);
  };
  var Memory_instance;
  function Memory_getInstance() {
    return Memory_instance;
  }
  function FastArrayList_init_$Init$($this) {
    // Inline function 'kotlin.emptyArray' call
    var tmp$ret$0 = [];
    FastArrayList.call($this, tmp$ret$0);
    return $this;
  }
  function FastArrayList_init_$Create$() {
    return FastArrayList_init_$Init$(objectCreate(protoOf(FastArrayList)));
  }
  function FastArrayList_init_$Init$_0(initialCapacity, $this) {
    // Inline function 'kotlin.emptyArray' call
    var tmp$ret$0 = [];
    FastArrayList.call($this, tmp$ret$0);
    return $this;
  }
  function FastArrayList_init_$Create$_0(initialCapacity) {
    return FastArrayList_init_$Init$_0(initialCapacity, objectCreate(protoOf(FastArrayList)));
  }
  function FastArrayList_init_$Init$_1(elements, $this) {
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.collections.toTypedArray' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$2 = copyToArray(elements);
    FastArrayList.call($this, tmp$ret$2);
    return $this;
  }
  function FastArrayList_init_$Create$_1(elements) {
    return FastArrayList_init_$Init$_1(elements, objectCreate(protoOf(FastArrayList)));
  }
  function _addAll($this, elements) {
    // Inline function 'kotlin.collections.isEmpty' call
    if (elements.length === 0)
      return false;
    // Inline function 'korlibs.datastructure.FastArrayList.jsArray' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$3 = $this.y1u_1;
    (function () {
      var $externalVarargReceiverTmp = tmp$ret$3;
      return $externalVarargReceiverTmp.push.apply($externalVarargReceiverTmp, [].slice.call(elements.slice()));
    }.call(this));
    $this.g1_1 = $this.g1_1 + 1 | 0;
    return true;
  }
  function rangeCheck($this, index) {
    if (index < 0 ? true : index >= $this.n())
      throw IndexOutOfBoundsException_init_$Create$_0('index: ' + index + ', size: ' + $this.n());
    return index;
  }
  function insertionRangeCheck($this, index) {
    if (index < 0 ? true : index > $this.n())
      throw IndexOutOfBoundsException_init_$Create$_0('index: ' + index + ', size: ' + $this.n());
    return index;
  }
  function FastArrayList(__array) {
    AbstractMutableList.call(this);
    this.y1u_1 = __array;
  }
  protoOf(FastArrayList).n = function () {
    // Inline function 'korlibs.datastructure.FastArrayList.jsArray' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return this.y1u_1.length;
  };
  protoOf(FastArrayList).f1 = function (index) {
    // Inline function 'get' call
    // Inline function 'korlibs.datastructure.FastArrayList.jsArray' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    // Inline function 'kotlin.js.asDynamic' call
    return this.y1u_1[rangeCheck(this, index)];
  };
  protoOf(FastArrayList).o = function (index, element) {
    rangeCheck(this, index);
    // Inline function 'kotlin.apply' call
    // Inline function 'get' call
    // Inline function 'korlibs.datastructure.FastArrayList.jsArray' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    // Inline function 'kotlin.js.asDynamic' call
    var this_0 = this.y1u_1[index];
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.datastructure.FastArrayList.set.<anonymous>' call
    // Inline function 'set' call
    // Inline function 'korlibs.datastructure.FastArrayList.jsArray' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    // Inline function 'kotlin.js.asDynamic' call
    this.y1u_1[index] = element;
    return this_0;
  };
  protoOf(FastArrayList).r = function (element) {
    // Inline function 'korlibs.datastructure.FastArrayList.jsArray' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    this.y1u_1.push(element);
    this.g1_1 = this.g1_1 + 1 | 0;
    return true;
  };
  protoOf(FastArrayList).t1 = function (index, element) {
    // Inline function 'korlibs.datastructure.FastArrayList.jsArray' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    this.y1u_1.splice(insertionRangeCheck(this, index), 0, element);
    this.g1_1 = this.g1_1 + 1 | 0;
  };
  protoOf(FastArrayList).d22 = function (elements) {
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'korlibs.datastructure.FastArrayList.jsArray' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$4 = elements.y1u_1;
    return _addAll(this, tmp$ret$4);
  };
  protoOf(FastArrayList).y = function (elements) {
    // Inline function 'kotlin.collections.toTypedArray' call
    var tmp$ret$0 = copyToArray(elements);
    return _addAll(this, tmp$ret$0);
  };
  protoOf(FastArrayList).h1 = function (index) {
    rangeCheck(this, index);
    this.g1_1 = this.g1_1 + 1 | 0;
    var tmp;
    if (index === 0) {
      // Inline function 'korlibs.datastructure.FastArrayList.jsArray' call
      // Inline function 'kotlin.js.unsafeCast' call
      // Inline function 'kotlin.js.asDynamic' call
      tmp = this.y1u_1.shift();
    } else if (index === get_lastIndex(this)) {
      // Inline function 'korlibs.datastructure.FastArrayList.jsArray' call
      // Inline function 'kotlin.js.unsafeCast' call
      // Inline function 'kotlin.js.asDynamic' call
      tmp = this.y1u_1.pop();
    } else {
      // Inline function 'kotlin.js.unsafeCast' call
      // Inline function 'korlibs.datastructure.FastArrayList.jsArray' call
      // Inline function 'kotlin.js.unsafeCast' call
      // Inline function 'kotlin.js.asDynamic' call
      // Inline function 'kotlin.js.asDynamic' call
      tmp = this.y1u_1.splice(index, 1)[0];
    }
    return tmp;
  };
  protoOf(FastArrayList).s = function (element) {
    // Inline function 'korlibs.datastructure.FastArrayList.jsArray' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var array = this.y1u_1;
    var inductionVariable = 0;
    var last = array.length;
    if (inductionVariable < last)
      do {
        var index = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        // Inline function 'get' call
        // Inline function 'kotlin.js.asDynamic' call
        var tmp$ret$4 = array[index];
        if (equals(tmp$ret$4, element)) {
          array.splice(index, 1);
          this.g1_1 = this.g1_1 + 1 | 0;
          return true;
        }
      }
       while (inductionVariable < last);
    return false;
  };
  protoOf(FastArrayList).b1v = function (fromIndex, toIndex) {
    // Inline function 'korlibs.datastructure.FastArrayList.jsArray' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    this.y1u_1.splice(fromIndex, toIndex - fromIndex | 0);
    this.g1_1 = this.g1_1 + 1 | 0;
  };
  protoOf(FastArrayList).b3 = function () {
    // Inline function 'korlibs.datastructure.FastArrayList.jsArray' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    this.y1u_1.length = 0;
    this.g1_1 = this.g1_1 + 1 | 0;
  };
  protoOf(FastArrayList).v1 = function (element) {
    // Inline function 'korlibs.datastructure.FastArrayList.jsArray' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return this.y1u_1.indexOf(element);
  };
  protoOf(FastArrayList).toString = function () {
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'korlibs.datastructure.FastArrayList.jsArray' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$4 = this.y1u_1;
    return '[' + joinToString_1(tmp$ret$4, ', ') + ']';
  };
  protoOf(FastArrayList).c3 = function () {
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'korlibs.datastructure.FastArrayList.jsArray' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    // Inline function 'kotlin.js.asDynamic' call
    return this.y1u_1.concat();
  };
  protoOf(FastArrayList).toArray = function () {
    return this.c3();
  };
  function FastIntMap() {
    // Inline function 'kotlin.js.asDynamic' call
    return new Map();
  }
  function get_size(_this__u8e3s4) {
    // Inline function 'kotlin.js.asDynamic' call
    return _this__u8e3s4.size;
  }
  function FastStringMap() {
    // Inline function 'kotlin.js.asDynamic' call
    return new Map();
  }
  function FastIdentityMap() {
    // Inline function 'kotlin.js.asDynamic' call
    return new Map();
  }
  function clear(_this__u8e3s4) {
    // Inline function 'kotlin.js.asDynamic' call
    _this__u8e3s4.clear();
  }
  function get_size_0(_this__u8e3s4) {
    // Inline function 'kotlin.js.asDynamic' call
    return _this__u8e3s4.size;
  }
  function contains(_this__u8e3s4, key) {
    // Inline function 'kotlin.js.asDynamic' call
    return _this__u8e3s4.has(key);
  }
  function get(_this__u8e3s4, key) {
    // Inline function 'kotlin.js.asDynamic' call
    return _this__u8e3s4.get(key);
  }
  function set(_this__u8e3s4, key, value) {
    // Inline function 'kotlin.js.asDynamic' call
    _this__u8e3s4.set(key, value);
  }
  function get_size_1(_this__u8e3s4) {
    // Inline function 'kotlin.js.asDynamic' call
    return _this__u8e3s4.size;
  }
  function remove(_this__u8e3s4, key) {
    // Inline function 'kotlin.js.asDynamic' call
    _this__u8e3s4.delete(key);
  }
  function keys(_this__u8e3s4) {
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$2 = Array_from(_this__u8e3s4.keys());
    return toList_0(tmp$ret$2);
  }
  function keys_0(_this__u8e3s4) {
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$2 = Array_from(_this__u8e3s4.keys());
    return toList_0(tmp$ret$2);
  }
  function Array_from(value) {
    return Array.from(value);
  }
  var CONCURRENCY_COUNT;
  //region block: post-declaration
  protoOf(IntArray2).f1r = getAt;
  protoOf(IntArray2).e1r = asString;
  protoOf(FloatArray2).f1r = getAt;
  protoOf(FloatArray2).e1r = asString;
  protoOf(SparseChunkedStackedIntArray2).b21 = getLast;
  protoOf(StackedIntArray2).b21 = getLast;
  protoOf(FastArrayList).e1v = addAll_0;
  protoOf(FastArrayList).c1v = setAddAll;
  protoOf(FastArrayList).z1u = setAddAll$default;
  protoOf(FastArrayList).d1v = setAll;
  protoOf(FastArrayList).a1v = removeToSize;
  //endregion
  //region block: init
  Companion_instance = new Companion();
  Companion_instance_0 = new Companion_0();
  Companion_instance_1 = new Companion_1();
  Companion_instance_2 = new Companion_2();
  Companion_instance_3 = new Companion_3();
  Companion_instance_4 = new Companion_4();
  Companion_instance_5 = new Companion_5();
  Companion_instance_6 = new Companion_6();
  Companion_instance_7 = new Companion_7();
  Companion_instance_8 = new Companion_8();
  Companion_instance_9 = new Companion_9();
  Companion_instance_10 = new Companion_10();
  Companion_instance_12 = new Companion_12();
  Companion_instance_13 = new Companion_13();
  Math_instance = new Math_0();
  Memory_instance = new Memory();
  CONCURRENCY_COUNT = 1;
  //endregion
  //region block: exports
  _.$_$ = _.$_$ || {};
  _.$_$.a = DoubleArrayList_init_$Create$;
  _.$_$.b = FastArrayList_init_$Create$_0;
  _.$_$.c = FastArrayList_init_$Create$;
  _.$_$.d = FastArrayList_init_$Create$_1;
  _.$_$.e = IntArrayList_init_$Create$;
  _.$_$.f = IntIntMap_init_$Create$;
  _.$_$.g = IntMap_init_$Create$;
  _.$_$.h = Pool_init_$Create$;
  _.$_$.i = TGenDeque_init_$Create$;
  _.$_$.j = _BSearchResult___init__impl__em6zam;
  _.$_$.k = _BSearchResult___get_found__impl__om04iz;
  _.$_$.l = _BSearchResult___get_index__impl__b5kraz;
  _.$_$.m = _BSearchResult___get_nearIndex__impl__s8nq43;
  _.$_$.n = _TGenStack___init__impl__yynjgt;
  _.$_$.o = TGenStack__pop_impl_qisxa0;
  _.$_$.p = TGenStack__push_impl_9yh33t;
  _.$_$.q = Companion_instance_0;
  _.$_$.r = Companion_instance;
  _.$_$.s = Companion_instance_10;
  _.$_$.t = Companion_instance_8;
  _.$_$.u = Closeable;
  _.$_$.v = SyncPauseable;
  _.$_$.w = ConcurrentPool;
  _.$_$.x = DoubleArrayList;
  _.$_$.y = Mixin;
  _.$_$.z = PropertyThis;
  _.$_$.a1 = Property;
  _.$_$.b1 = FastArrayList;
  _.$_$.c1 = FastIdentityCacheMap;
  _.$_$.d1 = FastIdentityMap;
  _.$_$.e1 = FastIntMap;
  _.$_$.f1 = FastSmallSet;
  _.$_$.g1 = FastStringMap;
  _.$_$.h1 = FloatArray2;
  _.$_$.i1 = GenericListIterator;
  _.$_$.j1 = GenericSubList;
  _.$_$.k1 = IntArray2;
  _.$_$.l1 = IntArrayList;
  _.$_$.m1 = IntDeque;
  _.$_$.n1 = Pool;
  _.$_$.o1 = Ref_0;
  _.$_$.p1 = Ref;
  _.$_$.q1 = ReturnablePool;
  _.$_$.r1 = RingBuffer;
  _.$_$.s1 = SortOps;
  _.$_$.t1 = SparseChunkedStackedIntArray2;
  _.$_$.u1 = StackedIntArray2;
  _.$_$.v1 = TGenQueue;
  _.$_$.w1 = associateByInt;
  _.$_$.x1 = binarySearch;
  _.$_$.y1 = clear;
  _.$_$.z1 = contains;
  _.$_$.a2 = doubleArrayListOf;
  _.$_$.b2 = get_endX;
  _.$_$.c2 = get_endY;
  _.$_$.d2 = fastArrayListOf;
  _.$_$.e2 = flip;
  _.$_$.f2 = floatArrayListOf;
  _.$_$.g2 = genericSort;
  _.$_$.h2 = getAndRemove;
  _.$_$.i2 = getCyclicOrNull;
  _.$_$.j2 = getCyclic_0;
  _.$_$.k2 = getCyclic;
  _.$_$.l2 = getExtraTyped;
  _.$_$.m2 = getExtra;
  _.$_$.n2 = get;
  _.$_$.o2 = hasExtra;
  _.$_$.p2 = intArrayListOf;
  _.$_$.q2 = get_keys;
  _.$_$.r2 = linkedHashMapOf;
  _.$_$.s2 = reverse_0;
  _.$_$.t2 = rotateRight;
  _.$_$.u2 = setExtra;
  _.$_$.v2 = set;
  _.$_$.w2 = get_size_0;
  _.$_$.x2 = get_size;
  _.$_$.y2 = sort;
  _.$_$.z2 = swap;
  _.$_$.a3 = toCaseInsensitiveMap;
  _.$_$.b3 = toFastList_1;
  _.$_$.c3 = toFastList;
  _.$_$.d3 = toFastList_0;
  _.$_$.e3 = toIntArrayList;
  _.$_$.f3 = toIntMap;
  _.$_$.g3 = toLinkedMap;
  _.$_$.h3 = toRef;
  _.$_$.i3 = toStacked;
  //endregion
  return _;
}));
